import { ApiBase } from '@/service/api-base-grid'
import { CancelToken } from 'axios'

export class AiListVo {
  /** ai视频类别 */
  aiType?: number

  /** ai视频类别转义 */
  aiTypeStr?: string

  /** id */
  id?: string

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态转义 */
  problemStatusStr?: string

  /** 时间 */
  reportTime?: string

  /** 河流 */
  river?: string
}

export class AiPageReqDto {
  /** 视频告警类型 */
  aiType?: number

  /** 设备编号 */
  deviceCode?: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatus?: number
}

export class AiProblemListDto {
  /** 告警类型 */
  aiType?: number
  aiTypeStr?: string

  /** 关联区域 */
  areaName?: string

  /** 描述 */
  description?: string

  /** 设备编号 */
  deviceMn?: string

  /** 设备名称 */
  deviceName?: string

  /** 附件列表 */
  fileUrl?: string

  /** 告警id */
  id?: string

  /** 问题名称 */
  problemName?: string

  /** 问题状态 1:待处理 2:处理中 3:已办结 */
  problemStatus?: number
  problemStatusStr?: string

  /** 上报时间 */
  reportTime?: string
  reportTimeStr?: string
}

export class AiTotalDto {
  /** 当前天数量 */
  currentDay?: number

  /** 当前年数量 */
  currentYear?: number

  /** 明细 */
  items?: AiTypeTotalDto[]

  /** 当前站点 */
  name?: string
}

export class AiTotalReqDto {
  /** 摄像头编号 */
  deviceCode?: string
}

export class AiTypeTotalDto {
  /** 类型名称 */
  name?: string

  /** 数量 */
  quantity?: number

  /** 类型编码 */
  type?: number
}

export class AppPersonalStatisticsReqDto {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string
}

export class AreaHkgkDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string

  /** 单位 */
  unit?: string
}

export class AssessmentRankingsDto {
  /** 单位名称 */
  companyName?: string

  /** 城镇排水污染监管 */
  czpswrjgScore?: string

  /** 化粪池清掏和河道清漂河岸垃圾污染监管 */
  hfchdqpljwrjgScore?: string

  /** 河长制工作落实 */
  hzzgzlsScore?: string

  /** id */
  id?: number

  /** 流域名称 */
  ly?: string

  /** 考核月份 */
  month?: string

  /** 农贸市场污染监管 */
  nmscwrjgScore?: string

  /** 区级河长 */
  qjhz?: string

  /** sort */
  sort?: number

  /** 水质考核排名 */
  szkhRanking?: string

  /** 水质考核得分 */
  szkhhjScore?: string

  /** 水质类别 */
  szlb?: string

  /** 养殖业污染监管 */
  yzywrjgScore?: string

  /** 镇街名次 */
  zjRanking?: string

  /** 镇街考核总分 */
  zjkhTotalScore?: string

  /** 专项整治及监管落实 */
  zxzzjjgls?: string
}

export class AutoSiteFactorMonitorDataQuery {
  /** 监测时间 yyyy-MM-dd */
  begin!: string

  /** 因子编码 */
  factor!: string

  /** 数据周期, H-时均，D-日均 */
  frequency!: string

  /** 设备编码 */
  mn!: string
}

export class AutoSiteInfoReqDTO {
  /** 设备编码 */
  mn?: string
}

export class AutoSiteMonitorDataReqDTO {
  /** 时间 yyyy-MM-dd */
  date?: string

  /** 监测因子编码 */
  factor?: string

  /** 数据周期, H-时均，D-日均 */
  frequency?: string

  /** 设备编码 */
  mn?: string
}

export class AutoSiteStatisticsQuery {
  /** 时间格式（yyyy-MM-dd HH） */
  date?: string

  /** 流域名称 */
  ly?: string
}

export class AutoSiteSzskQuery {
  /** 时间格式（yyyy-MM-dd HH） */
  date?: string

  /** 流域名称 */
  ly?: string

  /** 站点类型 */
  type?: string
}

export class AxjcssExDto {
  /** 项 */
  items?: AxjcssExItemDto[]

  /** 总数 */
  totalQuantity?: number
}

export class AxjcssExItemDto {
  /** 数量 */
  quantity?: number

  /** 占比 */
  rate?: number

  /** 类型 */
  type?: string
}

export class AxslgcExDto {
  /** 项 */
  items?: AxslgcExItemDto[]

  /** 总数 */
  totalQuantity?: number
}

export class AxslgcExItemDto {
  /** 数量 */
  quantity?: number

  /** 占比 */
  rate?: number

  /** 类型 */
  type?: string
}

export class BasicStatisticsQuery {
  /** 流域名称 */
  ly?: string

  /** 河流 */
  river?: string
}

export class CallInfoDto {
  /** 房间号 */
  channelNo?: string

  /** 状态 1表示请求通话   2表示通话中  3表示挂断 */
  status?: number

  /** 用户id */
  userId?: number
}

export class CameraStreamDto {
  /** 接入方式 */
  accessMode?: number

  /** 摄像头监测设备id */
  deviceId?: string

  /** 设备名称 */
  deviceName?: string

  /** 是否是海康威视视频 true 是  false 否 */
  hkVideo?: boolean
  id?: string

  /** 视频流 */
  videoStream?: string
}

export class CommandDto {
  action?: number
  cameraIndexCode?: string
  command?: string
  presetIndex?: number
  speed?: number
}

export class CommonPointVo {
  /** 类别用于区分类型 gk,sk,qk,一体化yth,物联站wlz,水库sk 等 */
  category?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  name?: string

  /** 是否在线，在线true , 不在线false */
  online?: boolean

  /** 是否超标   达标db , 超标cb, 无数据wsj */
  standard?: string

  /** 视频流地址 */
  videoStream?: string

  /** 水质等级评价 */
  waterLevel?: number

  /** 纬度 */
  wd?: string
}

export class CommonStatisticsDto {
  /** 名称 */
  name?: string

  /** 数量 */
  value?: number
}

export class CyqyEntity {
  /** 登记机构 */
  djjg?: string

  /** 法定代表人 */
  fddbr?: string

  /** 负责人 */
  fzr?: string

  /** 负责人_联系电话 */
  fzrLxfs?: string

  /** 管理人 */
  glr?: string

  /** 管理人_联系方式 */
  glrLxfs?: string

  /** 行业类别 */
  hylb?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 经营范围 */
  jyfw?: string

  /** 经营类别 */
  jylb?: string

  /** 企业类型 */
  qylx?: string

  /** 企业名称 */
  qymc?: string

  /** 所在地址 */
  szdz?: string

  /** 纬度 */
  wd?: string

  /** 行政区划代码 */
  xzqhdm?: string

  /** 行政区划名称 */
  xzqhmc?: string

  /** 状态 */
  zt?: string
}

export class DfBasicDTO {
  /** 保护范围划界 */
  bhfwhj?: string

  /** 达标长度(m) */
  dbcd?: string

  /** 堤防编码 */
  dfbm?: string

  /** 堤防长度 */
  dfcd?: string

  /** 堤防级别 */
  dfjb?: string

  /** 堤防跨界情况 */
  dfkjqk?: string

  /** 堤防类型 */
  dflx?: string

  /** 堤防名称 */
  dfmc?: string

  /** 堤防型式 */
  dfxs?: string

  /** 工程归口管理部门 */
  gcgkglbm?: string

  /** 工程任务 */
  gcrw?: string

  /** geometry */
  geometry?: string

  /** 管理单位 */
  gldw?: string

  /** 管理单位权属 */
  gldwqs?: string

  /** 管理单位性质 */
  gldwxz?: string

  /** 管理单位责任人 */
  gldwzrr?: string

  /** 管理单位责任人电话 */
  gldwzrrdh?: string

  /** 管理单位责任人职务 */
  gldwzrrzw?: string

  /** 管理范围划界 */
  glfwhj?: string

  /** 管理范围确权 */
  glfwqq?: string

  /** 河流岸别 */
  hlab?: string

  /** 河流名称 */
  hlmc?: string

  /** 湖泊名称 */
  hpmc?: string

  /** 海洋名称 */
  hymc?: string

  /** id */
  id?: string

  /** 监控类型 */
  jklx?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 起点所在村 */
  qdszCun?: string

  /** 起点所在省 */
  qdszSheng?: string

  /** 起点所在市 */
  qdszShi?: string

  /** 起点所在县 */
  qdszXian?: string

  /** 起点所在乡(镇) */
  qdszZhen?: string

  /** 起点所在地 */
  qdszd?: string

  /** 起点桩号 */
  qdzh?: string

  /** 省级单位 */
  sjdw?: string

  /** 上级主管单位 */
  sjzgdw?: string

  /** 所属水系 */
  sxmc?: string

  /** 终点所在省 */
  zdszSheng?: string

  /** 终点所在市 */
  zdszShi?: string

  /** 终点所在村 */
  zdszUn?: string

  /** 终点所在县(区) */
  zdszXian?: string

  /** 终点所在乡(镇) */
  zdszZhen?: string

  /** 终点所在地 */
  zdszd?: string

  /** 终点桩号 */
  zdzh?: string

  /** 政府防汛责任人 */
  zffxzrr?: string

  /** 政府防汛责任人电话 */
  zffxzrrdh?: string

  /** 政府防汛责任人职务 */
  zffxzrrzw?: string

  /** 主管单位性质 */
  zgdwxz?: string

  /** 主管单位责任人 */
  zgdwzrr?: string

  /** 主管单位责任人电话 */
  zgdwzrrdh?: string

  /** 主管单位责任人职务 */
  zgdwzrrzw?: string

  /** 最近达标加固完成时间 */
  zjdbjgwcsj?: string

  /** 最近加固达标完工状态 */
  zjjgdbwgzt?: string
}

export class DfInfoOverviewResDto {
  /** 左岸数量 */
  leftTotal?: number

  /** 右岸数量 */
  rightTotal?: number

  /** 总数量 */
  total?: number
}

export class DkStatisticsDTO {
  /** 打卡率 */
  dkRate?: string

  /** 实际打卡数 */
  sjdkCount?: number

  /** 应打卡数 */
  ydkCount?: number

  /** 重点排口数量 */
  zdpkCount?: number
}

export class DmYzDatumLine {
  /** 基准线 */
  datumLine?: number

  /** 单位 */
  unit?: string
}

export class DmYzDatumLineQuery {
  /** 标准水质类别 */
  bzszlb?: number

  /** 因子 */
  code?: string

  /** 水体类型 */
  stlx?: string
}

export class DotMapDto {
  /** 类别 */
  category?: string

  /** 分类名称 */
  categoryStr?: string

  /** 管控级别 */
  gkjb?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  name?: string

  /** 是否在线，在线true , 不在线false */
  online?: boolean

  /** 排口列表 */
  outPuts?: WsclcInfoItemsDto[]

  /** 水质等级 */
  pollutionLevel?: string

  /** 排污口-整治状态: underway / complete -> 整治中 / 已完成 */
  pwkStats?: string

  /** 排污口-排污口一级分类: gy / czwsclc / ny / other -> 工业 / 城镇污水处理厂 / 农业 / 其它 */
  pwkYjfl?: string

  /** 是否超标   达标db , 超标cb, 无数据wsj */
  standard?: string

  /** 纬度 */
  wd?: string
}

export class DropBoxDto {
  /** 名称 */
  name?: string

  /** 值 */
  value?: string
}

export class DropBoxIntegerDto {
  /** 名称 */
  name?: string

  /** 值 */
  value?: number
}

export class EditLxDto {
  /** 模板分项id */
  itemId?: number

  /** 路线json 坐标 */
  lx?: string
}

export class EventDetailDto {
  /** 问题所在地址 */
  address?: string

  /** 上报人 */
  createUser?: string

  /** 问题描述 */
  description?: string

  /** 紧急程度 */
  emergencyDegreeStr?: string

  /** 附件列表 */
  fileList?: ZkProblemFileDto[]

  /** id列表 */
  idList?: string[]

  /** 问题所在纬度 */
  latitude?: number

  /** 问题所在经度 */
  longitude?: number

  /** 合并id */
  mergeId?: string

  /** 监测数据 */
  monitorDataDto?: MonitorDataSubjectDto

  /** 当前登录人可以进行的操作列表：['zj:转交','bl:办理','bj:办结','th:退回'] */
  operations?: string[]

  /** 当前任务id */
  problemId?: string

  /** 任务名称 */
  problemName?: string

  /** 问题来源 1:告警推送  2:问题上报  3:任务发布 */
  problemSource?: number

  /** 问题来源 */
  problemSourceStr?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态 */
  problemStatusStr?: string

  /** 问题二级分类 */
  problemSubtype?: number

  /** 问题二级分类转义文字 */
  problemSubtypeStr?: string

  /** 问题类型 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报时间Str */
  reportTimeStr?: string

  /** 问题所在流域河段 */
  river?: string

  /** 处理流程 */
  workflowRecordTree?: WorkflowRecordTreeDto[]
}

export class EventListDto {
  /** 问题地址 */
  address?: string

  /** 指派时间 */
  assignTime?: string

  /** 上报人 */
  createUser?: string

  /** 上报人（id） */
  createUserId?: number

  /** 当前处理人(多个逗号隔开) */
  currentHandleUser?: string

  /** 当前处理人集合 */
  currentHandleUserIds?: number[]

  /** 处理期限（单位：天） */
  deadLine?: number

  /** 描述 */
  description?: string

  /** 紧急程度  1:一般  2:重要  3:紧急 */
  emergencyDegree?: number

  /** id */
  id?: string

  /** 合并id */
  mergeId?: string

  /** 职务 */
  position?: string

  /** 问题名称 */
  problemName?: string

  /** 问题来源 */
  problemSource?: number

  /** 问题来源 */
  problemSourceStr?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态 */
  problemStatusStr?: string

  /** 问题类型 */
  problemType?: number

  /** 问题类型 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报时间 */
  reportTimeStr?: string

  /** 河流河段 */
  river?: string
}

export class FactorSubjectDto {
  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 展示排序 */
  sort?: number

  /** 标准值 */
  standValues?: number[]

  /** 单位 */
  unit?: string
}

export class FileDto {
  /** 文件后缀名 */
  fileSuffix?: string

  /** 文件类型  图片:image，视频:video，音频:audio,文档:doc,其他：other */
  fileType?: string
  id?: string

  /** 模块id（问题id/流程id） */
  modelId?: string

  /** 所属模块（1.问题附件，2流程附件） */
  modelType?: number

  /** 文件名称 */
  name?: string

  /** 文件路径 */
  path?: string

  /** 访问url */
  url?: string
}

export class GnfqExDto {
  /** 统计 */
  items?: GnfqExItemDto[]

  /** 分区级别 */
  level?: string

  /** 总数 */
  totalQuantity?: number
}

export class GnfqExItemDto {
  /** 类别 */
  category?: string

  /** 级别 */
  level?: string

  /** 数量 */
  quantity?: number

  /** 占比 */
  rate?: number
}

export class GnfqQuery {
  /** 功能分区级别 1:一级 2:二级 */
  level?: number

  /** 流域名称 */
  ly?: string
}

export class GridInfo {
  /** 网格id */
  id?: number

  /** 重点监管点 */
  itemPrintDtos?: MbItemPrintDto[]

  /** 流域 */
  ly?: string

  /** 起点名称 */
  qdmc?: string

  /** 所在镇街 */
  szzj?: string

  /** 网格员电话 */
  tel?: string

  /** 网格员userId */
  wgUserId?: number

  /** 网格员名称 */
  wgUserName?: string

  /** 巡河记录 */
  xhRecord?: SceenWgyXhRecordDto[]

  /** 终点名称 */
  zdmc?: string
}

export class GridWgyRecordQuery {
  /** 开始时间 */
  beginTime?: string

  /** 结束时间 */
  endTime?: string

  /** 用户id */
  userId?: number
}

export class GridXcRecordBaseInfoDto {
  /** 所在河流 */
  hl?: string

  /** 巡查记录id */
  id?: number

  /** 重点监管点 */
  prints?: string

  /** 起点名称 */
  qdmc?: string

  /** 所在镇街名称 */
  szzjmc?: string

  /** 网格员id */
  userId?: number

  /** 终点名称 */
  zdmc?: string

  /** 网格员名称 */
  zrrUserName?: string

  /** 联系电话 */
  zrrUserTel?: string
}

export class GridXcRecordDto {
  /** 巡查记录 */
  records?: GridXcRecordReportDto[]

  /** 实巡数 */
  sxs?: number

  /** 应巡数 */
  yxs?: number
}

export class GridXcRecordReportDto {
  /** 开始时间 */
  beginTime?: string

  /** 日期 */
  date?: string

  /** 打卡次数 */
  dkCount?: number

  /** 结束时间 */
  endTime?: string

  /** id */
  id?: number

  /** 上报问题数 */
  reportProblemCount?: number

  /** 巡河里程（km） */
  xhlc?: number

  /** 总时长（h） */
  zsc?: number
}

export class GyqyInfoDto {
  /** 行业类别 */
  hymc?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 企业规模 */
  qygm?: string

  /** 所属流域 */
  ssly?: string

  /** 所在乡镇 */
  szsz?: string

  /** 纬度 */
  wd?: string

  /** 企业名称 */
  wrymc?: string
}

export class GyqyInfoPopDto {
  /** 行业名称 */
  hymc?: string

  /** ID */
  id?: string

  /** 经度 */
  jd?: number

  /** 联系人电话 */
  lxrdh?: string

  /** 联系人姓名 */
  lxrxm?: string

  /** 排污许可证代码 */
  pwxkzdm?: string

  /** 企业规模 */
  qygm?: string

  /** 受纳水体 */
  snst?: string

  /** 统一社会信用代码 */
  tyshxydm?: string

  /** 纬度 */
  wd?: number

  /** 污染源名称 */
  wrymc?: string

  /** 详细地址 */
  xxd?: string

  /** 组织机构代码 */
  zzkgdm?: string
}

export class GywryDto {
  /** 工业企业数据集合 */
  gyqy?: GyqyInfoDto[]

  /** 统计数 */
  stats?: StatisticsCountDto[]
}

export class GyyqEntity {
  cym?: string

  /** 地址 村 */
  dzCun?: string

  /** 地址 省 */
  dzSheng?: string

  /** 地址 市 */
  dzShi?: string

  /** 地址 县 */
  dzXian?: string

  /** 地址 乡 */
  dzXiang?: string

  /** 负责人 */
  fzr?: string

  /** 负责人电话 */
  fzrdh?: string

  /** 规划环评批准号 */
  ghhpbzh?: string

  /** 管理单位 */
  gldw?: string

  /** 管理级别 */
  gljb?: string
  gndw?: string
  id?: string

  /** 基本介绍 */
  jbjs?: string

  /** 经度 */
  jd?: string

  /** 建设状态 */
  jszt?: string

  /** 集中式污水处理设施数 */
  jzwsclsss?: number

  /** 联系人 */
  lxr?: string

  /** 联系人电话 */
  lxrdh?: string

  /** 排污口情况 距三江距离 */
  pwkqkJsjjl?: string

  /** 排污口数量 */
  pwkqkSl?: string

  /** 排污去向 */
  pwqx?: string

  /** 入园企业数量 */
  ryqyjs?: number

  /** 是否开展规划环评 */
  sfKzghhp?: string

  /** 是否商用工业园区 */
  sfSygyyq?: string
  sfsc?: string
  sjlx?: string

  /** 受纳水体 */
  snst?: string
  snstfhl?: string
  snstid?: string
  sssx?: string
  sssxid?: string

  /** 所在地址 */
  szdz?: string

  /** 纬度 */
  wd?: string
  xzqhdm?: string
  xzqhmc?: string
  yqdm?: string

  /** 园区级别 */
  yqjb?: string
  yqmc?: string

  /** 园区面积 */
  yqmj?: string

  /** 园区实际处理 */
  yqsjcll?: number

  /** 园区设计处理能力 */
  yqsjclnl?: number

  /** 已完成在线监控装置安装并联网数 */
  ywczxjkzzazblws?: string

  /** 运行状态 */
  yxzt?: string

  /** 主导行业 */
  zdhy?: string

  /** 组团名称 */
  ztmc?: string

  /** 在线监测的主要因子 */
  zxjczyyz?: string

  /** 执行排放标准 */
  zxpfbz?: string
}

export class GyyqInfoCountStatisticsVo {
  /** 集中污水处理设施数量 */
  jzwsclssCount?: number

  /** 入园企业数量 */
  ryqyCount?: number

  /** 园区及组团数 */
  totalCount?: number
}

export class GyyqInventoryVo {
  /** 所属区域 */
  ssqy?: string

  /** 园区名称 */
  yqmc?: string

  /** 组团名称 */
  ztmc?: string
}

export class GzhProblemDTO {
  createUserId?: number
  createUserStr?: string
  id?: string
  position?: string
  problemName?: string
  problemStatus?: number
  problemStatusStr?: string
  reportTime?: string
}

export class HdspListDto {
  accessMode?: number
  deviceCode?: string

  /** 配合类型使用获取流的摄像头id */
  deviceId?: string

  /** 设备名称 */
  deviceName?: string
  hkws?: boolean

  /** 河流 */
  hl?: string
  id?: string

  /** 是否在线 */
  isOnlined?: boolean

  /** 经度 */
  jd?: string

  /** 视频流 */
  videoStream?: string

  /** 纬度 */
  wd?: string
}

export class HdspStatisticsDTO {
  /** 已处理问题数 */
  problemOverCount?: number

  /** 待处理问题数 */
  problemPendingCount?: number

  /** 视频报警数量 */
  problemTotalCount?: number

  /** 监控点位 */
  videoCount?: number
}

export class HdspTreeDTO {
  /** 子类 */
  children?: VideoSimpleDTO[]

  /** 名称 */
  name?: string
}

export class HdtjDto {
  /** 村社 */
  cs?: number

  /** 河流总数 */
  hlzs?: number

  /** 联系单位 */
  lxdw?: number

  /** 乡镇 */
  xz?: number

  /** 重点风险源 */
  zdfxy?: number

  /** 镇街河长办 */
  zjhzb?: number
}

export class HjSubjectDto {
  /** 处理中问题数 */
  clzwtQuantity?: number

  /** 完成率 */
  complateRate?: number

  /** 上报问题总数 */
  sbwtQuantity?: number

  /** 实巡次数 */
  sxQuantity?: number

  /** 未处理问题数 */
  wclwtQuantity?: number

  /** 网格员数量 */
  wgyQuantity?: number

  /** 未完成巡河人数 */
  wwcxhrsQuantity?: number

  /** 巡河里程 */
  xhlc?: number

  /** 巡河时长 */
  xhsc?: number

  /** 已处理问题数 */
  yclwtQuantity?: number

  /** 应巡次数 */
  yxQuantity?: number

  /** 重点监管点数量 */
  zdjgdQuantity?: number

  /** 责任河段数量 */
  zrhdQuantity?: number
}

export class HkListQuery {
  /** 搜索关键词 */
  keyword?: string

  /** 流域名称 */
  ly?: string
  skLevel?: string
}

export class HlApiDto {
  /** 河流编码,忽略该字段 */
  hlbm?: string

  /** 河流名称 */
  hlmc?: string
}

export class HomeDropSelect {
  children?: HomeDropSelect[]
  name?: string
  value?: string
}

export class HzLevelNameQuery {
  /** 河长级别  */
  levelName?: string
}

export class HzListVO {
  /** 河长名称 */
  hzmc?: string

  /** 联系河段 */
  lxhd?: string

  /** 职务 */
  zw?: string
}

export class HzPopInfoQuery {
  /** 查询条件，河长级别 */
  level?: string
  ly?: string

  /** 镇街 */
  zj?: string
}

export class HzddProblemListDto {
  /** 分类 */
  category?: string

  /** 自动告警编码 */
  deviceMn?: string

  /** 污染因子 */
  factorCode?: string

  /** id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 问题名称 */
  problemName?: string

  /** 处理状态 */
  problemStatus?: number

  /** 处理状态注释 */
  problemStatusStr?: string

  /** 问题类别二级分类 */
  problemSubtype?: number

  /** 问题类别二级分类名称 */
  problemSubtypeStr?: string

  /** 问题类别 */
  problemType?: number

  /** 问题类别名称 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string
}

export class HzgzXctjDto {
  /** 月份 */
  month?: string[]

  /** 实巡次数 */
  sxCountList?: number[]

  /** 应巡次数 */
  yxCountList?: number[]
}

export class HztjDto {
  /** 镇街/流域名称 */
  name?: string

  /** 统计数量 */
  quantity?: number
}

export class HzxhPeriodQuery {
  ly?: string

  /** 频次 w周 m月 */
  period?: string
}

export class HzxhProblemListQuery {
  /** 重要程度 */
  emergencyDegree?: string

  /** 流域 */
  ly?: string

  /** 频次, d, w, m */
  period?: string

  /** 问题类型二级分类下拉 */
  problemSubtype?: string

  /** 问题类型 */
  problemType?: string
}

export class HzxxMbItemPrint {
  createTime?: string
  id?: number
  itemId?: number
  jcdmc?: string
  jd?: string
  lb?: string
  period?: string
  updateTime?: string
  wd?: string
}

export class IdDto {
  /** 序号id */
  id?: number
}

export class IdIntegerQuery {
  id?: number
}

export class IdStringQuery {
  /** id */
  id?: string
}

export class IndexDto {
  /** 音频列表 */
  audios?: Item[]

  /** 其他列表 */
  files?: Item[]

  /** 图片列表 */
  images?: Item[]

  /** 视频列表 */
  videos?: Item[]
}

export class IndexMyTaskListDto {
  /** 限制期限 */
  deadline?: string

  /** 到期时间 */
  expirationTime?: string

  /** 任务id */
  id?: any

  /** 临近，已超期 */
  overDate?: string

  /** 任务描述 */
  remark?: string

  /** 数据来源：1事件任务，2巡河任务,3水库问题,4水库巡查任务 */
  source?: number

  /** 任务类别 */
  sponsorType?: string

  /** 开始时间 */
  startTime?: string

  /** 任务状态 */
  status?: string

  /** 任务名称 */
  taskName?: string
}

export class Item {
  /** 文件后缀 */
  fileSuffix?: string

  /** 文件名称 */
  name?: string

  /** 服务器存放地址 */
  path?: string

  /** 上传时间 */
  uploadTime?: string

  /** 文件路径 */
  url?: string
}

export class JhDto {
  /** 创建时间 */
  createTime?: string

  /** 计划id */
  id?: number

  /** 计划类别id */
  jhlbId!: number

  /** 计划名称 */
  jhmc!: string

  /** 计划描述 */
  jhms!: string

  /** 紧急程度 */
  jjcd!: string

  /** 结束时间 */
  jssj!: string

  /** 开始时间 */
  kssj!: string

  /** 巡查范围 */
  xcfw!: string
}

export class JhFjDto {
  /** 创建时间 */
  createTime?: string

  /** 附件名称 */
  fjMc?: string

  /** 附件路径 */
  fjPath?: string

  /** 计划id */
  jhId?: number
}

export class JhPageDto {
  /** 发布状态 */
  fbzt?: string

  /** 河长级别 */
  hzjb?: string

  /** 计划id */
  id?: number

  /** 计划类别名称 */
  jhlbName?: string

  /** 计划名称 */
  jhmc?: string

  /** 计划状态 */
  jhzt?: string

  /** 紧急程度 */
  jjcd?: string

  /** 结束时间 */
  jssj?: string

  /** 开始时间 */
  kssj?: string

  /** 巡查频次 */
  xcpc?: string
}

export class JhPzxxDto {
  /** 创建时间 */
  createTime?: string

  /** 次数 */
  cs!: number

  /** 操作：>= ; <= ; = ; > ; < */
  cz!: string

  /** 河流名称 */
  hl!: string

  /** 河长级别 */
  hzjb!: string

  /** 计划id */
  jhId?: number

  /** 流域名称 */
  ly!: string

  /** 频次 */
  pc!: string

  /** 模板 */
  zrtx!: string
}

export class JhSaveDto {
  /** copy计划的id */
  copyId?: number

  /** 计划附件 */
  fjs?: JhFjDto[]

  /** 计划 */
  jhDto!: JhDto

  /** 计划配置信息 */
  pzxxs!: JhPzxxDto[]
}

export class JhStatusChangeDto {
  /** 计划id */
  id?: number

  /** 计划状态:1启用/0停用 */
  jhzt?: number
}

export class JsonResult {
  code?: number
  data?: any
  msg?: string
}

export class KeyValue {
  /** key */
  key?: string

  /** value */
  value?: any
}

export class LcStatisticsDTO {
  /** 实巡里程 */
  sxLc?: number

  /** 巡河里程率 */
  xhRate?: string

  /** 应巡里程 */
  yxLc?: number
}

export class LyAndKeywordsQuery {
  keyword?: string

  /** 流域名称 */
  ly?: string
}

export class LyAndMonthQuery {
  /** 流域名称 */
  ly?: string

  /** 考核月份（yyyy-MM） */
  month?: string
}

export class LyAndPkLxQuery {
  /** 流域名称 */
  ly?: string
  pklx?: string
}

export class LyAndSzyTypeQuery {
  /** 流域名称 */
  ly?: string

  /** 查询数据类型 雨量站，水位站，水文站 */
  type?: string
}

export class LyAndTypeAndMonthQuery {
  /** 流域名称 */
  ly?: string

  /** 数据时间 格式yyyy-MM-dd */
  time?: string

  /** 类型  水文站，水位站，雨量站 */
  type?: string
}

export class LyAndYearQuery {
  /** 流域名称 */
  ly?: string

  /**  年份 yyyy */
  year?: string
}

export class LyAndZjQuery {
  /** 流域名称 */
  ly?: string

  /** 镇街名称 */
  zj?: string
}

export class LyOrZjListDTO {
  /** 网格员数量 */
  count?: number

  /** 流域名称、镇街名称 */
  name?: string

  /** 专职或兼职 */
  zzOrjz?: string
}

export class LyQuery {
  /** 流域名称 */
  ly?: string
}

export class LyTotalDetailDto {
  /** 部门河长数量 */
  bmhzsl?: number

  /** 村级河长数量 */
  cjhzsl?: number

  /** 河段数量 */
  hdsl?: number

  /** 河道数量 */
  hlsl?: number

  /** 河长总数 */
  hzzs?: number

  /** 兼职网格员数量 */
  jzWgysl?: number

  /** 流域 */
  ly?: string

  /** 流域区责任人数量 */
  lyzrrsl?: number

  /** 区常务副总河长 */
  qcwfzhzsl?: number

  /** 区副总河长 */
  qfzhzsl?: number

  /** 区级河长数量 */
  qjhzsl?: number

  /** 区总和长 */
  qzhzsl?: number

  /** 网格员数量 */
  wgysl?: number

  /** 镇街河长数量 */
  zjhzsl?: number

  /** 专职网格员数量 */
  zzWgysl?: number
}

export class LygkCountStatisticsVo {
  /** 河流长度 */
  hlcd?: number

  /** 河流总数 */
  hlzs?: number

  /** 落差 */
  lc?: number

  /** 流域总面积KM^2 */
  lyzmj?: number

  /** 区级河流数量 */
  qjhlsl?: number

  /** 支流数量 */
  zlsl?: number
}

export class LyhdDto {
  /** 子集 */
  childrens?: LyhdDto[]

  /** 河流 */
  hl?: string

  /** 流域 */
  ly?: string

  /** 名称 */
  name?: string
}

export class MBItemPrintDto {
  /** 监测点名称 */
  jcdmc?: string

  /** 经度 */
  jd?: string

  /** 修改前经度 */
  lastJd?: string

  /** 修改前纬度 */
  lastWd?: string

  /** 纬度 */
  wd?: string
}

export class MapPointReqDTO {
  /** 流域 */
  ly?: string

  /** 河流 */
  river?: string
}

export class MbDto {
  /** 模板id */
  id?: string

  /** 模板名称 */
  mbmc?: string
}

export class MbItemBmjDto {
  /** 部门河长id */
  bmjUserId!: number

  /** 部门河长名称 */
  bmjUserName?: string

  /** 创建时间 */
  createTime?: string

  /** 模板分项id */
  itemId?: number

  /** 联系方式 */
  tel?: string
}

export class MbItemCjDto {
  /** 村级河长id */
  cjUserId!: number

  /** 村级河长名称 */
  cjUserName?: string

  /** 创建时间 */
  createTime?: string

  /** 分项id */
  itemId?: number

  /** 联系方式 */
  tel?: string
}

export class MbItemDto {
  /** 村居社 */
  cjs!: string

  /** 河流名称 */
  hl!: string

  /** 模板分项id */
  id?: number

  /** 流域名称 */
  ly!: string

  /** 模板id */
  mbId!: string

  /** 起点编号 */
  qdbh!: string

  /** 起点经度 */
  qdjd!: string

  /** 起点名称 */
  qdmc!: string

  /** 起点纬度 */
  qdwd!: string

  /** 备注 */
  remark?: string

  /** 所在镇街id */
  szzj!: string

  /** 所在镇街名称 */
  szzjmc!: string

  /** 网格编号 */
  wgbh!: string

  /** 巡查范围 */
  xcfw!: string

  /** 终点编号 */
  zdbh!: string

  /** 终点经度 */
  zdjd!: string

  /** 终点名称 */
  zdmc!: string

  /** 终点纬度 */
  zdwd!: string
}

export class MbItemLocationDto {
  /** 创建时间 */
  createTime?: string

  /** 模板分项id */
  itemId?: number

  /** 途径点编号 */
  tjdBh!: string

  /** 途径点经度 */
  tjdJd!: string

  /** 途径点名称 */
  tjdMc!: string

  /** 途径点纬度 */
  tjdWd!: string
}

export class MbItemPageDto {
  /** 村级河长联系方式 */
  cjhzTels?: string[]

  /** 村级河长名称 */
  cjhzs?: string[]

  /** 村局社 */
  cjs?: string

  /** 河流 */
  hl?: string

  /** 模板分项id */
  id?: number

  /** 模板id */
  mbId?: string

  /** 起点名称 */
  qdmc?: string

  /** 网格编号 */
  wgbh?: string

  /** 网格员联系方式 */
  wgyTels?: string[]

  /** 网格员名称 */
  wgys?: string[]

  /** 巡查范围 */
  xcfw?: string

  /** 重点监管点 */
  zdjgd?: string

  /** 终点名称 */
  zdmc?: string

  /** 镇街河长联系方式 */
  zjhzTels?: string[]

  /** 镇街河长名称 */
  zjhzs?: string[]
}

export class MbItemPrintDto {
  /** 创建时间 */
  createTime?: string

  /** 模板分项id */
  itemId?: number

  /** 检查点名称 */
  jcdmc?: string

  /** 经度 */
  jd?: string

  /** 类别 */
  lb?: string

  /** 打卡频次 r/z   一日一次/一周一次 */
  period?: string

  /** 纬度 */
  wd?: string
}

export class MbItemQjDto {
  /** 创建时间 */
  createTime?: string

  /** 模板分项id */
  itemId?: number

  /** 区级河长id */
  qjUserId!: number

  /** 区级河长名称 */
  qjUserName?: string

  /** 联系方式 */
  tel?: string
}

export class MbItemSaveDto {
  /** 部门河长 */
  itemBmjDtos?: MbItemBmjDto[]

  /** 村级河长 */
  itemCjDtos?: MbItemCjDto[]

  /** 模板分项 */
  itemDto?: MbItemDto

  /** 途径点 */
  itemLocationDtos?: MbItemLocationDto[]

  /** 重点监管点 */
  itemPrintDtos?: MbItemPrintDto[]

  /** 区级河长 */
  itemQjDtos?: MbItemQjDto[]

  /** 网格员 */
  itemWgyDtos?: MbItemWgyDto[]

  /** 镇街河长 */
  itemZjDtos?: MbItemZjDto[]
}

export class MbItemWgyDto {
  /** 创建时间 */
  createTime?: string

  /** 模板分项id */
  itemId?: number

  /** 联系方式 */
  tel?: string

  /** 网格员id */
  wgUserId!: number

  /** 网格员名称 */
  wgUserName?: string
}

export class MbItemZjDto {
  /** 创建时间 */
  createTime?: string

  /** 模板分项id */
  itemId?: number

  /** 联系方式 */
  tel?: string

  /** 镇街河长id */
  zjUserId!: number

  /** 镇街河长名称 */
  zjUserName?: string
}

export class MonitorDataListDto {
  /** 监测时间 */
  dataTime?: string

  /** 因子 */
  factor?: string

  /** 监测值 */
  value?: number
}

export class MonitorDataSubjectDto {
  /** 监测数据列表 */
  dataList?: MonitorDataListDto[]

  /** 设备mn */
  deviceMn?: string

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 标准值 */
  standValues?: number[]

  /** 因子单位 */
  unit?: string
}

export class MonitorSubjectDto {
  /** 超标标识（Y/N） */
  ex?: string

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 监测值 */
  monitorValue?: number

  /** 展示排序 */
  sort?: number
}

export class MonitorVideoDto {
  /** 展开对象 */
  childs?: MonitorVideoDto[]

  /** id */
  id?: string

  /** 标题名称 */
  title?: string

  /** 监控视频列表 */
  videos?: MonitorVideoInfoDto[]
}

export class MonitorVideoExReqDto {
  /** 河流 */
  hl?: string

  /** 流域 */
  ly?: string

  /** 名称 */
  name?: string
}

export class MonitorVideoInfoDto {
  /** 接入方式 */
  accessMode?: number

  /** 视频监测设备编码/设备序列号 */
  deviceCode?: string

  /** 视频监测设备编码/设备序列号 */
  deviceId?: string

  /** 设备名 */
  deviceName?: string

  /** 视频监测设备编码/设备序列号 */
  deviceSerial?: string

  /** 是否是海康威视视频 true 是  false 否 */
  hkVideo?: boolean

  /** 所在河流 */
  hl?: string

  /** id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 是否在线 */
  onlined?: number

  /** 排序用 */
  sort?: number

  /** 站点名称 */
  stationName?: string

  /** 视频流地址 */
  videoStream?: string

  /** 视频类型 */
  videoType?: number
}

/**
 * 视频智能分析终端表
 */
export class MonitorVideoTerminalDto {
  /** 视频监控区域id */
  areaId?: number

  /** 视频监控区域名字 */
  areaName?: string

  /** 创建时间 */
  createTime?: string

  /** 删除标识:0-正常;1-删除 */
  deleted?: number

  /** 描述/备注 */
  description?: string

  /** 终端编号 */
  deviceIndexCode?: string
  id?: number

  /** ip地址 */
  ipAddr?: string

  /** 终端名称 */
  name?: string

  /** 在线状态：0-不在线;1-在线 */
  status?: number

  /** 类型：0-AI视频分析终端 */
  type?: number

  /** 更新时间 */
  updateTime?: string
}

/**
 * 视频智能分析终端列表查询DTO
 */
export class MonitorVideoTerminalListDTO {
  /** 视频监控区域id */
  areaId?: number

  /** 终端名称 */
  name?: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class MonitorVideoTerminalReqDto {
  /** 视频监控区域id */
  areaId?: number

  /** 视频监控区域名字 */
  areaName?: string

  /** 描述/备注 */
  description?: string

  /** 终端编号 */
  deviceIndexCode?: string
  id?: number

  /** ip地址 */
  ipAddr?: string

  /** 终端名称 */
  name?: string

  /** 在线状态：0-不在线;1-在线 */
  status?: number

  /** 类型：0-AI视频分析终端 */
  type?: number
}

export class MontiroObjDto {
  /** 所在河流 */
  hl?: string

  /** 所在流域 */
  ly?: string
}

export class MyBacklogReqDto {
  /** 用戶id(非必传) */
  loginUserId?: number

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class MyEventListDto {
  /** 问题地址 */
  address?: string

  /** 事件描述 */
  description?: string

  /** 事件名称 */
  eventName?: string

  /** 事件状态 */
  eventStatus?: string

  /** 事件类型 */
  eventType?: string

  /** 河流河段 */
  hlhd?: string

  /** 事件id */
  id?: string

  /** 紧急程度（1-4 : 一般、重要、非常重要、紧急） */
  level?: string

  /** 上报人 */
  reportProple?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报人职务 */
  zw?: string
}

export class MyEventResponseDto {
  /** 我的事件列表 */
  eventListDtos?: MyEventListDto[]

  /** 各事件状态数量统计 */
  typeQuantityDtos?: MyEventStatusQuantityDto[]
}

export class MyEventStatusQuantityDto {
  /** 状态code */
  code?: number

  /** 数量 */
  quantity?: number

  /** 事件状态 */
  status?: string
}

export class MyPatrolDto {
  /** 完成率 */
  complateRate?: number

  /** 实巡次数 */
  sxQuantity?: number

  /** 未完成清单 */
  unfinisheds?: UnfinishedListDto[]

  /** 未完成巡河人数 */
  wwcxhrsQuantity?: number

  /** 巡河里程 */
  xhlc?: number

  /** 巡河时长 */
  xhsc?: number

  /** 应巡次数 */
  yxQuantity?: number
}

export class MyPatrolReqDto {
  /** 开始时间（yyyy-MM-dd） */
  begin?: string

  /** 结束时间（yyyy-MM-dd） */
  end?: string

  /** 登录用户id(可不传) */
  loginUserId?: number
}

export class NmscEntity {
  /** 备注 */
  bz?: string

  /** 地址 */
  dz?: string

  /** 负责人 */
  fzr?: string

  /** 负责人电话 */
  fzrdh?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 类别 */
  lb?: string

  /** 名称 */
  mc?: string

  /** 市场面积 */
  scmj?: string

  /** 是否临河 */
  sflh?: string

  /** 数据量 */
  sjl?: string

  /** 所属社区 */
  sssq?: string

  /** 水体名称 */
  stmc?: string

  /** 纬度 */
  wd?: string

  /** 行政区划代码 */
  xzqhdm?: number

  /** 行政区划名称 */
  xzqhmc?: string
}

export class NoticeContentInfoDto {
  /** 上一条公告 */
  lastNoticeModel?: SimpleNoticeDto

  /** 公告详情 */
  model?: NoticeDto

  /** 下一条公告 */
  nextNoticeModel?: SimpleNoticeDto
}

export class NoticeContentListDto {
  /** 是否紧急公告:1是，0否 */
  alerted?: number

  /** 发布时间 */
  createTime?: string

  /** 发布时间 */
  createTimeStr?: string

  /** 发布部门 */
  deptName?: string

  /** 公告id */
  id?: number

  /** 公告标题 */
  title?: string
}

export class NoticeDto {
  /** 是否紧急公告：1是，0否 */
  alerted?: number

  /** 内容 */
  content?: string

  /** 创建时间 */
  createTime?: string

  /** 创建时间 */
  createTimeStr?: string

  /** 部门id */
  deptId?: string

  /** 部门名称 */
  deptName?: string

  /** 文件列表 */
  files?: FileDto[]

  /** id */
  id?: number

  /** 标题 */
  title?: string

  /** 组织结构数 */
  tree?: OrgTree[]
}

export class NywryDto {
  /** 水产养殖数量 */
  scyzCount?: number

  /** 水产养殖数据 */
  scyzList?: ScyzDto[]

  /** 水产养殖占比 */
  scyzPer?: string

  /** 畜禽养殖数量 */
  xqyzCount?: number

  /** 畜禽养殖数据 */
  xqyzList?: XqyzDto[]

  /** 畜禽养殖占比 */
  xqyzPer?: string
}

export class OneRiverOnePlanStatisticsDto {
  /** 总数 */
  count?: number

  /** 类型名称 */
  name?: string

  /** 已完成数 */
  totalCount?: number
}

export class OneRiverOnePlanStatisticsVo {
  dataList?: OneRiverOnePlanStatisticsDto[]

  /** 区级完成数 */
  qjItemCount?: number

  /** 区级总数 */
  qjItemOverCount?: number

  /** 市级完成数 */
  sjItemCount?: number

  /** 市级总数 */
  sjItemOverCount?: number
}

export class OnlineWgyItemInfoDto {
  /** 巡河记录id */
  id?: number

  /** 分项id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 巡河人电话 */
  lxdh?: string

  /** 重点监管点 */
  prints?: WgyItemPrintDto[]

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 巡河人id */
  userId?: number

  /** 巡河人名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 巡河轨迹 */
  zb?: any[][]

  /** 终点经度 */
  zdjd?: string

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string
}

export class OrgTree {
  /** 是否选中 */
  checked?: boolean

  /** 子集 */
  children?: OrgTree[]

  /** 是否为人 */
  isPeople?: boolean

  /** 组织结构id */
  orgId?: string
  pkey?: string

  /** 是否选中 */
  selected?: boolean

  /** 上级组织机构id */
  supperOrgId?: string

  /** 名称 */
  title?: string

  /** 用户id */
  userId?: number
}

export class PageQuery {
  /** 页码,默认1 */
  currPage?: number

  /** 每页显示条数,默认10 */
  pageSize?: number
}

export class ParseMessageColumnDto {
  /** 表头英文key */
  key?: string

  /** 表头中文解释 */
  title?: string
}

export class PcEventReportDto {
  /** 事件地址 */
  address?: string

  /** 部件类别 */
  bjlb!: number

  /** 处理期限 */
  deadline!: number

  /** 处置人id */
  handleUserIdList!: number[]

  /** 经度 */
  jd?: string

  /** 紧急程度（1-4 : 一般、重要、非常重要、紧急） */
  jjcd!: string

  /** 河流 */
  river!: string

  /** 发送短信通知：1是，0否 */
  sendSms!: number

  /** 事件类别 */
  sjlb!: number

  /** 事件名称 */
  sjmc!: string

  /** 事件描述 */
  sjms?: string

  /** 所属镇街-精确到村（最后一级编号） */
  street?: string

  /** 监督人 */
  superviseUserIdList?: number[]

  /** 纬度 */
  wd?: string

  /** 现场录音 */
  xcly?: FileDto[]

  /** 现场视频 */
  xcsp?: FileDto[]

  /** 现场照片 */
  xczp?: FileDto[]
}

export class PcXhtjDto {
  /** 数据列表 */
  dataList?: PcXhtjMergeDto[]

  /** 合计数据列 */
  hjDto?: HjSubjectDto
}

export class PcXhtjMergeDto {
  /** 处理中问题数 */
  clzwtQuantity?: number

  /** 完成率 */
  complateRate?: number

  /** 河流名称 */
  hlName?: string

  /** 河长名称 */
  hzName?: string

  /** 河长数量 */
  hzQuantity?: number

  /** 河长集合 */
  hzSets?: number[]

  /** 河长id */
  hzUserId?: number

  /** 流域名称 */
  lyName?: string

  /** 上报问题总数 */
  sbwtQuantity?: number

  /** 实巡次数 */
  sxQuantity?: number

  /** 实巡人数 */
  sxrQuantity?: number

  /** 未处理问题数 */
  wclwtQuantity?: number

  /** 未完成巡河人数集合 */
  wwcxhrSets?: string[]

  /** 未完成巡河人数 */
  wwcxhrsQuantity?: number

  /** 巡河里程（km） */
  xhlc?: number

  /** 巡河时长(分) */
  xhsc?: number

  /** 已处理问题数 */
  yclwtQuantity?: number

  /** 应巡次数 */
  yxQuantity?: number

  /** 应巡人数 */
  yxrQuantity?: number

  /** 重点监管点数量 */
  zdjgdQuantity?: number

  /** 镇街名称 */
  zjName?: string

  /** 责任河段数量 */
  zrhdQuantity?: number
}

export class PhoneQuery {
  phone?: string
}

export class PkListVo {
  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 排口名称 */
  pkmc?: string

  /** 排污口类型 */
  pwkbm?: string

  /** 纬度 */
  wd?: string
}

export class ProblemCountClassifiedStatisticsDTO {
  /** 对应类型的已处理数量 */
  doingList?: number[]

  /** 类型名称 */
  nameList?: string[]

  /** 对应类型名称的总数 */
  totalList?: number[]
}

export class ProblemCountStatisticsDTO {
  /** 处理中数量 */
  doingCount?: number

  /** 完结数量 */
  overCount?: number

  /** 问题总数 */
  totalCount?: number
}

export class ProblemDataStatisticsVO {
  /** 处理中 */
  doingCount?: number

  /** 已完成数 */
  overCount?: number

  /** 问题总数 */
  totalCount?: number
}

export class ProblemPointVO {
  /** 问题id */
  id?: string

  /** 经度 */
  jd?: string

  /** 问题名称 */
  problemName?: string

  /** 问题子类型 */
  problemSubtype?: number

  /** 问题子类型 转义 */
  problemSubtypeStr?: string

  /** 纬度 */
  wd?: string
}

export class ProblemReportDetailVO {
  /** 问题id */
  problemId?: string

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态转义 */
  problemStatusStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报人名称 */
  zrrUserName?: string
}

export class ProblemReportStatisticsVO {
  /** 处理中数 */
  doingCount?: number

  /** id, 根据类型不同 id则取值不同 */
  id?: string

  /** 镇街名称 */
  name?: string

  /** 已处理数 */
  overCount?: number

  /** 完成率 */
  overRate?: string

  /** 上报数量 */
  reportTotalCount?: number

  /** 类型 */
  type?: string
}

export class ProblemStatisticsDTO {
  /** 处理中数量 */
  doingCount?: number

  /** 完成问题数 */
  overCount?: number

  /** 完成率 */
  problemOverRate?: string

  /** 问题总数 */
  totalCount?: number
}

export class ProgressFormPOST {
  /** 推进情况文本 */
  content?: string

  /** 创建人id */
  createUserId?: number

  /** 创建人 */
  createUsername?: string

  /** 佐证材料附件地址 */
  fileUrl?: string[]

  /** 进度 数字 */
  overRate?: number

  /** id */
  taskId?: number
}

export class PublicProblemReportPOST {
  /** 问题地址 */
  address?: string

  /** 描述 */
  description?: string

  /** 上传的附件url */
  fileList?: FileDto[]

  /** 维度 */
  latitude?: number

  /** 经度 */
  longitude?: number

  /** 微信附件ids */
  mediaList?: string[]

  /** 是否老人 */
  oldman?: boolean

  /** 任务名称 */
  problemName!: string

  /** 问题类型 */
  problemSubtype?: number

  /** 河段河流 */
  river?: string

  /** 短信验证码 */
  smsCode?: string

  /** 联系电话 */
  tel?: string

  /** 姓名 */
  username?: string
}

export class PunchCardPost {
  /** 打卡内容 */
  content?: string

  /** 图片url */
  images?: string[]

  /** 责任人巡查分项详情id */
  itemId?: number

  /** 打卡经度 */
  jd?: string

  /** 用户id,测试用 */
  loginUserId?: number

  /** 重点监测点id */
  printId?: number

  /** 视频url */
  videos?: string[]

  /** 打卡纬度 */
  wd?: string
}

export class PunchCardVO {
  /** 是否能打卡 */
  flag?: boolean

  /** 附近重点监测点信息 */
  print?: ZdjcdInfoDto
}

export class QskInfoDto {
  /** 内容 */
  content?: string

  /** 所处生态敏感区 */
  ecologyArea?: string
  id?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 名称 */
  name?: string

  /** 保护范围 */
  protectArea?: string

  /** 用途 */
  purpose?: string

  /** 规模 */
  scale?: string

  /** 水资源类型 */
  type?: string

  /** 年取水量 */
  yearQsl?: string

  /** 占用岸线长度 */
  zyaxcd?: string
}

export class QskInfoListDTO {
  /** 饼图数据 */
  pieData?: CommonStatisticsDto[]

  /** 总数 */
  totalCount?: number
}

export class QyxhtjDto {
  /** 完成率 */
  complateRate?: number

  /** 名称（可能是userId|用户名） */
  name?: string

  /** 实巡 */
  sx?: number

  /** 应巡 */
  yx?: number
}

export class RankingTimesDto {
  /** 年月 */
  month?: string

  /** 时间 年月日 */
  time?: string

  /** 年份 */
  year?: string
}

export class RankingsFileRespDto {
  /** 考核月份 */
  month?: string

  /** 考核文件url */
  url?: string
}

export class RankingsListDtos {
  /** 单位名称/镇街名称 */
  companyName?: string

  /** 流域 */
  ly?: string

  /** 考核月份 */
  month?: string

  /** 区级河段长 */
  qjhdz?: string

  /** 镇街名次 */
  zjRanking?: string

  /** 镇街考核总分 */
  zjkhTotalScore?: string
}

export class RiverDetailDTO {
  /** 流域面积 */
  area?: number

  /** 河流等级 */
  hlLevel?: number

  /** 河流代码 */
  hldm?: string

  /** 流经乡镇 */
  ljxz?: string

  /** 河流长度 */
  riverLength?: number

  /** 流域等级 */
  riverLevel?: string

  /** 河流名称 */
  riverName?: string
}

export class RiverInfoDto {
  /** 河流等级 */
  hlLevel?: number

  /** 河流长度 */
  hlcd?: string

  /** 河流名称 */
  hlmc?: string

  /** 流域面积 */
  lymj?: number

  /** 支流数量 */
  zlsl?: string
}

export class RiverLeaderStatisticsVo {
  /** 部门河长数量 */
  bmhzsl?: number

  /** 村级河长数量 */
  cjhzsl?: number

  /** 河长总数 */
  hzzs?: number

  /** 流域区河长数量 */
  lyzrrsl?: number

  /** 区常务副总河长 */
  qcwfzhzsl?: number

  /** 区副总河长 */
  qfzhzsl?: number

  /** 区级河长数量 */
  qjhzsl?: number

  /** 区总和长 */
  qzhzsl?: number

  /** 河长人员数据 */
  riverLeaders?: RiverLeaderTreeDto[]

  /** 镇街河长数量 */
  zjhzsl?: number
}

export class RiverLeaderTreeDto {
  /** 子级 */
  child?: RiverLeaderTreeDto[]

  /** 名称 */
  name?: string

  /** 联系河段 */
  river?: string

  /** 排序 */
  sort?: number

  /** 所在镇街 */
  szzj?: string

  /** 河长级别 */
  type?: string

  /** 温馨提示 */
  warmPrompt?: string

  /** 职务 */
  zw?: string
}

export class RiverListDTO {
  /** 河流等级 */
  hlLevel?: number

  /** id */
  id?: number

  /** 河流长度 */
  riverLength?: string

  /** 河流等级转义 */
  riverLevel?: string

  /** 河流名称 */
  riverName?: string
}

export class RiverQuery {
  /** 搜索关键词 */
  keyword?: string

  /** 流域名称 */
  ly?: string
  riverLevel?: string
}

export class RiverZjDto {
  /** 流域 */
  ly?: string

  /** 河流 */
  river?: string

  /** 镇街 */
  zj?: string
}

export class RpcEventInstancePageDto {
  /** 音频 */
  audio?: string

  /** 部件类型 */
  bjlx?: string

  /** 是否关闭/false未关闭、true关闭 */
  close?: boolean

  /** 数据上传附件 */
  filesList?: RpcZDTaskFilesDto[]

  /** 是否生成任务单 */
  generate?: boolean

  /** 当前处理状态(0待办1已办2办结) */
  handleStatus?: string

  /** 河流河段 */
  hlhd?: string

  /** id */
  id?: string

  /** 等级/紧急程度1234 */
  level!: string

  /** 事件名称 */
  name!: string

  /** 照片 */
  photo?: string

  /** 事件编号 */
  serialNo?: string

  /** 事件类型(根据结构树获取) */
  type!: string

  /** 上报时间 */
  upTime?: string

  /** 上报人名称 */
  upUserName?: string

  /** 视频 */
  video?: string
}

export class RpcZDTaskFilesDto {
  /** 上传描述 */
  description?: string

  /** 服务器存储文件地址(必填) */
  filePath!: string

  /** 上传文件格式类型 .text */
  fileSuffix!: string

  /** 文件名称 */
  name?: string

  /** 文件地址(非必填) */
  url?: string
}

/**
 * 一河一策，重点任务分解表
 */
export class SKeyTaskResolveDto {
  /** 配合单位名称 */
  cooperateDepartmentName?: string

  /** 创建时间 */
  createTime?: string

  /** 0：未删除 1：已删除 */
  deleted?: number

  /** 责任单位 */
  dutyDepartmentName?: string

  /** 是否完成 */
  finish?: string

  /** 河段起止点 */
  hdqzd?: string

  /** 河流湖库 */
  hlhk?: string

  /** id */
  id?: number

  /** 所在流域 */
  ly?: string

  /** 主要问题 */
  mainProblem?: string

  /** 完成率 */
  overRate?: number

  /** 完成时限 */
  overTime?: string

  /** 1市级 2区级 3镇街 */
  problemLevel?: number

  /** 问题类别 */
  problemType?: string

  /** 推进情况 */
  promoteSituation?: string

  /** 措施内容 */
  protectiveMeasure?: string

  /** 任务级别 */
  rwjb?: string

  /** 所属镇街 */
  sszj?: string

  /** 所在村居社 */
  szcjs?: string

  /** 所在位置 */
  szwz?: string

  /** 任务发布年份 */
  taskTime?: number

  /** 资金来源 */
  zjly?: string

  /** 责任人 */
  zrr?: string

  /** 责任人id */
  zrrUserId?: number
}

/**
 * 一河一策，重点任务分解表
 */
export class SKeyTaskResolveEntity {
  /** 配合单位名称 */
  cooperateDepartmentName?: string

  /** 创建时间 */
  createTime?: string
  createUserId?: number

  /** 0：未删除 1：已删除 */
  deleted?: number

  /** 责任单位 */
  dutyDepartmentName?: string

  /** 是否完成 */
  finish?: string

  /** 河段起止点 */
  hdqzd?: string

  /** 河流湖库 */
  hlhk?: string

  /** id */
  id?: number

  /** 所在流域 */
  ly?: string

  /** 主要问题 */
  mainProblem?: string

  /** 完成率 */
  overRate?: number

  /** 完成时限 */
  overTime?: string

  /** 1市级 2区级 3镇街 */
  problemLevel?: number

  /** 问题类别 */
  problemType?: string

  /** 推进情况 */
  promoteSituation?: string

  /** 措施内容 */
  protectiveMeasure?: string

  /** 任务级别 */
  rwjb?: string

  /** 所属镇街 */
  sszj?: string

  /** 所在村居社 */
  szcjs?: string

  /** 所在位置 */
  szwz?: string

  /** 任务发布年份 */
  taskTime?: number

  /** 资金来源 */
  zjly?: string

  /** 责任人 */
  zrr?: string

  /** 责任人id */
  zrrUserId?: number
}

export class SceenWgyAreaXcDto {
  /** 实巡次数列表 */
  sxArrays?: KeyValue[]

  /** 应巡次数列表 */
  yxArrays?: KeyValue[]
}

export class SceenWgyXhDto {
  /** 区域巡查 */
  areaXcDto?: SceenWgyAreaXcDto

  /** 巡河统计 */
  xhTjDto?: SceenWgyXhTjDto
}

export class SceenWgyXhRecordDto {
  /** 巡查记录id */
  id?: number

  /** 巡河里程（千米） */
  mileage?: string

  /** 巡河时长（H） */
  timeLength?: string

  /** 巡查人id */
  userId?: number

  /** 巡查人 */
  userName?: string

  /** 巡查结束时间 */
  xhjssj?: string

  /** 巡查开始时间 */
  xhkssj?: string
}

export class SceenWgyXhTjDto {
  /** 巡检完成率 */
  percentageComplete?: number

  /** 应该巡检总次数 */
  shouldQuantity?: number

  /** 巡检总时长（H） */
  timeLength?: number

  /** 巡检总里程（KM） */
  totalMileage?: number

  /** 巡检总次数 */
  totalQuantity?: number
}

export class ScyzDetailDto {
  /** 详细地址 */
  dz?: string

  /** 负责人 */
  fzr?: string

  /** ID */
  id?: string

  /** 经度 */
  jd?: string

  /** 类别 */
  lb?: string

  /** 联系方式 */
  lxfs?: string

  /** 养殖场名称 */
  mc?: string

  /** 年生产能力（吨） */
  nscnl?: string

  /** 受纳水体 */
  snst?: string

  /** 所属街道 */
  szcj?: string

  /** 纬度 */
  wd?: string

  /** 养殖类型 */
  yzlx?: string

  /** 养殖面积（亩） */
  yzmj?: string

  /** 养殖种类 */
  yzzl?: string
}

export class ScyzDto {
  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  mc?: string

  /** 年生产能力 */
  nscnl?: string

  /** 水体名称 */
  stmc?: string

  /** 纬度 */
  wd?: string

  /** 养殖面积 */
  yzmj?: string

  /** 养殖种类 */
  yzzl?: string

  /** 镇街地址 */
  zj?: string
}

export class SgDmPopVo {
  /** 标准水质类别的级别 */
  bzszlbdm?: number

  /** 断面名称 */
  dmmc?: string

  /** 检测时间 */
  jcsj?: string

  /** 最新水质参数 */
  quality?: DropBoxDto[]

  /** 水体类型 */
  stlx?: string

  /** 水质分析趋势数据 */
  waterTrendData?: WaterTrendDto[]

  /** 主要超标污染物 */
  zyCbWry?: string
}

export class SgnqCountByLevelVo {
  /** 一级数量 */
  oneCount?: number

  /** 一级长度 */
  oneLevelLength?: number

  /** 二级数量 */
  twoCount?: number

  /** 二级长度 */
  twoLevelLength?: number
}

export class SgnqListVo {
  /** 功能区级别 */
  level?: string

  /** 水功能区名称 */
  name?: string

  /** 水质目标 罗马文 */
  szmb?: string

  /** 水质目标数字 */
  szmbn?: number
}

export class SgnqPieVo {
  /** 数量 */
  count?: number

  /** 长度 */
  length?: number

  /** 名称 */
  name?: string
}

export class ShjzlQuery {
  /** 流域名称 */
  ly?: string

  /** 时间格式（yyyy-MM-dd HH） */
  month?: string

  /** 监测类型,sgjc手工监测 zdjc自动监测 */
  type?: string
}

export class SimpleNoticeDto {
  /** id */
  id?: number

  /** 标题 */
  title?: string
}

export class SkDetailDTO {
  /** 标准 罗马文 */
  bzszlb?: string

  /** 标准 数字 */
  bzszlbn?: number

  /** 管理单位 */
  gldw?: string

  /** 管理责任人 */
  gldwfzr?: string

  /** 湖库代码 */
  hkdm?: string

  /** 湖库规模 */
  hkgm?: string

  /** 湖库名称 */
  hkmc?: string

  /** 死库容 */
  skr?: string

  /** 移动电话 */
  yddh?: string

  /** 总库容 */
  zkr?: string
}

export class SkInfoDto {
  /** 坝型 */
  bx?: string
  dz?: string
  hkdm?: string

  /** 水库规模 */
  hkgm?: string

  /** 水库名称 */
  hkmc?: string
  id?: string

  /** 经度 */
  jd?: string

  /** 集雨面积 */
  jymj?: number

  /** 死库容 */
  skr?: number

  /** 所在河流 */
  stmc?: string

  /** 水库视频 */
  videoStream?: any[]

  /** 纬度 */
  wd?: string

  /** 现蓄库容(万m³) */
  xxkr?: number

  /** 现蓄水位(m) */
  xxsw?: number

  /** 所在乡镇 */
  xzqhmc?: string

  /** 正常库容 */
  zckr?: number

  /** 最大坝高 */
  zdbg?: string

  /** 总库容 */
  zkr?: number
}

export class SkInfoOverviewResDto {
  /** 小（1）型水库总数量 */
  'little1SkTotal'?: number

  /** 小（2）型水库总数量 */
  'little2SkTotal'?: number

  /** 中型水库总数量 */
  middleSkTotal?: number

  /** 水库总数量 */
  skTotal?: number

  /** 总库容 */
  skTotalCapacity?: number

  /** 饮用水源地数量 */
  yysydTotal?: number
}

export class SkListDTO {
  /** 水库规模 */
  hkgm?: string

  /** 水库名称 */
  hkmc?: string
  id?: string
  sortValue?: number
}

export class SkSzMonitorDTO {
  /** 达标数 */
  dbCount?: number

  /** 达标率 */
  dbRate?: string

  /** 监测数据 */
  monitorData?: YysydInfoStatisticsVo[]

  /** 总数 */
  totalCount?: number
}

export class StatisticsCountDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string
}

export class StatisticsCountUnitDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string

  /** 单位 */
  unit?: string
}

export class StatisticsLcPieVo {
  /** 名称 */
  name?: string

  /** 里程 单位千米 */
  value?: number
}

export class StatisticsPieVo {
  /** 名称 */
  name?: string

  /** 次数 */
  value?: number
}

export class StreamApiDto {
  /** 流域名称 */
  lymc?: string
}

export class SwSiteDetailAndGraphQuery {
  /** 站点编码 */
  indexCode?: string

  /** 时间 格式yyyy-MM-dd,不传默认查询最新数据 */
  time?: string
}

export class SwSiteStandardLineQuery {
  /** 年限 */
  ageLimit?: number

  /** 因子 */
  factor?: string

  /** 站点编码 */
  indexCode?: string
}

export class SwSiteStandardLineVo {
  /** 中位线 */
  medianLine?: number

  /** 七位线 */
  sevenLine?: number

  /** 三位线 */
  threeLine?: number
}

export class SwrDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string

  /** 占比 */
  proportion?: string
}

export class SwslGraphDto {
  /** 监测值 */
  d?: string

  /** 时点 */
  t?: string
}

export class SwslGraphVo {
  /** 对应因子的数据 */
  item?: SwslGraphDto[]

  /** 对应数据的的因子名称 */
  name?: string
}

export class SwslSiteInfo {
  /** 折线图所有数据 */
  datas?: SwslGraphVo[]

  /** 监测因子列表 */
  factors?: string[]

  /** 在线状态 */
  onlined?: boolean

  /** 测站编码 */
  stcd?: string

  /** 测站名称 */
  stnm?: string

  /** 测站类型 */
  type?: string
}

export class SwslSsjcDto {
  /** 站点编码 */
  indexCode?: string

  /** 站点名称 */
  indexName?: string

  /** 经度 */
  jd?: string

  /** 降雨量 */
  jyl?: string

  /** 流量 */
  ll?: string

  /** 水位 */
  sw?: string

  /** 时间 */
  tm?: string

  /** 纬度 */
  wd?: string
}

export class SwslZdtjDto {
  /** 取水口总数 */
  qskzs?: number

  /** 取水口在线数 */
  qskzxs?: number

  /** 水位站在线数 */
  swwzxs?: number

  /** 水位站总数 */
  swwzzs?: number

  /** 水文站总数 */
  swzzs?: number

  /** 水文站在线数 */
  swzzxs?: number

  /** 雨量站总数 */
  ylzzs?: number

  /** 雨量站在线数 */
  ylzzxs?: number
}

export class SxTableDto {
  /** 是否结束 */
  ifEnd?: string

  /** 起点 */
  qdmc?: string

  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河里程(公里) */
  xhlc?: number

  /** 巡河时长(分) */
  xhsc?: number

  /** 终点 */
  zdmc?: string
}

export class SyaxExDto {
  /** 岸线功能分区 */
  axgnqs?: GnfqExDto[]

  /** 岸线基础设施 */
  axjcss?: AxjcssExDto

  /** 岸线水利工程 */
  axslgc?: AxslgcExDto
}

export class SzDetailDto {
  /** 监测对象 */
  dataList?: MonitorSubjectDto[]

  /** 监测时间 */
  dataTime?: string

  /** 因子列表 */
  factorList?: FactorSubjectDto[]

  /** 设备编码 */
  mn?: string

  /** 断面名称 */
  name?: string

  /** 主要污染物列表 */
  zywrwList?: SzZywrwDto[]
}

export class SzHistoryDto {
  /** 当前水质 */
  currentWaterQuality?: string

  /** 监测时点/时间 */
  dataTime?: string

  /** 经度 */
  jd?: number

  /** 设备编码 */
  mn?: string

  /** 断面名称 */
  sectionName?: string
  sort?: number

  /** 水质目标 */
  target?: string

  /** 站点类型(1国控，2市控，3一体化，4物联站) */
  type?: string

  /** PH(无量纲) */
  'w01001'?: string

  /** PH异常标注 */
  'w01001Ex'?: string

  /** 浊度(NTU) */
  'w01003'?: string

  /** 浊度异常标注 */
  'w01003Ex'?: string

  /** 溶解氧(mg/L) */
  'w01009'?: string

  /** 溶解氧异常标注 */
  'w01009Ex'?: string

  /** 水温(℃) */
  'w01010'?: string

  /** 水温异常标注 */
  'w01010Ex'?: string

  /** 电导率(μS/cm) */
  'w01014'?: string

  /** 电导率异常标注 */
  'w01014Ex'?: string

  /** 化学需氧量(mg/L) */
  'w01018'?: string

  /** 化学需氧量异常标注 */
  'w01018Ex'?: string

  /** 高锰酸盐指数(mg/L) */
  'w01019'?: string

  /** 高锰酸盐指数异常标注 */
  'w01019Ex'?: string

  /** 总氮(mg/L) */
  'w21001'?: string

  /** 总氮异常标注 */
  'w21001Ex'?: string

  /** 氨氮(mg/L) */
  'w21003'?: string

  /** 氨氮异常标注 */
  'w21003Ex'?: string

  /** 总磷(mg/L) */
  'w21011'?: string

  /** 总磷异常标注 */
  'w21011Ex'?: string

  /** 纬度 */
  wd?: number
}

export class SzInfoDto {
  /** 工程地址 */
  dd?: string

  /** 工程类型 */
  gclx?: string

  /** id */
  id?: string

  /** 集雨面积 */
  jymj?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 联系电话 */
  lxfs?: string

  /** 联系人 */
  lxr?: string

  /** 所在河流 */
  szhl?: string

  /** 数据类型 1：拦河坝 2：'水闸 */
  type?: number

  /** 名称 */
  xmmc?: string

  /** 行政区划代码 */
  xzqhdm?: string

  /** 行政区划名称 */
  xzqhmc?: string

  /** 运营管理单位 */
  yxgldw?: string
}

export class SzInfoOverviewResDto {
  /** 船闸数量 */
  czTotal?: number

  /** 翻板闸数量 */
  fbzTotal?: number

  /** 滚水坝数量 */
  gsbTotal?: number

  /** 滚水坝（石）数量 */
  gsbsTotal?: number

  /** 石坝数量 */
  sbTotal?: number

  /** 水闸总数量 */
  szTotal?: number

  /** 条石坝数量 */
  tsbTotal?: number

  /** 橡胶坝数量 */
  xjbTotal?: number
}

export class SzZywrwDto {
  /** 超标倍数 */
  cbbs?: number

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 监测值 */
  monitorValue?: number

  /** 标准值 */
  standValue?: number[]
}

export class SzySiteCountStatisticsDTO {
  /** 在线数 */
  onlineCount?: number

  /** 总数 */
  totalCount?: number
}

export class TargetTaskCountStatisticsVo {
  qjCount?: number
  sjCount?: number
  totalCount?: number
  zjCount?: number
}

export class TaskDetailDTO {
  /** 配合单位名称 */
  cooperateDepartmentName?: string
  createTime?: string

  /** 责任单位 */
  dutyDepartmentName?: string

  /** 是否完成 */
  finish?: string

  /** 河流湖库 */
  hlhk?: string
  id?: number

  /** 所在流域 */
  ly?: string

  /** 主要问题 */
  mainProblem?: string

  /** 完成率 进度 */
  overRate?: string

  /** 完成时限 */
  overTime?: string

  /** 1市级 2区级 */
  problemLevel?: number

  /** 问题类别 */
  problemType?: string

  /** 推进情况 */
  promoteSituation?: string

  /** 措施内容 */
  protectiveMeasure?: string

  /** 任务级别 */
  rwjb?: string

  /** 所属镇街 */
  sszj?: string

  /** 所在村居社 */
  szcjs?: string

  /** 所在位置 */
  szwz?: string

  /** 任务发布年份 */
  taskTime?: number

  /** 推进 */
  tjList?: YhycTaskTJDTO[]

  /** 资金来源 */
  zjly?: string

  /** 责任人 */
  zrr?: string

  /** 责任人id */
  zrrUserId?: number
}

export class TaskLevelQuery {
  /** 任务级别, 1-市级 2-区级 3-镇街级 */
  taskLevel?: string
}

export class TaskListQuery {
  /** 责任单位 */
  department?: string

  /** 关键词 */
  keyword?: string

  /** 流域 */
  ly?: string

  /** 页码 */
  page?: number

  /** 记录数 */
  pageSize?: number

  /** 任务类型 */
  problemType?: string

  /** 状态 */
  status?: string
  taskLevel?: string

  /** 时间 */
  time?: string
}

export class TaskListVO {
  /** id */
  id?: number

  /** 主要问题 */
  mainProblem?: string

  /** 完成率 */
  overRate?: string

  /** 问题类型 */
  problemType?: string

  /** 所在位置 */
  szwz?: string
}

export class TaskQuery {
  /** 流域 */
  ly?: string
  taskLevel?: string

  /** 时间 */
  time?: string
}

export class TmpIndexDto {
  /** 坐标系 */
  coordinate?: string

  /** 河长级别 */
  hzjb?: string

  /** 经度 */
  jd?: string

  /** 联系电话 */
  lxdh?: string

  /** 联系河段 */
  lxhd?: string

  /** 用户id */
  userId?: number

  /** 用户名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 镇街 */
  zj?: string
}

export class TreeDto {
  /** 子级 */
  childs?: TreeDto[]

  /** 名称 */
  name?: string

  /** 值 */
  value?: string
}

export class Type {
  typeName?: string
}

export class TypeStatisticsCountDTO {
  /** 分类名称 */
  name?: string

  /** 完成数 */
  overCount?: number

  /** 总数 */
  totalCount?: number
}

export class UnfinishedListDto {
  /** 级别 */
  hzjb?: string

  /** 实巡次数 */
  sxQuantity?: number

  /** 姓名 */
  userName?: string

  /** 应巡次数 */
  yxQuantity?: number
}

export class VideoIndexDto {
  /** 接入方式 */
  accessMode?: number

  /** 类别用于区分类型 gk,sk,qk,一体化yth,物联站wlz,水库sk 等 */
  category?: string

  /** 摄像头编码 */
  deviceCode?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  name?: string

  /** 是否在线，在线true , 不在线false */
  online?: boolean

  /** 是否超标   达标db , 超标cb, 无数据wsj */
  standard?: string

  /** 视频流地址 */
  videoStream?: string

  /** 水质等级评价 */
  waterLevel?: number

  /** 纬度 */
  wd?: string
}

export class VideoListDto {
  /** 排口名称 */
  output?: string

  /** 站点名称 */
  psName?: string

  /** 视频地址 */
  videoPath?: string
}

export class VideoSimpleDTO {
  /** 摄像头id */
  cameraId?: string

  /** 摄像头id */
  id?: string

  /** 摄像头名称 */
  name?: string
  online?: boolean
}

export class WaterAssessmentDto {
  /** 当前数据月 */
  currentMonth?: string

  /** 国考 */
  gkDto?: WaterAssessmentGKDto

  /** 最新数据月 */
  month?: string

  /** 区考 */
  qkDto?: WaterAssessmentGKDto

  /** 市考 */
  skDto?: WaterAssessmentGKDto

  /** 物联站 */
  wlzDto?: WaterAssessmentGKDto

  /** 一体化 */
  ythDto?: WaterAssessmentGKDto
}

export class WaterAssessmentGKDto {
  /** 超标 */
  cb?: number

  /** 超标站点集合 */
  cbSitenames?: Record<string, any>[]

  /** 达标 */
  db?: number

  /** 达标率 */
  dbRate?: number

  /** 达标站点集合 */
  dbSitenames?: Record<string, any>[]

  /** 总数 */
  total?: number

  /** 所有站点集合 */
  totalSitenames?: Record<string, any>[]

  /** 无数据/离线 */
  wjc?: number
}

export class WaterAssessmentSectionInfoDto {
  /** 1-12月累计 */
  accumulativeWaterQuality?: string

  /** 考核结果 */
  assessmentResult?: string

  /** 当前水质 */
  currentWaterQuality?: string

  /** 经度 */
  jd?: string

  /** 排序号 */
  pxh?: number

  /** 断面ID */
  sectionID?: string

  /** 断面名称 */
  sectionName?: string

  /** 断面类型 */
  sectionType?: string

  /** 目标水质 */
  targetWaterQuality?: string

  /** 纬度 */
  wd?: string
}

export class WaterAssessmentSectionInfoResultDto {
  /** 当前数据月 */
  currentMonth?: string

  /** 最新数据月 */
  month?: string

  /** 断面总数 */
  sectionCount?: number

  /** 断面信息集合 */
  waterAssessmentSectionInfos?: WaterAssessmentSectionInfoDto[]
}

export class WaterPollutionOnlineDto {
  /** 接入数量 */
  accessQuantity?: string

  /** 在线数-气泡展示数据 */
  itemModel?: WsclcStatisticalOnlineItemDto

  /** 在线监测总数 */
  monitorOnlineTotalQuantity?: number

  /** 离线数 */
  offlineQuantity?: number

  /** 在线率 */
  onlinePo?: string

  /** 在线数 */
  onlineQuantity?: number

  /** 超标数量 */
  overStandardQuantity?: string
}

export class WaterTrendDto {
  /** 因子 */
  code?: string

  /** 因子名称 */
  name?: string

  /** 趋势图 */
  trend?: string[]
  xaxis?: string[]
}

export class WgyCountByZjDTO {
  /** 名称 */
  name?: string

  /** 类别（专，兼职） */
  type?: string

  /** 数量 */
  value?: number
}

export class WgyCountStatisticsDTO {
  /** 兼职数量 */
  jzCount?: number

  /** 流域或镇街 */
  lyOrZjList?: LyOrZjListDTO[]

  /** 网格员总数 */
  totalCount?: number

  /** 网格员 */
  wgyList?: WgyZzListDTO[]

  /** 专职数量 */
  zzCount?: number
}

export class WgyCountStatisticsVo {
  /** 兼职网格员数量 */
  jzWgyCount?: number

  /** 网格员总数 */
  total?: number

  /** 专职网格员数量 */
  zzWgyCount?: number
}

export class WgyDkCountDto {
  /** 打卡完成率 */
  dkedRate?: string

  /** 实际打卡次数 */
  sjdkCount?: number

  /** 应打卡次数 */
  ydkCount?: number

  /** 重点排口数量 */
  zdpkCount?: number
}

export class WgyDto {
  /** 网格员id */
  userId?: number

  /** 网格员名称 */
  userName?: string
}

export class WgyItemPrintDto {
  id?: number

  /** 经度 */
  jd?: string

  /** 纬度 */
  wd?: string

  /** 站点名称 */
  zdjgd?: string
}

export class WgyStatisticsQuery {
  ly?: string
  zj?: string
}

export class WgyTableDto {
  /** 次数 */
  cs?: number

  /** 操作 */
  cz?: string

  /** 频次 */
  pc?: string

  /** 起点名称 */
  qdmc?: string

  /** 网格员名 */
  wgyName?: string

  /** 网格员id */
  wgyUserId?: number

  /** 终点名称 */
  zdmc?: string
}

export class WgyTableReqDto {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 登录用户id（测试用，勿传） */
  loginUserId?: number

  /** 流域 */
  ly?: string

  /** 镇街 */
  zj?: string
}

export class WgyTableRespDto {
  /** 网格员id */
  wgUserId?: number

  /** 网格员名称 */
  wgUserName?: string
}

export class WgyWtIndexDto {
  /** 状态code（0：待处理，1：处理中，2：已处理） */
  handleStatus?: number

  /** 问题id（事件中心） */
  id?: string

  /** 纬度 */
  latitude?: number

  /** 经度 */
  longitude?: number

  /** 问题名称 */
  name?: string
}

export class WgyWtRecordDto {
  /** 状态code */
  handleStatus?: number

  /** 河流 */
  hl?: string

  /** 河长类型（wgy/hz） */
  hzlb?: string

  /** 问题id（事件中心） */
  id?: string

  /** 纬度 */
  latitude?: number

  /** 经度 */
  longitude?: number

  /** 问题名称 */
  name?: string

  /** 状态 */
  status?: string

  /** 上报时间 */
  upTime?: string

  /** 上报人 */
  userName?: string
}

export class WgyWtczDto {
  /** 问题处置排名 */
  pmList?: WgyWtczPmDto[]

  /** 问题统计 */
  tjDto?: WgyWtczTjDto
}

export class WgyWtczPmDto {
  /** 处置完成率 */
  czwcl?: number

  /** 上报总数 */
  sbzs?: number

  /** 已处理数 */
  ycls?: number

  /** 镇街 */
  zj?: string
}

export class WgyWtczTjDto {
  /** 处理中数 */
  clzzs?: number

  /** 处置率 */
  czl?: number

  /** 上报总数 */
  sbzs?: number

  /** 已处理数 */
  ycls?: number
}

export class WgyWwcxhListDto {
  /** 河流 */
  hl?: string

  /** 巡查频次 */
  pc?: string

  /** 实巡次数 */
  sxQuantity?: number

  /** 网格员id */
  userId?: number

  /** 网格员名称 */
  userName?: string

  /** 应巡次数 */
  yxQuantity?: number
}

export class WgyXhCountDto {
  /** 实际打卡次数 */
  sjdkCount?: number

  /** 实巡里程 */
  sxMileage?: number

  /** x轴数据 */
  xaxis?: string

  /** 应打卡次数 */
  ydkCount?: number

  /** 应巡里程 */
  yxMileage?: number
}

export class WgyXhCountInfoDto {
  /** 姓名 */
  name?: string

  /** 上报问题数量 */
  problemCount?: number

  /** 实际打卡次数 */
  sjdkCount?: number

  /** 实巡里程 */
  sxMileage?: number

  /** 网格员id */
  userId?: number

  /** 应打卡次数 */
  ydkCount?: number

  /** 应巡里程 */
  yxMileage?: number

  /** 镇街 */
  zj?: string
}

export class WgyXhGridByZjDto {
  /** 河流 */
  hl?: string

  /** mbId */
  id?: number

  /** 重点监管点 */
  prints?: string

  /** 起点名称 */
  qdmc?: string

  /** 用户id */
  userId?: number

  /** 用户名称 */
  username?: string

  /** 终点名称 */
  zdmc?: string
}

export class WgyXhGroupByZjDto {
  /** 百分比 */
  percent?: string

  /** 实巡数量 */
  sxCount?: number

  /** 应巡数量 */
  yxCount?: number

  /** 镇街 */
  zj?: string
}

export class WgyXhInfoStatisticsDto {
  /** 实巡次数 */
  sxQuantity?: number

  /** 所在镇街 */
  szzj?: string

  /** 网格员名称 */
  wgyName?: string

  /** 网格员id */
  wgyUserId?: number

  /** 应巡次数 */
  yxQuantity?: number
}

export class WgyXhStatisticsDto {
  /** 实巡次数 */
  sx?: number

  /** 实巡人数 */
  sxrs?: number

  /** 巡河里程(km) */
  xhlc?: number

  /** 巡河时长(h) */
  xhsc?: number

  /** 应巡次数 */
  yx?: number

  /** 应巡人数/网格员数 */
  yxrs?: number
}

export class WgyXhStatisticsInfoQuery {
  /** 开始时间 yyyy-MM-dd */
  beginTime?: string

  /** 结束时间 yyyy-MM-dd */
  endTime?: string

  /** 流域 */
  ly?: string

  /** 巡河人id */
  userId?: number

  /** 是否完成巡河 全部，未完成，已完成 */
  xhwczt?: string

  /** 镇街 */
  zj?: string
}

export class WgyYxMbDto {
  /** 网格员每周应巡id */
  id?: number

  /** 所属流域 */
  ly?: string

  /** 网格员每周应巡河段里程（km） */
  needMileage?: number

  /** 备注 */
  remark?: string

  /** 所在镇街名称 */
  szzj?: string

  /** 网格员id */
  userId?: number

  /** 网格员 */
  userName?: string
}

export class WgyYxMbReqDto {
  /** 流域 */
  ly?: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number

  /** 所在镇街 */
  szzj?: string

  /** 网格员id */
  userId?: number

  /** 网格员名称 */
  userName?: string
}

export class WgyZjMappingQuery {
  /** 搜索关键词 */
  keywords?: string

  /** 流域 */
  ly?: string

  /** 镇街 */
  zj?: string
}

export class WgyZzListDTO {
  /** 网格段 */
  lxhd?: string

  /** 用户名 */
  name?: string

  /** 区分专职，兼职 */
  type?: string

  /** 专职或兼职 */
  zzOrjz?: string
}

export class WorkflowRecordTreeDto {
  /** 指派时间 */
  assignTime?: string

  /** 指派时间Str */
  assignTimeStr?: string

  /** 指派人员 */
  assignUser?: string

  /** 子流程 */
  childList?: WorkflowRecordTreeDto[]

  /** 处理期限（单位：天） */
  deadline?: number

  /** 处理意见描述 */
  description?: string

  /** 评论列表 */
  evaluations?: WorkflowRecordTreeDto[]

  /** 附件列表 */
  fileList?: ZkProblemFileDto[]

  /** 流程描述 */
  flowDesc?: string

  /** 处理状态 1:待处理 2:处理中 3:已办结 */
  handleStatus?: number

  /** 处理状态 */
  handleStatusStr?: string

  /** 处理时间 */
  handleTime?: string

  /** 处理时间Str */
  handleTimeStr?: string

  /** 执行类型（1:执行/2:督办） */
  handleType?: number

  /** 执行类型 */
  handleTypeStr?: string

  /** 处理人员 */
  handleUser?: string

  /** id */
  id?: string

  /** 是否可以流程进行评价 */
  ifEvaluation?: boolean

  /** 是否合并单据（1是，0否） */
  merged?: number
  pid?: string

  /** 职务 */
  position?: string

  /** 职务全名 */
  positionFullName?: string

  /** 问题id */
  problemId?: string

  /** 处理进度 */
  schedule?: number

  /** 整改措施 */
  zgcs?: string

  /** 整改措施Str */
  zgcsStr?: string
}

export class WrjFLyStatisticsDTO {
  /** 飞行次数 */
  count?: number

  /** 航飞里程 */
  lc?: number
}

export class WrjFlightRecordDto {
  /** 飞行时间 */
  createTime?: string

  /** 任务描述 */
  description?: string

  /** 飞行距离 */
  distance?: string

  /** 飞行结束点经度 */
  endJd?: string

  /** 终点名称 */
  endName?: string

  /** 飞行结束点纬度 */
  endWd?: string

  /** list格式飞行路径 */
  flightpathList?: any[]

  /** id */
  id?: number

  /** 所属流域 */
  ly?: string

  /** 名称 */
  name?: string

  /** 河流名称 */
  river?: string

  /** 开始点经度 */
  startJd?: string

  /** 起点名称 */
  startName?: string

  /** 开始点纬度 */
  startWd?: string

  /** 飞行视频 */
  videoUrl?: string
}

export class WrjFlyRecordDTO {
  /** 飞行时间 */
  createTime?: string

  /** 飞行距离 */
  distance?: number

  /** 飞行结束经度 */
  endJd?: string

  /** 飞行结束纬度 */
  endWd?: string

  /** list格式飞行轨迹 */
  flightpathList?: any[]

  /** id */
  id?: string

  /** 河流 */
  river?: string

  /** 飞行起点经度 */
  startJd?: string

  /** 飞行起点纬度 */
  startWd?: string
}

export class WrjPathDto {
  /** 结束点经度 */
  endJd?: string

  /** 结束点纬度 */
  endWd?: string

  /** 飞行路径 */
  flightpath?: string

  /** id */
  id?: number

  /** 河流 */
  river?: string

  /** 开始点经度 */
  startJd?: string

  /** 开始点纬度 */
  startWd?: string
}

export class WrjStatisticsDto {
  /** 飞行记录 */
  filghtRecord?: WrjPathDto[]

  /** 飞行次数 */
  flightCount?: number

  /** 飞行距离 */
  flightDistance?: number

  /** 页面总数 */
  pageTotal?: number
}

export class WsclcDetailDto {
  /** 地理位置 */
  address?: string

  /** 管控级别 */
  attentionDegreeCode?: string

  /** 责任单位 */
  epoName?: string

  /** 因子列表 */
  factors?: Record<string, string>[]

  /** 法人代表 */
  fddbr?: string

  /** 排口最新数据时间 */
  lastedDate?: string

  /** 排口编码 */
  outPutCode?: string

  /** 排口名称 */
  outPutName?: string

  /** 排放标准 */
  pfbz?: string

  /** 编码 */
  psCode?: string

  /** 污水处理厂名称 */
  psName?: string

  /** 排放去向类型 */
  psqxlx?: string

  /** 工艺 */
  ssclgy?: string

  /** 规模 */
  sssjrclnl?: string

  /** 水体名称 */
  stmc?: string

  /** 状态：cb / db / wsj / wjr */
  stru?: string

  /** 排污许可证编码 */
  tyshxydm?: string

  /** 污水处理厂视频 */
  videoList?: VideoListDto[]

  /** 运营单位 */
  yydwmc?: string
}

export class WsclcDetailPopQuery {
  /** 排口编码 */
  outputCode!: string

  /** 污水处理厂编码 */
  psCode!: string

  /** 水体名称 */
  stmc?: string
}

export class WsclcGraphDto {
  /** 时间 */
  dataTime?: string

  /** 因子 */
  factor?: string

  /** 监测时间 */
  monitorTime?: string

  /** 排口编码 */
  outPutCode?: string

  /** 标准值 */
  stand?: string[]

  /** 单位 */
  unit?: string

  /** 监测值 */
  value?: string
}

export class WsclcGraphQuery {
  /** 结束时间 yyyy-MM-dd HH */
  endTime?: string

  /** 监测因子 */
  factor?: string

  /** 排口编码mn */
  outPutCode?: string

  /** 开始时间 yyyy-MM-dd HH */
  startTime?: string

  /**  hour:时均值, day:日均值 */
  type?: string
}

export class WsclcInfoItemsDto {
  /** 排口在线状态 */
  online?: number

  /** 排口编码 */
  outPutCode?: string

  /** 排口名称 */
  outPutName?: string

  /** 排口状态 */
  stru?: string
}

export class WsclcStatisticalOnlineItemDto {
  /** 超标数 */
  cbQuantity?: number

  /** 达标率 */
  dbPo?: string

  /** 达标数 */
  dbQuantity?: number
}

export class WtTableDto {
  /** 上报人 */
  createUser?: string

  /** 当前处理人(多个逗号隔开) */
  currentHandleUser?: string

  /** id */
  id?: string

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatusStr?: string

  /** 上报时间 */
  reportTime?: string
}

export class WtczListDto {
  /** 问题id */
  problemId?: string

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态Str */
  problemStatusStr?: string

  /** 上报时间 */
  reportTime?: string
}

export class WtczZjGroupDto {
  /** 处理中 */
  clz?: number

  /** 上报总数 */
  sbzs?: number

  /** 未处理 */
  wcl?: number

  /** 已处理 */
  ycl?: number

  /** 镇街名称 */
  zj?: string
}

export class WtsbqkTableReqDto {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 登录用户id（测试用，勿传） */
  loginUserId?: number

  /** 流域 */
  ly?: string

  /** 状态:参考（处理中：clz，已处理：ycl, 全部则不传） */
  problemStatusStr?: string

  /** 网格员id */
  wgUserId?: number

  /** 镇街 */
  zj?: string
}

export class WtsbqkTableRespDto {
  /** 问题id */
  id?: string

  /** 问题名称 */
  problemName?: string

  /** 状态 */
  problemStatus?: number
  problemStatusStr?: string
}

export class WttjDto {
  /** 处理中 */
  clz?: number

  /** 上报总数 */
  sbzs?: number

  /** 未处理 */
  wcl?: number

  /** 已处理 */
  ycl?: number
}

export class WwcxhrTableDto {
  /** 河长级别 */
  hzjb?: string

  /** 备注 */
  remark?: string

  /** 实巡次数 */
  sxQuantity?: number

  /** 网格员名称 */
  wgyName?: string

  /** 网格员id */
  wgyUserId?: number

  /** 应巡次数 */
  yxQuantity?: number
}

export class WxPunchCardPost {
  /** 打卡内容 */
  content?: string

  /** 责任人巡查分项详情id */
  itemId?: number

  /** 打卡经度 */
  jd?: string

  /** 用户id,测试用 */
  loginUserId?: number

  /** 微信媒体id */
  mediaIds?: string[]

  /** 重点监测点id */
  printId?: number

  /** 打卡纬度 */
  wd?: string
}

export class WxRealReportDTO {
  /** 责任人巡查分项详情id */
  id?: number

  /** 经度 */
  jd?: string

  /** 用户id */
  userId?: number

  /** 纬度 */
  wd?: string
}

export class WxXhAttachmentDTO {
  /** 描述 */
  desc?: string

  /** 责任人巡查分项详情id */
  id?: number

  /** 媒体id */
  mediaId?: string[]

  /** 登录用户id */
  userId?: number
}

export class XcItemDetailEventDto {
  /** 问题地址（自动获取问题所在地址） */
  address?: string

  /** 部件类别,默认为“河面” */
  bjlb?: number
  createTime?: string

  /** 河流河段 */
  hlhd?: string
  id?: number

  /** 责任人巡查分项详情id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 紧急程度 */
  jjcd?: string

  /** 问题类别, 默认为“巡河上报 */
  sjlb?: number

  /** 问题名称 */
  sjmc?: string

  /** 事件描述 */
  sjms?: string

  /** 所属镇街-精确到村 */
  street?: string
  updateTime?: string

  /** 事件 id */
  uuid?: string

  /** 纬度 */
  wd?: string

  /** 现场录音 */
  xcly?: string

  /** 现场视频 */
  xcsp?: string

  /** 现场照片 */
  xczp?: string
}

export class XcListDto {
  /** 任务列表 */
  detailListDtos?: XcxcDto[]

  /** 计划是否已经结束 */
  ended?: boolean

  /** 计划id */
  jhId?: number

  /** 计划名称 */
  jhmc?: string

  /** 计划状态 */
  qyzt?: string
}

export class XcfwDto {
  /** id */
  id?: number

  /** 流域 */
  lyName?: string

  /** 巡查范围 */
  xcfw?: string

  /** 镇街 */
  zjName?: string
}

export class XcjlDto {
  /** 子级 */
  childs?: XcjlMergeDto[]

  /** 日期 */
  date?: string
}

export class XcjlInfoDto {
  /** 巡河附件 */
  files?: XhFileDto[]

  /** 巡河轨迹 */
  gjInfo?: XhGjInfoDto

  /** 计划名称 */
  jhmc?: string

  /** 结束时间 */
  jssj?: string

  /** 开始时间 */
  kssj?: string

  /** 联系方式 */
  lxfs?: string

  /** 流域名称 */
  lymc?: string

  /** 上报事件数量 */
  sbsj?: number

  /** 上报事件 */
  sbsjs?: XhSbsjInfoDto[]

  /** 所在镇街 */
  szzjmc?: string

  /** 网格编号 */
  wgbh?: string

  /** 巡查范围 */
  xcfw?: string

  /** 巡查距离 */
  xcjl?: string

  /** 巡查频次 */
  xcpc?: string

  /** 巡查人 */
  xcr?: string

  /** 巡查人id */
  xcrId?: number

  /** 巡查时长 */
  xcsc?: string

  /** 巡河结论 */
  xhResult?: string
}

export class XcjlMergeDto {
  /** 日期 */
  date?: string

  /** 责任人巡查分项详情id */
  id?: number

  /** 责任人巡查分项id */
  itemId?: number

  /** 起点名称 */
  qdmc?: string

  /** 时间 */
  time?: string

  /** 上报问题数量 */
  wtsbsl?: number

  /** 巡河时长 */
  xcsc?: string

  /** 巡河里程数 */
  xhlcs?: string

  /** 巡河类型：1常规巡河，2临时巡河 */
  xhlx?: number

  /** 终点名称 */
  zdmc?: string
}

export class XcjlPageDto {
  /** 河段起点 */
  hdqd?: string

  /** 河段终点 */
  hdzd?: string

  /** 河流名称 */
  hlmc?: string

  /** 巡河记录id */
  id?: number

  /** 上报问题数量 */
  sbwts?: number

  /** 责任人id */
  userId?: number

  /** 网格编号 */
  wgbh?: string

  /** 巡河范围 */
  xcfw?: string

  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河类型：1常规巡河，2临时巡河 */
  xhlx?: number

  /** 责任人 */
  xhr?: string

  /** 巡河状态 */
  xhzt?: string
}

export class XcxcDto {
  /** 开始时间 */
  begin?: string

  /** 本周期已巡查 */
  bzyxc?: string

  /** 村级社 */
  cjs?: string

  /** 截止时间 */
  end?: string

  /** 计划分项id */
  id?: number

  /** 计划巡查频次 */
  pc?: string

  /** 起点名称 */
  qdmc?: string

  /** 网格编号 */
  wgbh?: string

  /** 巡查要求 */
  xcyq?: string

  /** 重点监管点列表 */
  zdjgds?: string

  /** 终点名称 */
  zdmc?: string
}

export class XhDKStatisticQuery {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 流域 */
  ly?: string

  /** 镇街 */
  zj?: string
}

export class XhFileDto {
  /** 描述 */
  des?: string

  /** 文件路径 */
  filePath?: string

  /** 文件类型 */
  fileType?: string

  /** 文件请求url */
  url?: string
}

export class XhGjInfoDto {
  /** 巡河附件 */
  files?: XhFileDto[]

  /** 巡河轨迹(k(经度),v(纬度)) */
  gjs?: any

  /** 责任人巡查分项详情id */
  id?: number

  /** 流域 */
  ly?: string

  /** 巡查频次 */
  pc?: string

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 上报事件 */
  sbsjs?: XhSbsjDto[]

  /** 网格编号 */
  wgbh?: string

  /** 巡查范围 */
  xcfw?: string

  /** 巡查结论 */
  xhResult?: string

  /** 巡河对象 */
  xhdx?: XhdxDto

  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河状态：1巡河中，2巡河结束 */
  xhzt?: number

  /** 终点经度 */
  zdjd?: string

  /** 重点监管点列表 */
  zdjgds?: XhZdjgdDto[]

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string

  /** 联系人 */
  zrrUserName?: string

  /** 联系方式 */
  zrrUserTel?: string
}

export class XhGjQuery {
  /** 开始时间 */
  begin?: string

  /** 结束时间 */
  end?: string
  userIds?: number[]
}

export class XhIndexDto {
  /** 部门河长 */
  bmHz?: string

  /** 河长级别 */
  hzjb?: string

  /** 巡河记录id */
  id?: number

  /** 经度 */
  jd?: string

  /** 联系电话 */
  lxdh?: string

  /** 联系河段 */
  lxhd?: string

  /** 区级河长 */
  qjHz?: string

  /** 巡河人id */
  userId?: number

  /** 巡河人名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 镇街 */
  zj?: string

  /** 镇街河长 */
  zjHz?: string

  /** 职务 */
  zw?: string
}

export class XhOverDto {
  /** 责任人巡查分项详情id */
  id?: number

  /** 巡查结论 */
  xhResult?: string
}

export class XhProblemReportDTO {
  /** 问题所在地址 */
  address?: string

  /** 处理期限 */
  deadline!: number

  /** 问题描述 */
  description?: string

  /** 紧急程度 */
  emergencyDegree!: number

  /** 处置人id */
  handleUserIdList!: OrgTree[]

  /** 维度 */
  latitude?: number

  /** 经度 */
  longitude?: number

  /** 媒体ids */
  mediaIds?: string[]

  /** 任务名称 */
  problemName!: string

  /** 來源 */
  problemSource!: number

  /** 问题子类型 */
  problemSubtype?: number

  /** 任务类型 */
  problemType!: number

  /** 流域河段：针对任务来源为问题上报时传递，其它来源忽略该字段 */
  river?: string

  /** 发送短信通知：1是，0否 */
  sendSms!: number

  /** 监督人 */
  superviseUserIdList?: OrgTree[]

  /** 巡查范围：1城区内，2城区外（包含一周一次/一天一次），3其它 */
  xcfw?: number
}

export class XhProblemStatisticsVo {
  /** 处理中数量 */
  doingCount?: number

  /** 对应类型的已做数量 */
  doingList?: number[]

  /** 完成率 */
  finishingRate?: string

  /** 类型名称 */
  nameList?: string[]

  /** 已处理总数 */
  overCount?: number

  /** 问题总数 */
  totalCount?: number

  /** 对应类型名称的总数 */
  totalList?: number[]
}

export class XhRecordInfoReqDto {
  /** 开始时间（yyyy-MM-dd），查询时间范围不得超过30天 */
  beginDate!: string

  /** 结束时间（yyyy-MM-dd），查询时间范围不得超过30天 */
  endDate!: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class XhRecordInfoRespDto {
  /** 村居社 */
  cjs?: string

  /** 次数 */
  cs?: number

  /** 操作：>= ; <= ; = ; > ; < */
  cz?: string

  /** 河流名称 */
  hl?: string

  /** 河长级别 */
  hzjb?: string

  /** 巡河记录id */
  id?: number

  /** 巡河任务id */
  itemId?: number

  /** 流域名称 */
  ly?: string

  /** 频次 */
  pc?: string

  /** 监测点列表 */
  prints?: XhRecordPrintDto[]

  /** 巡河上报问题 */
  problems?: XhRecordProblemDto[]

  /** 起点编号 */
  qdbh?: string

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 所在镇街id */
  szzj?: string

  /** 所在镇街名称 */
  szzjmc?: string

  /** 巡河人 */
  userName?: string

  /** 网格编号 */
  wgbh?: string

  /** 巡查范围 */
  xcfw?: string

  /** 巡河结论 */
  xhResult?: string

  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河里程（米） */
  xhlc?: number

  /** 巡河状态：1巡河中，2巡河结束 */
  xhzt?: number

  /** 终点编号 */
  zdbh?: string

  /** 终点经度 */
  zdjd?: string

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string
}

export class XhRecordPrintDto {
  /** 打卡状态：1未打卡，2已打卡 */
  dkzt?: number

  /** 巡查记录id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 监测点类型：1重点监测点，2途径点 */
  type?: number

  /** 纬度 */
  wd?: string

  /** 监测点名称 */
  zdjgd?: string
}

export class XhRecordProblemDto {
  /** 事件地址 */
  address?: string

  /** 部件类别 */
  bjlb?: number

  /** 河流河段 */
  hlhd?: string

  /** 巡河记录id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 紧急程度 */
  jjcd?: string

  /** 事件类别 */
  sjlb?: number

  /** 事件名称 */
  sjmc?: string

  /** 事件描述 */
  sjms?: string

  /** 所属镇街-精确到村 */
  street?: string

  /** 上报问题关联id */
  uuid?: string

  /** 纬度 */
  wd?: string
}

export class XhSbsjDto {
  /** 经度 */
  jd?: string

  /** 事件名称 */
  sjmc?: string

  /** 事件uuid */
  uuid?: string

  /** 纬度 */
  wd?: string
}

export class XhSbsjInfoDto {
  /** 上报时间 */
  createTime?: string

  /** 事件类别 */
  sjlb?: string

  /** 事件名称 */
  sjmc?: string

  /** 事件描述 */
  sjms?: string

  /** 事件id */
  uuid?: string
}

export class XhStatisticsRateWithZjDto {
  /** 打卡率 */
  dkRate?: number

  /** 问题处置率 */
  problemHandleRate?: number

  /** 镇街名称 */
  zjName?: string
}

export class XhStatisticsRateWithZjReqDto {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 流域 */
  ly?: string
}

export class XhTaskInfoReqDto {
  /** 开始时间（yyyy-MM-dd），查询时间范围不得超过30天 */
  beginDate!: string

  /** 结束时间（yyyy-MM-dd），查询时间范围不得超过30天 */
  endDate!: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class XhTaskInfoRespDto {
  /** 村居社 */
  cjs?: string

  /** 次数 */
  cs?: number

  /** 操作：>= ; <= ; = ; > ; < */
  cz?: string

  /** 河流名称 */
  hl?: string

  /** 河长级别 */
  hzjb?: string

  /** 巡河任务id */
  id?: number

  /** 流域名称 */
  ly?: string

  /** 频次 */
  pc?: string

  /** 监测点列表 */
  prints?: XhTaskPrintDto[]

  /** 起点编号 */
  qdbh?: string

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 所在镇街名称 */
  szzjmc?: string

  /** 网格编号 */
  wgbh?: string

  /** 巡查范围 */
  xcfw?: string

  /** 终点编号 */
  zdbh?: string

  /** 终点经度 */
  zdjd?: string

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string

  /** 周期结束时间 */
  zqjssj?: string

  /** 周期开始时间 */
  zqkssj?: string

  /** 责任人用户名称 */
  zrrUserName?: string

  /** 责任人用户电话 */
  zrrUserTel?: string
}

export class XhTaskPageReqDto {
  /** 用户账号 */
  loginName!: string

  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number
}

export class XhTaskPrintDto {
  /** 任务id */
  itemId?: number

  /** 监测点名称 */
  jcdmc?: string

  /** 经度 */
  jd?: string

  /** 监测点类型：1重点监测点，2途径点 */
  type?: number

  /** 纬度 */
  wd?: string
}

export class XhZdjgdDto {
  /** 打卡状态: 1未打卡，2已打卡 */
  dkzt?: number

  /** 经度 */
  jd?: string

  /** 监测点类型：1重点监测点，2途径点 */
  type?: number

  /** 纬度 */
  wd?: string

  /** 监管点名称 */
  zdjgd?: string
}

export class XhdxDto {
  /** 上报事件数量 */
  sbsj?: number

  /** 巡查距离 */
  xcjl?: string

  /** 巡查时长 */
  xcsc?: string
}

export class XhgjReqDto {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 名称 */
  name?: string

  /** 类型 ly，wgy，zj */
  type?: string

  /** userId */
  userId?: number
}

export class XhgjResDto {
  /** 网格员名称 */
  name?: string

  /** 网格员id */
  userId?: number
  xhgjResItemDtos?: XhgjResItemDto[]
}

export class XhgjResItemDto {
  /** 巡查日期 */
  date?: string

  /** 巡查轨迹坐标 */
  gjzb?: any[][]

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 终点经度 */
  zdjd?: string

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string
}

export class XhjlListDto {
  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河里程(米) */
  xhlc?: number

  /** 巡河时长(分) */
  xhsc?: number

  /** 巡河状态 */
  xhztStr?: string
}

export class XhjlReportReqDto {
  /** 巡查开始时间 */
  beginTime!: string

  /** 巡查结束时间 */
  endTime!: string

  /** 巡查人账号 */
  loginName!: string

  /** 巡查任务id */
  taskId!: number

  /** 巡查结果 */
  xhResult?: string

  /** 巡河距离 */
  xhlc!: number
}

export class XhtjBaseStatisticsQuery {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 流域 */
  ly?: string

  /** 用户id */
  userId?: number

  /** 镇街 */
  zj?: string
}

export class XhtjBaseStatisticsVO {
  /** 兼职网格员数量 */
  jzWgyCount?: number

  /** 重点监管点数量 */
  printCount?: number

  /** 网格员总数 */
  wgyTotalCount?: number

  /** 巡河问题结束数量 */
  xhProblemOverCount?: number

  /** 巡河问题总数 */
  xhProblemTotalCount?: number

  /** 专治网格员数量 */
  zzWgyCount?: number
}

export class XhtjDto {
  /** 实巡次数 */
  sx?: number

  /** 实巡人数 */
  sxrs?: number

  /** 巡河里程(km) */
  xhlc?: number

  /** 巡河时长(h) */
  xhsc?: number

  /** 应巡次数 */
  yx?: number

  /** 应巡人数/网格员数 */
  yxrs?: number

  /** 重点监管点数量 */
  zdjgdsl?: number
}

export class XhtjZjBaseStatisticsVo {
  /** 打卡完成率 */
  dkRate?: string

  /** 镇街名称，网格员名称 */
  name?: string

  /** 上报已处理数量 */
  problemResolved?: number

  /** 上报处理中数量 */
  problemResolving?: number

  /** 上报数量 */
  problemTotal?: number

  /** 网格综合巡查完成情况 */
  qualified?: string

  /** 问题处置完成率 */
  resolveRate?: string

  /** 实际打卡次数 */
  sjdk?: number

  /** 实巡里程 */
  sxLc?: number

  /** 数据类型 */
  type?: string

  /** 网格员id */
  userId?: number

  /** 网格员数量 */
  wgyCount?: number

  /** 巡河完成率 */
  xhRate?: string

  /** 巡河有效率 */
  xhValidRate?: string

  /** 应打卡次数 */
  ydk?: number

  /** 应巡里程 */
  yxLc?: number

  /** 重点监管点数量 */
  zdjgd?: number
}

export class XmyzDetailDto {
  ID?: string

  /** 曾用名 */
  cym?: string

  /** 地址 */
  dz?: string

  /** 粪便处理工艺 */
  fbClgy?: string

  /** 法人代表 */
  frdb?: string

  /** 经度 */
  jd?: number

  /** 联系方式 */
  lxfs?: string

  /** 名称 */
  mc?: string

  /** 圈舍清粪方式 */
  qsQffs?: string

  /** 圈舍通风方式 */
  qsTffs?: string

  /** 审核状态 */
  shzt?: any

  /** 设计存栏规模 */
  sjclgm?: any

  /** 纬度 */
  wd?: number

  /** 养殖种类 */
  yzzl?: string
}

export class XqyzDto {
  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  mc?: string

  /** 设计存栏规模 */
  sjclgm?: string

  /** 设计年存栏规模 */
  sjnclgm?: string

  /** 纬度 */
  wd?: string

  /** 养殖种类 */
  yzzl?: string

  /** 镇街 */
  zj?: string
}

export class YcszStatistics {
  /** y轴数据 */
  datas?: string[][]

  /** 时间轴 */
  dateAxis?: string[]

  /** 水质目标 */
  targetList?: string[]
  xaxis?: string[]
}

export class YdTsBasicDTO {
  /** 材质(联通线路) */
  cz?: string

  /** 工程编码 */
  gcbm?: string

  /** 工程备注 */
  gcbz?: any

  /** 工程名称 */
  gcmc?: string

  /** 工程终点 */
  gczd?: string

  /** geometry1 */
  'geometry1'?: string

  /** geometry2 */
  'geometry2'?: string

  /** 管径(联通线路) */
  gj?: any

  /** 联通线路 */
  ltxl?: string

  /** 设计取水量(联通线路) */
  sjqsl?: string
}

export class YhycTaskTJDTO {
  /** 推进说明 */
  content?: string

  /** 推进时间 */
  createTime?: string

  /** 推进人单位 */
  createUserDepartment?: string

  /** 推进人id */
  createUserId?: number

  /** 推进人名称 */
  createUsername?: string

  /** 附件 */
  fileUrl?: string
  fileUrlList?: string[]

  /** 完成率  推进进度 */
  overRate?: string
}

export class YjpkCountStatisticsVO {
  /** 总数 */
  totalCount?: number

  /** 污水排口数量 */
  wspkCount?: number

  /** 雨水排口数量 */
  yspkCount?: number

  /** 雨污混流数量 */
  ywpkCount?: number
}

export class YysMonitorInfoDetailVo {
  /** 是否为保护区 true 是 false 否 */
  bhq?: boolean
  data?: WaterTrendDto[]

  /** 断面名称 */
  dmmc?: string

  /** 监测方式 */
  monitorFunc?: string

  /** 监测类型 */
  monitorType?: string
  nowSz?: string
  nowSzn?: number

  /** 水体类型 */
  stlx?: string

  /** 所在镇街 */
  szzj?: string
  targetSz?: string
  targetSzn?: number

  /** 饮用水源地类型 */
  yysydlx?: string

  /** 供水类型 */
  zdlx?: string
}

export class YysydCountStatisticsVo {
  /** 饼状图数据 */
  statisticsData?: CommonStatisticsDto[]

  /** 总数 */
  total?: number
}

export class YysydGroupByZdlxStatisticsDTO {
  cbCount?: number
  dbCount?: number
  dbRate?: string
  wsjCount?: number
}

export class YysydInfoStatisticsVo {
  /** 标准值(罗马文) */
  bzszlb?: string

  /** 标准值 */
  bzszlbdm?: number

  /** 断面名称 */
  dmmc?: string

  /** 断面id */
  id?: string

  /** 检测时间 */
  jcsj?: string

  /** 经度 */
  jd?: number

  /** 水质评价(罗马文 + '类')  */
  pjjb?: string

  /** 水质评价 */
  pjjbn?: number

  /** 超标状态, null为未知 */
  state?: boolean

  /** 纬度 */
  wd?: number

  /** 站点类型 */
  zdlx?: string
}

export class YysydListQuery {
  keyword?: string

  /** 流域名称 */
  ly?: string

  /** 站点类型(管控级别) */
  zdlx?: string
}

export class ZcfgPageReqDto {
  /** 页码,默认1 */
  page!: number

  /** 每页显示条数,默认10 */
  pageSize!: number

  /** 政策法规标题 */
  title?: string
}

export class ZcfgPageRespDto {
  /** 文件地址 */
  fileUrl?: string

  /** id */
  id?: number

  /** 序号 */
  orderName?: string

  /** 发布时间 */
  publishTime?: string

  /** 标题 */
  title?: string

  /** 河长令类型 */
  type?: string
}

export class ZdgyqyLastDataDto {
  columns?: ParseMessageColumnDto[]
  data?: Record<string, any>[]
}

export class ZdjcdInfoDto {
  /** 重点监测点id */
  id?: number

  /** 责任人巡查分项详情id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 频次 r日 z周 */
  period?: string

  /** 实际打卡次数 */
  sjdk?: number

  /** 纬度 */
  wd?: string

  /** 应打卡次数 */
  ydk?: number

  /** 名称 */
  zdjgd?: string
}

export class ZdpkTableReqDto {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string

  /** 登录用户id（测试用，勿传） */
  loginUserId?: number

  /** 流域 */
  ly?: string

  /** 网格员id */
  wgUserId?: number

  /** 镇街 */
  zj?: string
}

export class ZdpkTableRespDto {
  /** 重点监测点名称 */
  jcdmc?: string
}

export class ZjOrLyDetailQuery {
  /** 查询类型 */
  type?: string
}

export class ZjQuery {
  /** 镇街名称 */
  zj?: string
}

export class ZkProblemFileDto {
  /** 文件名称 */
  fileName?: string

  /** 文件路径 */
  filePath?: string

  /** 文件类型(image,video,audio,doc,other) */
  fileType?: string

  /** 模块id（问题id/流程id） */
  modelId?: string
}

export class ZnzzVO {
  /** 职能职责 */
  content?: string

  /** 名称 */
  name?: string
}

export class ZrhdTableDto {
  /** 起点编号 */
  qdbh?: string

  /** 起点名称 */
  qdmc?: string

  /** 终点编号 */
  zdbh?: string

  /** 终点名称 */
  zdmc?: string
}

export class ProblemReportInfoListQuery {
  /** 开始时间 */
  beginTime!: string

  /** 结束时间 */
  endTime!: string
  id?: string
  type?: string
}

export class JsonResultAiTotalDto {
  code?: number
  data?: AiTotalDto
  msg?: string
}

export class JsonResultCallInfoDto {
  code?: number
  data?: CallInfoDto
  msg?: string
}

export class JsonResultCameraStreamDto {
  code?: number
  data?: CameraStreamDto
  msg?: string
}

export class JsonResultCyqyEntity {
  code?: number
  data?: CyqyEntity
  msg?: string
}

export class JsonResultDfBasicDTO {
  code?: number
  data?: DfBasicDTO
  msg?: string
}

export class JsonResultDfInfoOverviewResDto {
  code?: number
  data?: DfInfoOverviewResDto
  msg?: string
}

export class JsonResultDkStatisticsDTO {
  code?: number
  data?: DkStatisticsDTO
  msg?: string
}

export class JsonResultDmYzDatumLine {
  code?: number
  data?: DmYzDatumLine
  msg?: string
}

export class JsonResultEditLxDto {
  code?: number
  data?: EditLxDto
  msg?: string
}

export class JsonResultEventDetailDto {
  code?: number
  data?: EventDetailDto
  msg?: string
}

export class JsonResultGridInfo {
  code?: number
  data?: GridInfo
  msg?: string
}

export class JsonResultGridXcRecordBaseInfoDto {
  code?: number
  data?: GridXcRecordBaseInfoDto
  msg?: string
}

export class JsonResultGridXcRecordDto {
  code?: number
  data?: GridXcRecordDto
  msg?: string
}

export class JsonResultGyqyInfoPopDto {
  code?: number
  data?: GyqyInfoPopDto
  msg?: string
}

export class JsonResultGywryDto {
  code?: number
  data?: GywryDto
  msg?: string
}

export class JsonResultGyyqEntity {
  code?: number
  data?: GyyqEntity
  msg?: string
}

export class JsonResultGyyqInfoCountStatisticsVo {
  code?: number
  data?: GyyqInfoCountStatisticsVo
  msg?: string
}

export class JsonResultHdspStatisticsDTO {
  code?: number
  data?: HdspStatisticsDTO
  msg?: string
}

export class JsonResultHdtjDto {
  code?: number
  data?: HdtjDto
  msg?: string
}

export class JsonResultHzgzXctjDto {
  code?: number
  data?: HzgzXctjDto
  msg?: string
}

export class JsonResultIndexDto {
  code?: number
  data?: IndexDto
  msg?: string
}

export class JsonResultJhSaveDto {
  code?: number
  data?: JhSaveDto
  msg?: string
}

export class JsonResultKeyValue {
  code?: number
  data?: KeyValue
  msg?: string
}

export class JsonResultLcStatisticsDTO {
  code?: number
  data?: LcStatisticsDTO
  msg?: string
}

export class JsonResultListAiListVo {
  code?: number
  data?: AiListVo[]
  msg?: string
}

export class JsonResultListAreaHkgkDto {
  code?: number
  data?: AreaHkgkDto[]
  msg?: string
}

export class JsonResultListAssessmentRankingsDto {
  code?: number
  data?: AssessmentRankingsDto[]
  msg?: string
}

export class JsonResultListCameraStreamDto {
  code?: number
  data?: CameraStreamDto[]
  msg?: string
}

export class JsonResultListCommonPointVo {
  code?: number
  data?: CommonPointVo[]
  msg?: string
}

export class JsonResultListCommonStatisticsDto {
  code?: number
  data?: CommonStatisticsDto[]
  msg?: string
}

export class JsonResultListCyqyEntity {
  code?: number
  data?: CyqyEntity[]
  msg?: string
}

export class JsonResultListDfBasicDTO {
  code?: number
  data?: DfBasicDTO[]
  msg?: string
}

export class JsonResultListDotMapDto {
  code?: number
  data?: DotMapDto[]
  msg?: string
}

export class JsonResultListDropBoxDto {
  code?: number
  data?: DropBoxDto[]
  msg?: string
}

export class JsonResultListDropBoxIntegerDto {
  code?: number
  data?: DropBoxIntegerDto[]
  msg?: string
}

export class JsonResultListFileDto {
  code?: number
  data?: FileDto[]
  msg?: string
}

export class JsonResultListGridXcRecordReportDto {
  code?: number
  data?: GridXcRecordReportDto[]
  msg?: string
}

export class JsonResultListGyyqInventoryVo {
  code?: number
  data?: GyyqInventoryVo[]
  msg?: string
}

export class JsonResultListGzhProblemDTO {
  code?: number
  data?: GzhProblemDTO[]
  msg?: string
}

export class JsonResultListHdspListDto {
  code?: number
  data?: HdspListDto[]
  msg?: string
}

export class JsonResultListHdspTreeDTO {
  code?: number
  data?: HdspTreeDTO[]
  msg?: string
}

export class JsonResultListHlApiDto {
  code?: number
  data?: HlApiDto[]
  msg?: string
}

export class JsonResultListHomeDropSelect {
  code?: number
  data?: HomeDropSelect[]
  msg?: string
}

export class JsonResultListHzListVO {
  code?: number
  data?: HzListVO[]
  msg?: string
}

export class JsonResultListHzddProblemListDto {
  code?: number
  data?: HzddProblemListDto[]
  msg?: string
}

export class JsonResultListHztjDto {
  code?: number
  data?: HztjDto[]
  msg?: string
}

export class JsonResultListHzxxMbItemPrint {
  code?: number
  data?: HzxxMbItemPrint[]
  msg?: string
}

export class JsonResultListIndexMyTaskListDto {
  code?: number
  data?: IndexMyTaskListDto[]
  msg?: string
}

export class JsonResultListJSONArray {
  code?: number
  data?: any[][]
  msg?: string
}

export class JsonResultListJSONObject {
  code?: number
  data?: Record<string, any>[]
  msg?: string
}

export class JsonResultListKeyValue {
  code?: number
  data?: KeyValue[]
  msg?: string
}

export class JsonResultListLyhdDto {
  code?: number
  data?: LyhdDto[]
  msg?: string
}

export class JsonResultListMapStringObject {
  code?: number
  data?: Record<string, any>[]
  msg?: string
}

export class JsonResultListMapStringString {
  code?: number
  data?: Record<string, string>[]
  msg?: string
}

export class JsonResultListMbDto {
  code?: number
  data?: MbDto[]
  msg?: string
}

export class JsonResultListMonitorDataListDto {
  code?: number
  data?: MonitorDataListDto[]
  msg?: string
}

export class JsonResultListMonitorVideoDto {
  code?: number
  data?: MonitorVideoDto[]
  msg?: string
}

export class JsonResultListMontiroObjDto {
  code?: number
  data?: MontiroObjDto[]
  msg?: string
}

export class JsonResultListNmscEntity {
  code?: number
  data?: NmscEntity[]
  msg?: string
}

export class JsonResultListOnlineWgyItemInfoDto {
  code?: number
  data?: OnlineWgyItemInfoDto[]
  msg?: string
}

export class JsonResultListOrgTree {
  code?: number
  data?: OrgTree[]
  msg?: string
}

export class JsonResultListPkListVo {
  code?: number
  data?: PkListVo[]
  msg?: string
}

export class JsonResultListProblemPointVO {
  code?: number
  data?: ProblemPointVO[]
  msg?: string
}

export class JsonResultListProblemReportDetailVO {
  code?: number
  data?: ProblemReportDetailVO[]
  msg?: string
}

export class JsonResultListProblemReportStatisticsVO {
  code?: number
  data?: ProblemReportStatisticsVO[]
  msg?: string
}

export class JsonResultListQskInfoDto {
  code?: number
  data?: QskInfoDto[]
  msg?: string
}

export class JsonResultListQyxhtjDto {
  code?: number
  data?: QyxhtjDto[]
  msg?: string
}

export class JsonResultListRankingsListDtos {
  code?: number
  data?: RankingsListDtos[]
  msg?: string
}

export class JsonResultListRiverInfoDto {
  code?: number
  data?: RiverInfoDto[]
  msg?: string
}

export class JsonResultListRiverLeaderTreeDto {
  code?: number
  data?: RiverLeaderTreeDto[]
  msg?: string
}

export class JsonResultListRiverListDTO {
  code?: number
  data?: RiverListDTO[]
  msg?: string
}

export class JsonResultListSceenWgyXhRecordDto {
  code?: number
  data?: SceenWgyXhRecordDto[]
  msg?: string
}

export class JsonResultListScyzDto {
  code?: number
  data?: ScyzDto[]
  msg?: string
}

export class JsonResultListSgnqListVo {
  code?: number
  data?: SgnqListVo[]
  msg?: string
}

export class JsonResultListSgnqPieVo {
  code?: number
  data?: SgnqPieVo[]
  msg?: string
}

export class JsonResultListSkListDTO {
  code?: number
  data?: SkListDTO[]
  msg?: string
}

export class JsonResultListStatisticsCountDto {
  code?: number
  data?: StatisticsCountDto[]
  msg?: string
}

export class JsonResultListStatisticsCountUnitDto {
  code?: number
  data?: StatisticsCountUnitDto[]
  msg?: string
}

export class JsonResultListStatisticsLcPieVo {
  code?: number
  data?: StatisticsLcPieVo[]
  msg?: string
}

export class JsonResultListStatisticsPieVo {
  code?: number
  data?: StatisticsPieVo[]
  msg?: string
}

export class JsonResultListStreamApiDto {
  code?: number
  data?: StreamApiDto[]
  msg?: string
}

export class JsonResultListSwrDto {
  code?: number
  data?: SwrDto[]
  msg?: string
}

export class JsonResultListSwslSsjcDto {
  code?: number
  data?: SwslSsjcDto[]
  msg?: string
}

export class JsonResultListSxTableDto {
  code?: number
  data?: SxTableDto[]
  msg?: string
}

export class JsonResultListSzHistoryDto {
  code?: number
  data?: SzHistoryDto[]
  msg?: string
}

export class JsonResultListSzInfoDto {
  code?: number
  data?: SzInfoDto[]
  msg?: string
}

export class JsonResultListTaskListVO {
  code?: number
  data?: TaskListVO[]
  msg?: string
}

export class JsonResultListTmpIndexDto {
  code?: number
  data?: TmpIndexDto[]
  msg?: string
}

export class JsonResultListTreeDto {
  code?: number
  data?: TreeDto[]
  msg?: string
}

export class JsonResultListTypeStatisticsCountDTO {
  code?: number
  data?: TypeStatisticsCountDTO[]
  msg?: string
}

export class JsonResultListVideoIndexDto {
  code?: number
  data?: VideoIndexDto[]
  msg?: string
}

export class JsonResultListWgyCountByZjDTO {
  code?: number
  data?: WgyCountByZjDTO[]
  msg?: string
}

export class JsonResultListWgyDto {
  code?: number
  data?: WgyDto[]
  msg?: string
}

export class JsonResultListWgyTableDto {
  code?: number
  data?: WgyTableDto[]
  msg?: string
}

export class JsonResultListWgyTableRespDto {
  code?: number
  data?: WgyTableRespDto[]
  msg?: string
}

export class JsonResultListWgyWtIndexDto {
  code?: number
  data?: WgyWtIndexDto[]
  msg?: string
}

export class JsonResultListWgyWtRecordDto {
  code?: number
  data?: WgyWtRecordDto[]
  msg?: string
}

export class JsonResultListWgyWwcxhListDto {
  code?: number
  data?: WgyWwcxhListDto[]
  msg?: string
}

export class JsonResultListWgyXhCountDto {
  code?: number
  data?: WgyXhCountDto[]
  msg?: string
}

export class JsonResultListWgyXhCountInfoDto {
  code?: number
  data?: WgyXhCountInfoDto[]
  msg?: string
}

export class JsonResultListWgyXhGridByZjDto {
  code?: number
  data?: WgyXhGridByZjDto[]
  msg?: string
}

export class JsonResultListWgyXhGroupByZjDto {
  code?: number
  data?: WgyXhGroupByZjDto[]
  msg?: string
}

export class JsonResultListWgyXhInfoStatisticsDto {
  code?: number
  data?: WgyXhInfoStatisticsDto[]
  msg?: string
}

export class JsonResultListWrjFlyRecordDTO {
  code?: number
  data?: WrjFlyRecordDTO[]
  msg?: string
}

export class JsonResultListWsclcGraphDto {
  code?: number
  data?: WsclcGraphDto[]
  msg?: string
}

export class JsonResultListWsclcInfoItemsDto {
  code?: number
  data?: WsclcInfoItemsDto[]
  msg?: string
}

export class JsonResultListWtTableDto {
  code?: number
  data?: WtTableDto[]
  msg?: string
}

export class JsonResultListWtczZjGroupDto {
  code?: number
  data?: WtczZjGroupDto[]
  msg?: string
}

export class JsonResultListWtsbqkTableRespDto {
  code?: number
  data?: WtsbqkTableRespDto[]
  msg?: string
}

export class JsonResultListWwcxhrTableDto {
  code?: number
  data?: WwcxhrTableDto[]
  msg?: string
}

export class JsonResultListXcListDto {
  code?: number
  data?: XcListDto[]
  msg?: string
}

export class JsonResultListXcfwDto {
  code?: number
  data?: XcfwDto[]
  msg?: string
}

export class JsonResultListXcjlDto {
  code?: number
  data?: XcjlDto[]
  msg?: string
}

export class JsonResultListXhIndexDto {
  code?: number
  data?: XhIndexDto[]
  msg?: string
}

export class JsonResultListXhStatisticsRateWithZjDto {
  code?: number
  data?: XhStatisticsRateWithZjDto[]
  msg?: string
}

export class JsonResultListXhTaskInfoRespDto {
  code?: number
  data?: XhTaskInfoRespDto[]
  msg?: string
}

export class JsonResultListXhgjResDto {
  code?: number
  data?: XhgjResDto[]
  msg?: string
}

export class JsonResultListXhjlListDto {
  code?: number
  data?: XhjlListDto[]
  msg?: string
}

export class JsonResultListXhtjZjBaseStatisticsVo {
  code?: number
  data?: XhtjZjBaseStatisticsVo[]
  msg?: string
}

export class JsonResultListXqyzDto {
  code?: number
  data?: XqyzDto[]
  msg?: string
}

export class JsonResultListYdTsBasicDTO {
  code?: number
  data?: YdTsBasicDTO[]
  msg?: string
}

export class JsonResultListYysydGroupByZdlxStatisticsDTO {
  code?: number
  data?: YysydGroupByZdlxStatisticsDTO[]
  msg?: string
}

export class JsonResultListYysydInfoStatisticsVo {
  code?: number
  data?: YysydInfoStatisticsVo[]
  msg?: string
}

export class JsonResultListZdjcdInfoDto {
  code?: number
  data?: ZdjcdInfoDto[]
  msg?: string
}

export class JsonResultListZdpkTableRespDto {
  code?: number
  data?: ZdpkTableRespDto[]
  msg?: string
}

export class JsonResultListZnzzVO {
  code?: number
  data?: ZnzzVO[]
  msg?: string
}

export class JsonResultListZrhdTableDto {
  code?: number
  data?: ZrhdTableDto[]
  msg?: string
}

export class JsonResultListString {
  code?: number
  data?: string[]
  msg?: string
}

export class JsonResultLyTotalDetailDto {
  code?: number
  data?: LyTotalDetailDto
  msg?: string
}

export class JsonResultLygkCountStatisticsVo {
  code?: number
  data?: LygkCountStatisticsVo
  msg?: string
}

export class JsonResultMapStringInt {
  code?: number
  data?: Record<string, number>
  msg?: string
}

export class JsonResultMbItemSaveDto {
  code?: number
  data?: MbItemSaveDto
  msg?: string
}

export class JsonResultMonitorVideoTerminalDto {
  code?: number
  data?: MonitorVideoTerminalDto
  msg?: string
}

export class JsonResultMyEventResponseDto {
  code?: number
  data?: MyEventResponseDto
  msg?: string
}

export class JsonResultMyPatrolDto {
  code?: number
  data?: MyPatrolDto
  msg?: string
}

export class JsonResultNmscEntity {
  code?: number
  data?: NmscEntity
  msg?: string
}

export class JsonResultNoticeContentInfoDto {
  code?: number
  data?: NoticeContentInfoDto
  msg?: string
}

export class JsonResultNywryDto {
  code?: number
  data?: NywryDto
  msg?: string
}

export class JsonResultOneRiverOnePlanStatisticsVo {
  code?: number
  data?: OneRiverOnePlanStatisticsVo
  msg?: string
}

export class JsonResultPageListAiProblemListDto {
  code?: number
  data?: PageListAiProblemListDto
  msg?: string
}

export class JsonResultPageListEventListDto {
  code?: number
  data?: PageListEventListDto
  msg?: string
}

export class JsonResultPageListJhPageDto {
  code?: number
  data?: PageListJhPageDto
  msg?: string
}

export class JsonResultPageListMbItemPageDto {
  code?: number
  data?: PageListMbItemPageDto
  msg?: string
}

export class JsonResultPageListMonitorVideoTerminalDto {
  code?: number
  data?: PageListMonitorVideoTerminalDto
  msg?: string
}

export class JsonResultPageListNoticeContentListDto {
  code?: number
  data?: PageListNoticeContentListDto
  msg?: string
}

export class JsonResultPageListRpcEventInstancePageDto {
  code?: number
  data?: PageListRpcEventInstancePageDto
  msg?: string
}

export class JsonResultPageListSKeyTaskResolveDto {
  code?: number
  data?: PageListSKeyTaskResolveDto
  msg?: string
}

export class JsonResultPageListWgyYxMbDto {
  code?: number
  data?: PageListWgyYxMbDto
  msg?: string
}

export class JsonResultPageListWtczListDto {
  code?: number
  data?: PageListWtczListDto
  msg?: string
}

export class JsonResultPageListXcjlPageDto {
  code?: number
  data?: PageListXcjlPageDto
  msg?: string
}

export class JsonResultPageListXhRecordInfoRespDto {
  code?: number
  data?: PageListXhRecordInfoRespDto
  msg?: string
}

export class JsonResultPageListXhTaskInfoRespDto {
  code?: number
  data?: PageListXhTaskInfoRespDto
  msg?: string
}

export class JsonResultPageListZcfgPageRespDto {
  code?: number
  data?: PageListZcfgPageRespDto
  msg?: string
}

export class JsonResultPcXhtjDto {
  code?: number
  data?: PcXhtjDto
  msg?: string
}

export class JsonResultProblemCountClassifiedStatisticsDTO {
  code?: number
  data?: ProblemCountClassifiedStatisticsDTO
  msg?: string
}

export class JsonResultProblemCountStatisticsDTO {
  code?: number
  data?: ProblemCountStatisticsDTO
  msg?: string
}

export class JsonResultProblemDataStatisticsVO {
  code?: number
  data?: ProblemDataStatisticsVO
  msg?: string
}

export class JsonResultProblemStatisticsDTO {
  code?: number
  data?: ProblemStatisticsDTO
  msg?: string
}

export class JsonResultPunchCardVO {
  code?: number
  data?: PunchCardVO
  msg?: string
}

export class JsonResultQskInfoListDTO {
  code?: number
  data?: QskInfoListDTO
  msg?: string
}

export class JsonResultRankingTimesDto {
  code?: number
  data?: RankingTimesDto
  msg?: string
}

export class JsonResultRankingsFileRespDto {
  code?: number
  data?: RankingsFileRespDto
  msg?: string
}

export class JsonResultRiverDetailDTO {
  code?: number
  data?: RiverDetailDTO
  msg?: string
}

export class JsonResultRiverLeaderStatisticsVo {
  code?: number
  data?: RiverLeaderStatisticsVo
  msg?: string
}

export class JsonResultSceenWgyXhDto {
  code?: number
  data?: SceenWgyXhDto
  msg?: string
}

export class JsonResultScyzDetailDto {
  code?: number
  data?: ScyzDetailDto
  msg?: string
}

export class JsonResultSgDmPopVo {
  code?: number
  data?: SgDmPopVo
  msg?: string
}

export class JsonResultSgnqCountByLevelVo {
  code?: number
  data?: SgnqCountByLevelVo
  msg?: string
}

export class JsonResultSkDetailDTO {
  code?: number
  data?: SkDetailDTO
  msg?: string
}

export class JsonResultSkInfoDto {
  code?: number
  data?: SkInfoDto
  msg?: string
}

export class JsonResultSkInfoOverviewResDto {
  code?: number
  data?: SkInfoOverviewResDto
  msg?: string
}

export class JsonResultSkSzMonitorDTO {
  code?: number
  data?: SkSzMonitorDTO
  msg?: string
}

export class JsonResultSwSiteStandardLineVo {
  code?: number
  data?: SwSiteStandardLineVo
  msg?: string
}

export class JsonResultSwslSiteInfo {
  code?: number
  data?: SwslSiteInfo
  msg?: string
}

export class JsonResultSwslZdtjDto {
  code?: number
  data?: SwslZdtjDto
  msg?: string
}

export class JsonResultSyaxExDto {
  code?: number
  data?: SyaxExDto
  msg?: string
}

export class JsonResultSzDetailDto {
  code?: number
  data?: SzDetailDto
  msg?: string
}

export class JsonResultSzInfoDto {
  code?: number
  data?: SzInfoDto
  msg?: string
}

export class JsonResultSzInfoOverviewResDto {
  code?: number
  data?: SzInfoOverviewResDto
  msg?: string
}

export class JsonResultSzySiteCountStatisticsDTO {
  code?: number
  data?: SzySiteCountStatisticsDTO
  msg?: string
}

export class JsonResultTargetTaskCountStatisticsVo {
  code?: number
  data?: TargetTaskCountStatisticsVo
  msg?: string
}

export class JsonResultTaskDetailDTO {
  code?: number
  data?: TaskDetailDTO
  msg?: string
}

export class JsonResultWaterAssessmentDto {
  code?: number
  data?: WaterAssessmentDto
  msg?: string
}

export class JsonResultWaterAssessmentSectionInfoResultDto {
  code?: number
  data?: WaterAssessmentSectionInfoResultDto
  msg?: string
}

export class JsonResultWaterPollutionOnlineDto {
  code?: number
  data?: WaterPollutionOnlineDto
  msg?: string
}

export class JsonResultWgyCountStatisticsDTO {
  code?: number
  data?: WgyCountStatisticsDTO
  msg?: string
}

export class JsonResultWgyCountStatisticsVo {
  code?: number
  data?: WgyCountStatisticsVo
  msg?: string
}

export class JsonResultWgyDkCountDto {
  code?: number
  data?: WgyDkCountDto
  msg?: string
}

export class JsonResultWgyWtczDto {
  code?: number
  data?: WgyWtczDto
  msg?: string
}

export class JsonResultWgyXhStatisticsDto {
  code?: number
  data?: WgyXhStatisticsDto
  msg?: string
}

export class JsonResultWgyYxMbDto {
  code?: number
  data?: WgyYxMbDto
  msg?: string
}

export class JsonResultWrjFLyStatisticsDTO {
  code?: number
  data?: WrjFLyStatisticsDTO
  msg?: string
}

export class JsonResultWrjFlightRecordDto {
  code?: number
  data?: WrjFlightRecordDto
  msg?: string
}

export class JsonResultWrjStatisticsDto {
  code?: number
  data?: WrjStatisticsDto
  msg?: string
}

export class JsonResultWsclcDetailDto {
  code?: number
  data?: WsclcDetailDto
  msg?: string
}

export class JsonResultWttjDto {
  code?: number
  data?: WttjDto
  msg?: string
}

export class JsonResultXcfwDto {
  code?: number
  data?: XcfwDto
  msg?: string
}

export class JsonResultXcjlInfoDto {
  code?: number
  data?: XcjlInfoDto
  msg?: string
}

export class JsonResultXhGjInfoDto {
  code?: number
  data?: XhGjInfoDto
  msg?: string
}

export class JsonResultXhProblemStatisticsVo {
  code?: number
  data?: XhProblemStatisticsVo
  msg?: string
}

export class JsonResultXhtjBaseStatisticsVO {
  code?: number
  data?: XhtjBaseStatisticsVO
  msg?: string
}

export class JsonResultXhtjDto {
  code?: number
  data?: XhtjDto
  msg?: string
}

export class JsonResultXmyzDetailDto {
  code?: number
  data?: XmyzDetailDto
  msg?: string
}

export class JsonResultYcszStatistics {
  code?: number
  data?: YcszStatistics
  msg?: string
}

export class JsonResultYjpkCountStatisticsVO {
  code?: number
  data?: YjpkCountStatisticsVO
  msg?: string
}

export class JsonResultYysMonitorInfoDetailVo {
  code?: number
  data?: YysMonitorInfoDetailVo
  msg?: string
}

export class JsonResultYysydCountStatisticsVo {
  code?: number
  data?: YysydCountStatisticsVo
  msg?: string
}

export class JsonResultZdgyqyLastDataDto {
  code?: number
  data?: ZdgyqyLastDataDto
  msg?: string
}

export class JsonResultZnzzVO {
  code?: number
  data?: ZnzzVO
  msg?: string
}

export class JsonResultBoolean {
  code?: number
  data?: boolean
  msg?: string
}

export class JsonResultInt {
  code?: number
  data?: number
  msg?: string
}

export class JsonResultLong {
  code?: number
  data?: number
  msg?: string
}

export class JsonResultObject {
  code?: number
  data?: any
  msg?: string
}

export class JsonResultString {
  code?: number
  data?: string
  msg?: string
}

export class PageListAiProblemListDto {
  /** 当前页相关数据 */
  items?: AiProblemListDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListEventListDto {
  /** 当前页相关数据 */
  items?: EventListDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListJhPageDto {
  /** 当前页相关数据 */
  items?: JhPageDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListMbItemPageDto {
  /** 当前页相关数据 */
  items?: MbItemPageDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListMonitorVideoTerminalDto {
  /** 当前页相关数据 */
  items?: MonitorVideoTerminalDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListNoticeContentListDto {
  /** 当前页相关数据 */
  items?: NoticeContentListDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListRpcEventInstancePageDto {
  /** 当前页相关数据 */
  items?: RpcEventInstancePageDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListSKeyTaskResolveDto {
  /** 当前页相关数据 */
  items?: SKeyTaskResolveDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListWgyYxMbDto {
  /** 当前页相关数据 */
  items?: WgyYxMbDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListWtczListDto {
  /** 当前页相关数据 */
  items?: WtczListDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListXcjlPageDto {
  /** 当前页相关数据 */
  items?: XcjlPageDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListXhRecordInfoRespDto {
  /** 当前页相关数据 */
  items?: XhRecordInfoRespDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListXhTaskInfoRespDto {
  /** 当前页相关数据 */
  items?: XhTaskInfoRespDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListZcfgPageRespDto {
  /** 当前页相关数据 */
  items?: ZcfgPageRespDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

/**
 * @title 环投网络流域公众服务平台接口文档
 * @version 1.0
 * @baseUrl //119.84.149.201/api/grid
 * 本文档描述了接口定义规范
 */
export class Api<SecurityDataType = any> extends ApiBase {
  aivideo = {
    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name AiAnalysisStatisticsUsingPost
     * @summary AI分析报警—统计
     * @request POST:/aivideo/aiAnalysisStatistics
     */
    aiAnalysisStatisticsUsingPost: (dto: AiTotalReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultAiTotalDto>(`/aivideo/aiAnalysisStatistics`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name AiProblemListUsingPost
     * @summary AI分析报警/预警报警信息—报警列表
     * @request POST:/aivideo/aiProblemList
     */
    aiProblemListUsingPost: (dto: AiPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListAiProblemListDto>(
        `/aivideo/aiProblemList`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name GetCameraStreamsUsingPost
     * @summary 摄像头视频流数据获取
     * @request POST:/aivideo/cameraStreams
     */
    getCameraStreamsUsingPost: (cameraIds: string[], cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(`/aivideo/cameraStreams`, 'POST', cameraIds, cancelToken),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name CameraYsyStreamsUsingPost
     * @summary 摄像头萤石云视频流获取
     * @request POST:/aivideo/cameraYsyStreams
     */
    cameraYsyStreamsUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCameraStreamDto>(
        `/aivideo/cameraYsyStreams`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name ControllingUsingPost
     * @summary 操作摄像头
     * @request POST:/aivideo/controlling
     */
    controllingUsingPost: (commandDto: CommandDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/aivideo/controlling`, 'POST', commandDto, cancelToken),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name DetailUsingGet
     * @summary 告警详情
     * @request GET:/aivideo/detail
     */
    detailUsingGet: (query: { id: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(
        `/aivideo/detail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name MonitorObjUsingPost
     * @summary 监测对象
     * @request POST:/aivideo/monitorObj
     */
    monitorObjUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMontiroObjDto>(`/aivideo/monitorObj`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name GetMonitorVideoUsingPost
     * @summary 视频监控
     * @request POST:/aivideo/monitorVideo
     */
    getMonitorVideoUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMonitorVideoDto>(
        `/aivideo/monitorVideo`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name MonitorVideoExUsingPost
     * @summary 视频监控扩展
     * @request POST:/aivideo/monitorVideoEx
     */
    monitorVideoExUsingPost: (dto: MonitorVideoExReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMonitorVideoDto>(
        `/aivideo/monitorVideoEx`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags ai视频管理专题
     * @name VideoPrintUsingPost
     * @summary 视频点位
     * @request POST:/aivideo/videoPrint
     */
    videoPrintUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListVideoIndexDto>(`/aivideo/videoPrint`, 'POST', null, cancelToken),
  }
  app = {
    /**
     * No description
     *
     * @tags app巡查呼叫接口
     * @name CalcUserSigUsingGet
     * @summary 计算UserSig
     * @request GET:/app/call/calcUserSig
     */
    calcUserSigUsingGet: (
      query: { expire: number; userId: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultString>(
        `/app/call/calcUserSig${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app巡查呼叫接口
     * @name ChangeStatusUsingPost
     * @summary 修改状态
     * @request POST:/app/call/changeStatus
     */
    changeStatusUsingPost: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/app/call/changeStatus`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags app巡查呼叫接口
     * @name CloseUsingPost1
     * @summary 挂断
     * @request POST:/app/call/close
     */
    closeUsingPost1: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/app/call/close`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags app巡查呼叫接口
     * @name CreateUsingPost1
     * @summary 创建用户呼叫状态
     * @request POST:/app/call/create
     */
    createUsingPost1: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/app/call/create`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags app巡查呼叫接口
     * @name GetChannelInfoUsingGet
     * @summary 获取用户状态
     * @request GET:/app/call/getChannelInfo
     */
    getChannelInfoUsingGet: (
      query?: { testUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultCallInfoDto>(
        `/app/call/getChannelInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app巡查呼叫接口
     * @name GetStatusUsingGet1
     * @summary 根据房间号获取房间状态
     * @request GET:/app/call/getStatus
     */
    getStatusUsingGet1: (query: { channelNo: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCallInfoDto>(
        `/app/call/getStatus${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 河库信息
     * @name GetRiverDetailByIdUsingPost2
     * @summary 河流--河流等级
     * @request POST:/app/hkxx/riverDetailById
     */
    getRiverDetailByIdUsingPost2: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRiverDetailDTO>(
        `/app/hkxx/riverDetailById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 河库信息
     * @name GetRiverLevelUsingPost2
     * @summary 河流--河流等级
     * @request POST:/app/hkxx/riverLevel
     */
    getRiverLevelUsingPost2: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/app/hkxx/riverLevel`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags app端 河库信息
     * @name GetRiverListUsingPost2
     * @summary 河流--河流列表
     * @request POST:/app/hkxx/riverList
     */
    getRiverListUsingPost2: (query: RiverQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverListDTO>(`/app/hkxx/riverList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端 河库信息
     * @name GetSkDetailByIdUsingPost2
     * @summary 湖库--水库详情
     * @request POST:/app/hkxx/skDetailById
     */
    getSkDetailByIdUsingPost2: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSkDetailDTO>(`/app/hkxx/skDetailById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端 河库信息
     * @name GetSkLevelUsingPost2
     * @summary 湖库--水库等级(规模)
     * @request POST:/app/hkxx/skLevel
     */
    getSkLevelUsingPost2: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/app/hkxx/skLevel`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags app端 河库信息
     * @name GetSkListUsingPost2
     * @summary 湖库--水库列表
     * @request POST:/app/hkxx/skList
     */
    getSkListUsingPost2: (query: HkListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSkListDTO>(`/app/hkxx/skList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端 河长体系
     * @name GetHzListByLevelNameUsingPost2
     * @summary 河长组织-名录（名单）
     * @request POST:/app/hztx/hzListByLevelName
     */
    getHzListByLevelNameUsingPost2: (
      query: HzLevelNameQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHzListVO>(
        `/app/hztx/hzListByLevelName`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 河长体系
     * @name GetHzCountStatisticsUsingPost3
     * @summary 河长组织--数据概览
     * @request POST:/app/hztx/hzStatistics
     */
    getHzCountStatisticsUsingPost3: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/app/hztx/hzStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 河长体系
     * @name GetHzTypeSelectUsingPost2
     * @summary 河长组织-河长类型下拉
     * @request POST:/app/hztx/hzTypeSelect
     */
    getHzTypeSelectUsingPost2: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/app/hztx/hzTypeSelect`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags app端 河长体系
     * @name GetZnzzUsingPost4
     * @summary 河长组织--职能职责
     * @request POST:/app/hztx/hzZnzz
     */
    getZnzzUsingPost4: (query: HzLevelNameQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZnzzVO>(`/app/hztx/hzZnzz`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端 河长体系
     * @name GetWgyStatisticsUsingPost2
     * @summary 网格员组织--数据概览
     * @request POST:/app/hztx/wgyStatistics
     */
    getWgyStatisticsUsingPost2: (
      query: WgyStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyCountStatisticsDTO>(
        `/app/hztx/wgyStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 河长体系
     * @name GetZnzzUsingPost3
     * @summary 网格员组织--职能职责
     * @request POST:/app/hztx/wgyZnzz
     */
    getZnzzUsingPost3: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZnzzVO>(`/app/hztx/wgyZnzz`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags app端“首页”接口
     * @name MyTaskUsingGet
     * @summary 首页我的任务
     * @request GET:/app/index/myTask
     */
    myTaskUsingGet: (query?: { zrrUserId?: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListIndexMyTaskListDto>(
        `/app/index/myTask${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“首页”接口
     * @name MyTaskCountUsingGet
     * @summary 首页我的待处理任务统计
     * @request GET:/app/index/myTaskCount
     */
    myTaskCountUsingGet: (query?: { zrrUserId?: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(
        `/app/index/myTaskCount${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“首页”接口
     * @name OnlineUserCountUsingGet
     * @summary 在线人数接口
     * @request GET:/app/index/onlineUserCount
     */
    onlineUserCountUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLong>(`/app/index/onlineUserCount`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags app端“我的任务”接口
     * @name OrgTreeUsingGet
     * @summary 任务交办对象
     * @request GET:/app/rw/orgTree
     */
    orgTreeUsingGet: (
      query?: { original?: string; tag?: number; useObj?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListOrgTree>(
        `/app/rw/orgTree${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“我的问题”接口
     * @name DqhlhdUsingGet
     * @summary 所属河流河段
     * @request GET:/app/sj/event/dqhlhd
     */
    dqhlhdUsingGet: (query?: { zrrUserId?: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/app/sj/event/dqhlhd${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“我的问题”接口
     * @name JjcdUsingGet
     * @summary 紧急程度下拉
     * @request GET:/app/sj/jjcd
     */
    jjcdUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/app/sj/jjcd`, 'GET', null, cancelToken),

    /**
     * @description 我的问题列表
     *
     * @tags app端“我的问题”接口
     * @name MyEventListUsingGet
     * @summary 我的问题列表
     * @request GET:/app/sj/myEventList
     */
    myEventListUsingGet: (
      query?: {
        eventStatus?: number
        name?: string
        page?: number
        size?: number
        xcfw?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultMyEventResponseDto>(
        `/app/sj/myEventList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“我的问题”接口
     * @name OrgTreeUsingGet1
     * @summary 问题交办对象
     * @request GET:/app/sj/orgTree
     */
    orgTreeUsingGet1: (
      query?: { original?: string; tag?: number; useObj?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListOrgTree>(
        `/app/sj/orgTree${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“我的问题”接口
     * @name ProblemReportUsingPost
     * @summary 问题上报（已经弃用）
     * @request POST:/app/sj/problem/report
     */
    problemReportUsingPost: (
      dto: XcItemDetailEventDto,
      query?: { zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResult>(
        `/app/sj/problem/report${this.addQueryParams(query)}`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“我的问题”接口
     * @name SjlbUsingGet
     * @summary 问题类别下拉
     * @request GET:/app/sj/sjlb
     */
    sjlbUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/app/sj/sjlb`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags app端“我的问题”接口
     * @name GetXcfwUsingGet
     * @summary 通过巡河时id获取巡查范围
     * @request GET:/app/sj/xcfw
     */
    getXcfwUsingGet: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXcfwDto>(
        `/app/sj/xcfw${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name FindLyByZjUsingGet
     * @summary 通过镇街查询流域
     * @request GET:/app/tjfx/findLyByZj
     */
    findLyByZjUsingGet: (query?: { zj?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStreamApiDto>(
        `/app/tjfx/findLyByZj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name FindZjByLyUsingGet
     * @summary 通过流域查询镇街
     * @request GET:/app/tjfx/findZjByLy
     */
    findZjByLyUsingGet: (
      query?: { ly?: string; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListString>(
        `/app/tjfx/findZjByLy${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetUserRoleUsingGet
     * @summary 获取登录人是河长办还是镇街
     * @request GET:/app/tjfx/getUserRole
     */
    getUserRoleUsingGet: (query?: { zrrUserId?: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(
        `/app/tjfx/getUserRole${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name WtczList2ZjUsingGet
     * @summary 问题处置情况-镇街用户
     * @request GET:/app/tjfx/getWtczList2Zj
     */
    wtczList2ZjUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        page?: number
        size?: number
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPageListWtczListDto>(
        `/app/tjfx/getWtczList2Zj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetWtczZjGroup2HzbUsingGet
     * @summary 问题处置情况-河长办用户
     * @request GET:/app/tjfx/getWtczZjGroup2Hzb
     */
    getWtczZjGroup2HzbUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWtczZjGroupDto>(
        `/app/tjfx/getWtczZjGroup2Hzb${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name HdtjUsingGet
     * @summary 河段河长/河段统计
     * @request GET:/app/tjfx/hdhz/hdtj
     */
    hdtjUsingGet: (query?: { zrrUserId?: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultHdtjDto>(
        `/app/tjfx/hdhz/hdtj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name HztjUsingGet
     * @summary 河段河长/河长统计
     * @request GET:/app/tjfx/hdhz/hztj
     */
    hztjUsingGet: (
      query?: { hzjb?: string; lymc?: string; tab?: number; zjmc?: string; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHztjDto>(
        `/app/tjfx/hdhz/hztj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name HzlevelUsingGet
     * @summary 河长级别下拉
     * @request GET:/app/tjfx/hzlevel
     */
    hzlevelUsingGet: (query?: { isHz?: boolean }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/app/tjfx/hzlevel${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 展示在app巡查记录专题下
     *
     * @tags app端“统计分析”接口
     * @name PersonalStatisticsUsingPost
     * @summary 个人巡河统计
     * @request POST:/app/tjfx/personalStatistics
     */
    personalStatisticsUsingPost: (
      dto: AppPersonalStatisticsReqDto,
      query?: { testUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXhtjZjBaseStatisticsVo>(
        `/app/tjfx/personalStatistics${this.addQueryParams(query)}`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name QyxhtjUsingGet
     * @summary 区域巡河统计
     * @request GET:/app/tjfx/qyxhtj
     */
    qyxhtjUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        userId?: number
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListQyxhtjDto>(
        `/app/tjfx/qyxhtj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name WgyUsingGet
     * @summary 网格员下拉
     * @request GET:/app/tjfx/wgy
     */
    wgyUsingGet: (
      query?: { ly?: string; name?: string; xcfw?: string; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyDto>(
        `/app/tjfx/wgy${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name WttjUsingGet
     * @summary 问题统计
     * @request GET:/app/tjfx/wttj
     */
    wttjUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWttjDto>(
        `/app/tjfx/wttj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name WttjTableUsingGet
     * @summary 问题统计-处理中/未处理列表
     * @request GET:/app/tjfx/wttjTable
     */
    wttjTableUsingGet: (
      query: {
        begin?: string
        column?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWtTableDto>(
        `/app/tjfx/wttjTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name WwcxhrListUsingGet
     * @summary 未完成巡河人员名单
     * @request GET:/app/tjfx/wwcxhrList
     */
    wwcxhrListUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        userId?: number
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWwcxhrTableDto>(
        `/app/tjfx/wwcxhrList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name XcfwUsingGet
     * @summary 巡查范围下拉
     * @request GET:/app/tjfx/xcfw
     */
    xcfwUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringString>(`/app/tjfx/xcfw`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name XhjlListUsingGet
     * @summary 网格员巡河记录清单
     * @request GET:/app/tjfx/xhjlList
     */
    xhjlListUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        userId?: number
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXhjlListDto>(
        `/app/tjfx/xhjlList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name XhtjUsingGet
     * @summary 巡河统计
     * @request GET:/app/tjfx/xhtj
     */
    xhtjUsingGet: (
      query: {
        begin?: string
        end?: string
        flag: string
        hzjb?: string
        lymc?: string
        userId?: number
        xcfw?: string
        zjmc?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultXhtjDto>(
        `/app/tjfx/xhtj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetBaseDataStatisticsUsingPost1
     * @summary 综合概览统计
     * @request POST:/app/tjfx2/baseDataStatistics
     */
    getBaseDataStatisticsUsingPost1: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultXhtjBaseStatisticsVO>(
        `/app/tjfx2/baseDataStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetIsHzbAuthUsingPost1
     * @summary 判断是否有河长办(流域/镇街)查询权限
     * @request POST:/app/tjfx2/isHzbAuth
     */
    getIsHzbAuthUsingPost1: (query: { userId: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultBoolean>(
        `/app/tjfx2/isHzbAuth${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetLcPieStatisticsUsingPost1
     * @summary 综合概览-里程饼状图
     * @request POST:/app/tjfx2/lcPieStatistics
     */
    getLcPieStatisticsUsingPost1: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsLcPieVo>(
        `/app/tjfx2/lcPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetMarkPieStatisticsUsingPost1
     * @summary 综合概览-打卡统计饼状图
     * @request POST:/app/tjfx2/markPieStatistics
     */
    getMarkPieStatisticsUsingPost1: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsPieVo>(
        `/app/tjfx2/markPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetProblemDataStatisticsUsingPost1
     * @summary 问题统计--数据统计
     * @request POST:/app/tjfx2/problemDataStatistics
     */
    getProblemDataStatisticsUsingPost1: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemDataStatisticsVO>(
        `/app/tjfx2/problemDataStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetProblemReportInfoListUsingPost1
     * @summary 问题统计--问题上报统计清单
     * @request POST:/app/tjfx2/problemReportInfoList
     */
    getProblemReportInfoListUsingPost1: (
      query: ProblemReportInfoListQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListProblemReportDetailVO>(
        `/app/tjfx2/problemReportInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetProblemReportStatisticsUsingPost2
     * @summary 问题统计--问题上报统计
     * @request POST:/app/tjfx2/problemReportStatistics
     */
    getProblemReportStatisticsUsingPost2: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListProblemReportStatisticsVO>(
        `/app/tjfx2/problemReportStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetProblemSubTypeCountStatisticsUsingPost2
     * @summary 问题统计--问题类型饼状图
     * @request POST:/app/tjfx2/problemSubTypeCountStatistics
     */
    getProblemSubTypeCountStatisticsUsingPost2: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/app/tjfx2/problemSubTypeCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetWgyZjDataStatisticsUsingPost1
     * @summary 镇街统计
     * @request POST:/app/tjfx2/wgyZjDataStatistics
     */
    getWgyZjDataStatisticsUsingPost1: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXhtjZjBaseStatisticsVo>(
        `/app/tjfx2/wgyZjDataStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetXhgjUsingPost3
     * @summary 巡河轨迹
     * @request POST:/app/tjfx2/xhgj
     */
    getXhgjUsingPost3: (query: XhgjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXhgjResDto>(`/app/tjfx2/xhgj`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name XhjlUsingPost2
     * @summary 巡河轨迹中个人巡查记录
     * @request POST:/app/tjfx2/xhgj/xhjl
     */
    xhjlUsingPost2: (query: XhtjBaseStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListGridXcRecordReportDto>(
        `/app/tjfx2/xhgj/xhjl`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name ZdjgdUsingPost2
     * @summary 巡河轨迹中重点监管点信息
     * @request POST:/app/tjfx2/xhgj/zdjgd
     */
    zdjgdUsingPost2: (query: XhgjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZdjcdInfoDto>(`/app/tjfx2/xhgj/zdjgd`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetZjOrLyDetailSelectUsingPost2
     * @summary 镇街/流域 详情下拉框
     * @request POST:/app/tjfx2/zjOrLyDetailSelect
     */
    getZjOrLyDetailSelectUsingPost2: (
      query: ZjOrLyDetailQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDropBoxDto>(
        `/app/tjfx2/zjOrLyDetailSelect`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“统计分析”接口
     * @name GetZjOrLySelectUsingPost2
     * @summary 镇街/流域 统计下拉框
     * @request POST:/app/tjfx2/zjOrLySelect
     */
    getZjOrLySelectUsingPost2: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/app/tjfx2/zjOrLySelect`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name CheckZjUsingGet
     * @summary 是否有重点监测点修改入口
     * @request GET:/app/xc/checkZj
     */
    checkZjUsingGet: (query?: { loginUserId?: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultBoolean>(
        `/app/xc/checkZj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name JhxcjlUsingGet
     * @summary 计划巡查记录
     * @request GET:/app/xc/jhxcjl
     */
    jhxcjlUsingGet: (
      query: {
        begin?: string
        end?: string
        isTmp?: boolean
        jhId: number
        keyword?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXcjlDto>(
        `/app/xc/jhxcjl${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name MyxcjlUsingGet
     * @summary 我的巡查记录
     * @request GET:/app/xc/myxcjl
     */
    myxcjlUsingGet: (
      query?: {
        begin?: string
        end?: string
        isTmp?: boolean
        keyword?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXcjlDto>(
        `/app/xc/myxcjl${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name RealReportUsingPost1
     * @summary 坐标实时上报
     * @request POST:/app/xc/realReport
     */
    realReportUsingPost1: (
      query: {
        id: number
        jd?: string
        locationType?: number
        reportTime?: string
        wd?: string
        zrrUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPunchCardVO>(
        `/app/xc/realReport${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name XcxclbUsingGet
     * @summary 现场巡查列表
     * @request GET:/app/xc/xcxclb
     */
    xcxclbUsingGet: (
      query?: { keyword?: string; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXcListDto>(
        `/app/xc/xcxclb${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name GetMbItemPrintUsingGet
     * @summary 获取用户所在的监管点
     * @request GET:/app/xc/xh/MbItemPrint
     */
    getMbItemPrintUsingGet: (
      query?: { loginUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHzxxMbItemPrint>(
        `/app/xc/xh/MbItemPrint${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name CheckOverPunchCardUsingGet
     * @summary 打卡状态检查
     * @request GET:/app/xc/xh/checkOverPunchCard
     */
    checkOverPunchCardUsingGet: (
      query: { itemDetailId: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultString>(
        `/app/xc/xh/checkOverPunchCard${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name XhOverUsingPost
     * @summary 结束巡河
     * @request POST:/app/xc/xh/over
     */
    xhOverUsingPost: (
      xhOverDto: XhOverDto,
      query?: { zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultXhGjInfoDto>(
        `/app/xc/xh/over${this.addQueryParams(query)}`,
        'POST',
        xhOverDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name PunchCardUsingPost1
     * @summary 重点监测点打卡
     * @request POST:/app/xc/xh/punchCard
     */
    punchCardUsingPost1: (punchCardPost: PunchCardPost, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(`/app/xc/xh/punchCard`, 'POST', punchCardPost, cancelToken),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name XhStartUsingPost
     * @summary 开始巡河
     * @request POST:/app/xc/xh/start
     */
    xhStartUsingPost: (
      query?: { isTmp?: boolean; itemId?: number; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultMapStringInt>(
        `/app/xc/xh/start${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name XhStatusUsingPost
     * @summary 巡河状态/巡查轨迹
     * @request POST:/app/xc/xh/status
     */
    xhStatusUsingPost: (
      query?: { detailId?: number; isTmp?: boolean; itemId?: number; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultXhGjInfoDto>(
        `/app/xc/xh/status${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name UpdateMbItemPrintUsingPost
     * @summary 修改重点监测点
     * @request POST:/app/xc/xh/updateMbItemPrint
     */
    updateMbItemPrintUsingPost: (dto: MBItemPrintDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(`/app/xc/xh/updateMbItemPrint`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags app端“河道巡查”接口
     * @name XhUploadUsingPost1
     * @summary 巡河附件上传
     * @request POST:/app/xc/xh/upload
     */
    xhUploadUsingPost1: (
      id: string,
      query?: { zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultIndexDto>(
        `/app/xc/xh/upload${this.addQueryParams(query)}`,
        'POST',
        id,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name SaveProgressFormUsingPost1
     * @summary 进度填报
     * @request POST:/app/yhyc/progressForm
     */
    saveProgressFormUsingPost1: (post: ProgressFormPOST, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(`/app/yhyc/progressForm`, 'POST', post, cancelToken),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name GetTaskByIdUsingPost3
     * @summary 单个任务详情
     * @request POST:/app/yhyc/taskById
     */
    getTaskByIdUsingPost3: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTaskDetailDTO>(`/app/yhyc/taskById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name GetTaskListUsingPost3
     * @summary 任务清单
     * @request POST:/app/yhyc/taskList
     */
    getTaskListUsingPost3: (query: TaskListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTaskListVO>(`/app/yhyc/taskList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name GetTaskStatisticsCountUsingPost2
     * @summary 数量统计
     * @request POST:/app/yhyc/taskStatisticsCount
     */
    getTaskStatisticsCountUsingPost2: (query: TaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTargetTaskCountStatisticsVo>(
        `/app/yhyc/taskStatisticsCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name GetTaskProblemSelectUsingPost3
     * @summary 任务清单--类型下拉
     * @request POST:/app/yhyc/taskTypeSelect
     */
    getTaskProblemSelectUsingPost3: (
      query: TaskLevelQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDropBoxDto>(
        `/app/yhyc/taskTypeSelect`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name GetTaskProblemSelectNoAllUsingPost1
     * @summary 任务清单--类型下拉(不含全部)
     * @request POST:/app/yhyc/taskTypeSelectNoAll
     */
    getTaskProblemSelectNoAllUsingPost1: (
      query: TaskLevelQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDropBoxDto>(
        `/app/yhyc/taskTypeSelectNoAll`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端 一河一策接口
     * @name GetTypeStatisticsPieUsingPost2
     * @summary 类型统计 饼状图
     * @request POST:/app/yhyc/typeStatisticsPie
     */
    getTypeStatisticsPieUsingPost2: (query: TaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTypeStatisticsCountDTO>(
        `/app/yhyc/typeStatisticsPie`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“政策法规”接口
     * @name PageUsingPost
     * @summary 政策法规分页列表
     * @request POST:/app/zcfg/page
     */
    pageUsingPost: (dto: ZcfgPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListZcfgPageRespDto>(`/app/zcfg/page`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags app端“镇街考核排名”接口
     * @name GetRankingsDetailUsingGet
     * @summary 镇街考核-查看考核排名详情弹窗
     * @request GET:/app/zjkhpm/getRankingsDetail
     */
    getRankingsDetailUsingGet: (
      query?: { ly?: string; month?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListAssessmentRankingsDto>(
        `/app/zjkhpm/getRankingsDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“镇街考核排名”接口
     * @name GetRankingsFileByMonthUsingGet
     * @summary 镇街考核-根据考核月份获取考核文件url
     * @request GET:/app/zjkhpm/getRankingsFileByMonth
     */
    getRankingsFileByMonthUsingGet: (
      query: { month: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultRankingsFileRespDto>(
        `/app/zjkhpm/getRankingsFileByMonth${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags app端“镇街考核排名”接口
     * @name UploadRankingsFileUsingPost
     * @summary 镇街考核-上传指定月份的考核文件
     * @request POST:/app/zjkhpm/uploadRankingsFile
     */
    uploadRankingsFileUsingPost: (
      query: { month: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultIndexDto>(
        `/app/zjkhpm/uploadRankingsFile${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),
  }
  axyzt = {
    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetAutoSiteMapPointUsingPost1
     * @summary 自动站地图点位
     * @request POST:/axyzt/autoSiteMapPoint
     */
    getAutoSiteMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/axyzt/autoSiteMapPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetYthzdzMonitorDataListUsingPost3
     * @summary 一体化自动站弹窗--监测数据
     * @request POST:/axyzt/autoSiteMonitorDataList
     */
    getYthzdzMonitorDataListUsingPost3: (
      query: AutoSiteFactorMonitorDataQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListMonitorDataListDto>(
        `/axyzt/autoSiteMonitorDataList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetAutoSiteSzskUsingPost3
     * @summary 水质实况
     * @request POST:/axyzt/autoSiteSzsk
     */
    getAutoSiteSzskUsingPost3: (query: AutoSiteSzskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSzHistoryDto>(`/axyzt/autoSiteSzsk`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetAutoSiteSzskSelectUsingPost1
     * @summary 水质实况下拉框
     * @request POST:/axyzt/autoSiteSzskSelect
     */
    getAutoSiteSzskSelectUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/axyzt/autoSiteSzskSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name StatisticsUsingPost1
     * @summary 自动监测统计
     * @request POST:/axyzt/autoWaterAssessment
     */
    statisticsUsingPost1: (query: AutoSiteStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterAssessmentDto>(
        `/axyzt/autoWaterAssessment`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 网格员音视频通话接口
     * @name ChangeStatusUsingPost2
     * @summary 修改状态
     * @request POST:/axyzt/call/changeStatus
     */
    changeStatusUsingPost2: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/axyzt/call/changeStatus`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 网格员音视频通话接口
     * @name CloseUsingPost3
     * @summary 挂断
     * @request POST:/axyzt/call/close
     */
    closeUsingPost3: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/axyzt/call/close`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 网格员音视频通话接口
     * @name CreateUsingPost3
     * @summary 创建用户呼叫状态
     * @request POST:/axyzt/call/create
     */
    createUsingPost3: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/axyzt/call/create`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 网格员音视频通话接口
     * @name GetChannelInfoUsingGet2
     * @summary 获取用户状态
     * @request GET:/axyzt/call/getChannelInfo
     */
    getChannelInfoUsingGet2: (
      query?: { jd?: string; wd?: string; zrrUserId?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultCallInfoDto>(
        `/axyzt/call/getChannelInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 网格员音视频通话接口
     * @name GetIndexUsingGet1
     * @summary 获取用户实时点位
     * @request GET:/axyzt/call/getIndex
     */
    getIndexUsingGet1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTmpIndexDto>(`/axyzt/call/getIndex`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 网格员音视频通话接口
     * @name GetStatusUsingGet3
     * @summary 根据房间号获取房间状态
     * @request GET:/axyzt/call/getStatus
     */
    getStatusUsingGet3: (query: { channelNo: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCallInfoDto>(
        `/axyzt/call/getStatus${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetCyqyByIdUsingPost1
     * @summary 餐饮企业点位弹窗信息
     * @request POST:/axyzt/cyqyById
     */
    getCyqyByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCyqyEntity>(`/axyzt/cyqyById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetCyqyListUsingPost1
     * @summary 餐饮企业列表
     * @request POST:/axyzt/cyqyList
     */
    getCyqyListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCyqyEntity>(`/axyzt/cyqyList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name CyqyMapPointUsingPost1
     * @summary 餐饮企业地图点位
     * @request POST:/axyzt/cyqyMapPoint
     */
    cyqyMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/cyqyMapPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags drop-controller
     * @name GetMapAreaUsingGet1
     * @summary 地图流域
     * @request GET:/axyzt/drop/mapArea
     */
    getMapAreaUsingGet1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/axyzt/drop/mapArea`, 'GET', null, cancelToken),

    /**
     * @description 包含所有流域
     *
     * @tags drop-controller
     * @name MapAreaSelectUsingPost1
     * @summary 地图流域（含河流）
     * @request POST:/axyzt/drop/mapAreaSelect
     */
    mapAreaSelectUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHomeDropSelect>(
        `/axyzt/drop/mapAreaSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags drop-controller
     * @name GetMapCoordUsingGet1
     * @summary 地图图层下拉框
     * @request GET:/axyzt/drop/mapCoord
     */
    getMapCoordUsingGet1: (query?: { type?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/axyzt/drop/mapCoord${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyqyCountStatisticsUsingPost1
     * @summary 工业企业--数量统计
     * @request POST:/axyzt/gyqyCountStatistics
     */
    getGyqyCountStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterPollutionOnlineDto>(
        `/axyzt/gyqyCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyqyDetailUsingPost1
     * @summary 工业企业--弹窗详情
     * @request POST:/axyzt/gyqyDetail
     */
    getGyqyDetailUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyqyInfoPopDto>(`/axyzt/gyqyDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyqyPieStatisticsUsingPost1
     * @summary 工业企业--数量统计(饼状图)
     * @request POST:/axyzt/gyqyPieStatistics
     */
    getGyqyPieStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/axyzt/gyqyPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyqyPointUsingPost1
     * @summary 工业企业--点位坐标
     * @request POST:/axyzt/gyqyPoint
     */
    getGyqyPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/gyqyPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGywryStatisticsUsingGet
     * @summary 工业污染源统计
     * @request GET:/axyzt/gywryStatistics
     */
    getGywryStatisticsUsingGet: (
      query?: { keywords?: string; ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultGywryDto>(
        `/axyzt/gywryStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyyqCountStatisticsUsingPost1
     * @summary 工业园区--数量统计
     * @request POST:/axyzt/gyyqCountStatistics
     */
    getGyyqCountStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyyqInfoCountStatisticsVo>(
        `/axyzt/gyyqCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyyqDetailByIdUsingPost1
     * @summary 工业园区--弹窗详情
     * @request POST:/axyzt/gyyqDetail
     */
    getGyyqDetailByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyyqEntity>(`/axyzt/gyyqDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyyqInventoryUsingPost1
     * @summary 工业园区--园区清单
     * @request POST:/axyzt/gyyqInventory
     */
    getGyyqInventoryUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListGyyqInventoryVo>(
        `/axyzt/gyyqInventory`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetGyyqPointUsingPost1
     * @summary 工业园区--点位坐标
     * @request POST:/axyzt/gyyqPoint
     */
    getGyyqPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/gyyqPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name GetAiListByIdUsingPost1
     * @summary 获取监控摄像头关联的问题列表
     * @request POST:/axyzt/hdsp/aiListById
     */
    getAiListByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListAiListVo>(`/axyzt/hdsp/aiListById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name BoomTypePieStatisticsUsingPost1
     * @summary 报警类型占比分析
     * @request POST:/axyzt/hdsp/boomTypePieStatistics
     */
    boomTypePieStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/axyzt/hdsp/boomTypePieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name GetCameraStreamListByIdUsingPost1
     * @summary 监测设备视频流获取接口(多个返回值兼容枪球一体)
     * @request POST:/axyzt/hdsp/cameraStreamListById
     */
    getCameraStreamListByIdUsingPost1: (
      query: IdStringQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCameraStreamDto>(
        `/axyzt/hdsp/cameraStreamListById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name HdspListUsingPost1
     * @summary 监控站点列表
     * @request POST:/axyzt/hdsp/hdspList
     */
    hdspListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHdspListDto>(`/axyzt/hdsp/hdspList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name HdspStreamByIdsUsingPost1
     * @summary 通过摄像头id集获取视频流地址
     * @request POST:/axyzt/hdsp/hdspStreamByIds
     */
    hdspStreamByIdsUsingPost1: (cameraIds: string[], cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/axyzt/hdsp/hdspStreamByIds`,
        'POST',
        cameraIds,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name HdspTreeUsingPost1
     * @summary 获取轮播视频树
     * @request POST:/axyzt/hdsp/hdspTree
     */
    hdspTreeUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHdspTreeDTO>(`/axyzt/hdsp/hdspTree`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河道视频
     * @name HdspStatisticsDtoJsonResultUsingPost1
     * @summary 数据统计
     * @request POST:/axyzt/hdsp/statistics
     */
    hdspStatisticsDtoJsonResultUsingPost1: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultHdspStatisticsDTO>(
        `/axyzt/hdsp/statistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetMapCoordsUsingGet1
     * @summary 地图点位获取
     * @request GET:/axyzt/mapCoords
     */
    getMapCoordsUsingGet1: (
      query: { keywords?: string; ly?: string; type: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDotMapDto>(
        `/axyzt/mapCoords${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name NmscByIdUsingPost1
     * @summary 农贸市场点位弹窗信息
     * @request POST:/axyzt/nmscById
     */
    nmscByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultNmscEntity>(`/axyzt/nmscById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetNmscListUsingPost1
     * @summary 农贸市场列表
     * @request POST:/axyzt/nmscList
     */
    getNmscListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListNmscEntity>(`/axyzt/nmscList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name NmscMapPointUsingPost1
     * @summary 农贸市场地图点位
     * @request POST:/axyzt/nmscMapPoint
     */
    nmscMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/nmscMapPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name NywryStatisticsUsingGet
     * @summary 农业污染源统计
     * @request GET:/axyzt/nywryStatistics
     */
    nywryStatisticsUsingGet: (query?: { ly?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultNywryDto>(
        `/axyzt/nywryStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetAutoSiteSzskUsingPost2
     * @summary 自动站水质实况
     * @request POST:/axyzt/openHkgk/autoSiteSzsk
     */
    getAutoSiteSzskUsingPost2: (query: AutoSiteSzskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSzHistoryDto>(
        `/axyzt/openHkgk/autoSiteSzsk`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 根据镇街、流域查询
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetDkStatisticsUsingPost1
     * @summary 网格员巡河--获取打卡信息(应、实际 打卡次数)
     * @request POST:/axyzt/openHkgk/dkStatistics
     */
    getDkStatisticsUsingPost1: (query: HzxhPeriodQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultDkStatisticsDTO>(
        `/axyzt/openHkgk/dkStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name HlxxUsingPost1
     * @summary 主要河流一览
     * @request POST:/axyzt/openHkgk/hlxx
     */
    hlxxUsingPost1: (query: BasicStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverInfoDto>(`/axyzt/openHkgk/hlxx`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetHzClickPopInfoUsingPost1
     * @summary 河长点击弹窗
     * @request POST:/axyzt/openHkgk/hzClickPopInfo
     */
    getHzClickPopInfoUsingPost1: (query: HzPopInfoQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverLeaderTreeDto>(
        `/axyzt/openHkgk/hzClickPopInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetHzCountStatisticsUsingPost4
     * @summary 河长分类数量统计
     * @request POST:/axyzt/openHkgk/hzCountStatistics
     */
    getHzCountStatisticsUsingPost4: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLyTotalDetailDto>(
        `/axyzt/openHkgk/hzCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetHzDutyContentUsingPost1
     * @summary 河长职能职责
     * @request POST:/axyzt/openHkgk/hzDutyContent
     */
    getHzDutyContentUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZnzzVO>(
        `/axyzt/openHkgk/hzDutyContent`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetHzPeopleStatisticsUsingPost1
     * @summary 河长组织名录
     * @request POST:/axyzt/openHkgk/hzPeopleStatistics
     */
    getHzPeopleStatisticsUsingPost1: (query: LyAndZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRiverLeaderStatisticsVo>(
        `/axyzt/openHkgk/hzPeopleStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 根据镇街、流域查询
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetLcStatisticsUsingPost1
     * @summary 网格员巡河--获取应巡，实巡里程数 专职网格员
     * @request POST:/axyzt/openHkgk/lcStatistics
     */
    getLcStatisticsUsingPost1: (query: HzxhPeriodQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLcStatisticsDTO>(
        `/axyzt/openHkgk/lcStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name LygkUsingPost1
     * @summary 流域概况
     * @request POST:/axyzt/openHkgk/lygk
     */
    lygkUsingPost1: (query: BasicStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLygkCountStatisticsVo>(
        `/axyzt/openHkgk/lygk`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetProblemByZjStatisticsUsingPost1
     * @summary 巡河问题--镇街处置排名
     * @request POST:/axyzt/openHkgk/problemByZjStatistics
     */
    getProblemByZjStatisticsUsingPost1: (
      query: HzxhPeriodQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemCountClassifiedStatisticsDTO>(
        `/axyzt/openHkgk/problemByZjStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetProblemCountStatisticsUsingPost1
     * @summary 巡河问题--问题数量统计
     * @request POST:/axyzt/openHkgk/problemCountStatistics
     */
    getProblemCountStatisticsUsingPost1: (
      query: HzxhPeriodQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemCountStatisticsDTO>(
        `/axyzt/openHkgk/problemCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name ProblemListUsingPost1
     * @summary 问题列表
     * @request POST:/axyzt/openHkgk/problemList
     */
    problemListUsingPost1: (query: HzxhProblemListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHzddProblemListDto>(
        `/axyzt/openHkgk/problemList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 根据镇街、流域查询
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetProblemReportStatisticsUsingPost3
     * @summary 网格员巡河--上报问题统计
     * @request POST:/axyzt/openHkgk/problemReportStatistics
     */
    getProblemReportStatisticsUsingPost3: (
      query: HzxhPeriodQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemStatisticsDTO>(
        `/axyzt/openHkgk/problemReportStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetProblemSourceStatisticsUsingPost1
     * @summary 巡河问题--问题来源统计
     * @request POST:/axyzt/openHkgk/problemSourceStatistics
     */
    getProblemSourceStatisticsUsingPost1: (
      query: HzxhPeriodQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemCountClassifiedStatisticsDTO>(
        `/axyzt/openHkgk/problemSourceStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetProblemSubTypeCountStatisticsUsingPost3
     * @summary 问题处置情况--二级问题分类(饼状图)
     * @request POST:/axyzt/openHkgk/problemSubTypeCountStatistics
     */
    getProblemSubTypeCountStatisticsUsingPost3: (
      query: HzxhPeriodQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/axyzt/openHkgk/problemSubTypeCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetSgDmYzDatumLineUsingPost1
     * @summary 手工监测(水源地)断面弹窗信息-断面因子基准线
     * @request POST:/axyzt/openHkgk/sgdmyzDatumLine
     */
    getSgDmYzDatumLineUsingPost1: (
      query: DmYzDatumLineQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultDmYzDatumLine>(
        `/axyzt/openHkgk/sgdmyzDatumLine`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetSkDataStatisticsUsingPost1
     * @summary 水库数据统计
     * @request POST:/axyzt/openHkgk/skDataStatistics
     */
    getSkDataStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSkInfoOverviewResDto>(
        `/axyzt/openHkgk/skDataStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetSkInfoByIdUsingPost1
     * @summary 单个水库详情
     * @request POST:/axyzt/openHkgk/skInfoById
     */
    getSkInfoByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSkInfoDto>(`/axyzt/openHkgk/skInfoById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetSkMapPointUsingPost1
     * @summary 地图水库点位
     * @request POST:/axyzt/openHkgk/skMapPoint
     */
    getSkMapPointUsingPost1: (query: LyAndKeywordsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/axyzt/openHkgk/skMapPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetSkSzMonitorUsingPost1
     * @summary 水库水质监测
     * @request POST:/axyzt/openHkgk/skSzMonitor
     */
    getSkSzMonitorUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSkSzMonitorDTO>(
        `/axyzt/openHkgk/skSzMonitor`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetTaskByIdUsingPost4
     * @summary 一河一策--单个任务详情
     * @request POST:/axyzt/openHkgk/taskById
     */
    getTaskByIdUsingPost4: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTaskDetailDTO>(`/axyzt/openHkgk/taskById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetTaskListUsingPost4
     * @summary 一河一策--任务清单
     * @request POST:/axyzt/openHkgk/taskList
     */
    getTaskListUsingPost4: (query: TaskListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTaskListVO>(
        `/axyzt/openHkgk/taskList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetTaskStatisticsCountUsingPost3
     * @summary 一河一策--数量统计
     * @request POST:/axyzt/openHkgk/taskStatisticsCount
     */
    getTaskStatisticsCountUsingPost3: (query: TaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTargetTaskCountStatisticsVo>(
        `/axyzt/openHkgk/taskStatisticsCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetTaskProblemSelectUsingPost4
     * @summary 一河一策--任务清单类型下拉
     * @request POST:/axyzt/openHkgk/taskTypeSelect
     */
    getTaskProblemSelectUsingPost4: (
      query: TaskLevelQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDropBoxDto>(
        `/axyzt/openHkgk/taskTypeSelect`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetTypeStatisticsPieUsingPost3
     * @summary 一河一策--类型统计 饼状图
     * @request POST:/axyzt/openHkgk/typeStatisticsPie
     */
    getTypeStatisticsPieUsingPost3: (query: TaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTypeStatisticsCountDTO>(
        `/axyzt/openHkgk/typeStatisticsPie`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetWgyCountGroupByZjUsingPost1
     * @summary 网格员镇街分布数量统计
     * @request POST:/axyzt/openHkgk/wgyCountGroupByZj
     */
    getWgyCountGroupByZjUsingPost1: (
      query: WgyZjMappingQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyCountByZjDTO>(
        `/axyzt/openHkgk/wgyCountGroupByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetWgyCountStatisticsUsingPost1
     * @summary 网格员数量统计
     * @request POST:/axyzt/openHkgk/wgyCountStatistics
     */
    getWgyCountStatisticsUsingPost1: (query: LyAndZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWgyCountStatisticsVo>(
        `/axyzt/openHkgk/wgyCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetWgyDutyContentUsingPost1
     * @summary 网格员职能职责
     * @request POST:/axyzt/openHkgk/wgyDutyContent
     */
    getWgyDutyContentUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/axyzt/openHkgk/wgyDutyContent`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库长工作专题
     * @name WgyXhCountByZjUsingPost1
     * @summary 网格员巡河--镇街统计信息
     * @request POST:/axyzt/openHkgk/wgyXhCountByZj
     */
    wgyXhCountByZjUsingPost1: (query: HzxhPeriodQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWgyXhCountDto>(
        `/axyzt/openHkgk/wgyXhCountByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 人员所属镇街，应巡实巡打卡情况等
     *
     * @tags 岸线一张图-河库长工作专题
     * @name GetWgyXhInfoStatisticsUsingPost1
     * @summary 网格员巡河--清单统计
     * @request POST:/axyzt/openHkgk/wgyXhInfoStatistics
     */
    getWgyXhInfoStatisticsUsingPost1: (
      query: HzxhPeriodQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhCountInfoDto>(
        `/axyzt/openHkgk/wgyXhInfoStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetYysydGroupByZdlxStatisticsUsingPost1
     * @summary 饮用水源分类统计-数据达标情况
     * @request POST:/axyzt/openHkgk/yysydGroupByZdlxStatistics
     */
    getYysydGroupByZdlxStatisticsUsingPost1: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListYysydGroupByZdlxStatisticsDTO>(
        `/axyzt/openHkgk/yysydGroupByZdlxStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetYysydInfoByIdUsingPost1
     * @summary 单个饮用水源地详情
     * @request POST:/axyzt/openHkgk/yysydInfoById
     */
    getYysydInfoByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultYysMonitorInfoDetailVo>(
        `/axyzt/openHkgk/yysydInfoById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetYysydListUsingPost1
     * @summary 饮用水源地列表
     * @request POST:/axyzt/openHkgk/yysydList
     */
    getYysydListUsingPost1: (query: YysydListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListYysydInfoStatisticsVo>(
        `/axyzt/openHkgk/yysydList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetYysydMapPointUsingPost1
     * @summary 地图饮用水源地点位
     * @request POST:/axyzt/openHkgk/yysydMapPoint
     */
    getYysydMapPointUsingPost1: (
      query: LyAndKeywordsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonPointVo>(
        `/axyzt/openHkgk/yysydMapPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetYysydStatisticsUsingPost1
     * @summary 饮用水源地统计、分类统计
     * @request POST:/axyzt/openHkgk/yysydStatistics
     */
    getYysydStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultYysydCountStatisticsVo>(
        `/axyzt/openHkgk/yysydStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 岸线一张图-河库信息概况专题
     * @name GetYysydZdlxSelectUsingPost1
     * @summary 饮用水源地管控级别下拉框
     * @request POST:/axyzt/openHkgk/yysydZdlxSelect
     */
    getYysydZdlxSelectUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/axyzt/openHkgk/yysydZdlxSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name OtherStatisticsUsingGet
     * @summary 其他污染源统计
     * @request GET:/axyzt/otherStatistics
     */
    otherStatisticsUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/axyzt/otherStatistics`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetPkCountStatisticsGroupByPklxUsingPost1
     * @summary 沿河排口--分类数量统计
     * @request POST:/axyzt/pkCountStatisticsGroupByPklx
     */
    getPkCountStatisticsGroupByPklxUsingPost1: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultYjpkCountStatisticsVO>(
        `/axyzt/pkCountStatisticsGroupByPklx`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetPkTypeSelectUsingPost1
     * @summary 沿河排口类型下拉
     * @request POST:/axyzt/pkTypeSelect
     */
    getPkTypeSelectUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/axyzt/pkTypeSelect`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetXqyzPieStatisticsUsingPost1
     * @summary 畜牧养殖饼状图
     * @request POST:/axyzt/qyzPieStatistics
     */
    getXqyzPieStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/axyzt/qyzPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetScyzByIdUsingPost1
     * @summary 水产养殖点位弹窗
     * @request POST:/axyzt/scyzById
     */
    getScyzByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultScyzDetailDto>(`/axyzt/scyzById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name ScyzDetailUsingGet
     * @summary 水产养殖详情
     * @request GET:/axyzt/scyzDetail
     */
    scyzDetailUsingGet: (query?: { id?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultScyzDetailDto>(
        `/axyzt/scyzDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetScyzListUsingPost1
     * @summary 水产养殖列表
     * @request POST:/axyzt/scyzList
     */
    getScyzListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListScyzDto>(`/axyzt/scyzList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetScyzMapPointUsingPost1
     * @summary 水产养殖地图点位
     * @request POST:/axyzt/scyzMapPoint
     */
    getScyzMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/scyzMapPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetScyzPieStatisticsUsingPost1
     * @summary 水产养殖镇饼状图
     * @request POST:/axyzt/scyzPieStatistics
     */
    getScyzPieStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/axyzt/scyzPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetScyzStatisticsCountGroupByZjUsingPost1
     * @summary 水产养殖镇街统计
     * @request POST:/axyzt/scyzStatisticsCountGroupByZj
     */
    getScyzStatisticsCountGroupByZjUsingPost1: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/axyzt/scyzStatisticsCountGroupByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetSgDmMapPointUsingPost1
     * @summary 手工地图点位
     * @request POST:/axyzt/sgDmMapPoint
     */
    getSgDmMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/sgDmMapPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetSgdmInfoStatisticsUsingPost1
     * @summary 手工断面信息统计
     * @request POST:/axyzt/sgdmInfoStatistics
     */
    getSgdmInfoStatisticsUsingPost1: (
      query: LyAndMonthQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWaterAssessmentSectionInfoResultDto>(
        `/axyzt/sgdmInfoStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetSgdmyzDatumLineUsingPost1
     * @summary 手工断面因子基准线
     * @request POST:/axyzt/sgdmyzDatumLine
     */
    getSgdmyzDatumLineUsingPost1: (
      query: DmYzDatumLineQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultDmYzDatumLine>(`/axyzt/sgdmyzDatumLine`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetSgjcWaterAssessmentUsingPost1
     * @summary 手工监测统计
     * @request POST:/axyzt/sgjcWaterAssessment
     */
    getSgjcWaterAssessmentUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterAssessmentDto>(
        `/axyzt/sgjcWaterAssessment`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetSgjcdmDetailUsingPost1
     * @summary 手工断面弹窗信息
     * @request POST:/axyzt/sgjcdmDetail
     */
    getSgjcdmDetailUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSgDmPopVo>(`/axyzt/sgjcdmDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name DfBasicInfoByIdUsingPost1
     * @summary 通过id查询 堤防工程信息
     * @request POST:/axyzt/syaxzt/dfBasicInfoById
     */
    dfBasicInfoByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultDfBasicDTO>(
        `/axyzt/syaxzt/dfBasicInfoById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetDfBasicInfoListUsingPost1
     * @summary 堤防工程-工程一览
     * @request POST:/axyzt/syaxzt/dfBasicInfoList
     */
    getDfBasicInfoListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDfBasicDTO>(
        `/axyzt/syaxzt/dfBasicInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetDfCountStatisticsUsingPost1
     * @summary 堤防工程-分类数量统计
     * @request POST:/axyzt/syaxzt/dfCountStatistics
     */
    getDfCountStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultDfInfoOverviewResDto>(
        `/axyzt/syaxzt/dfCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name DfMapPointUsingPost1
     * @summary 堤防工程地图点位
     * @request POST:/axyzt/syaxzt/dfMapPoint
     */
    dfMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/axyzt/syaxzt/dfMapPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetGnfqListUsingPost1
     * @summary 功能分区--列表
     * @request POST:/axyzt/syaxzt/gnfqList
     */
    getGnfqListUsingPost1: (query: GnfqQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSgnqListVo>(`/axyzt/syaxzt/gnfqList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetGnfqPieUsingPost1
     * @summary 功能分区--饼状图
     * @request POST:/axyzt/syaxzt/gnfqPie
     */
    getGnfqPieUsingPost1: (query: GnfqQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSgnqPieVo>(`/axyzt/syaxzt/gnfqPie`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetGnfqStatisticsCountGroupByLevelUsingPost1
     * @summary 功能分区--分级别统计总数长度
     * @request POST:/axyzt/syaxzt/gnfqStatisticsCountGroupByLevel
     */
    getGnfqStatisticsCountGroupByLevelUsingPost1: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSgnqCountByLevelVo>(
        `/axyzt/syaxzt/gnfqStatisticsCountGroupByLevel`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetSzBasicInfoListUsingPost1
     * @summary 水闸闸坝一览
     * @request POST:/axyzt/syaxzt/szBasicInfoList
     */
    getSzBasicInfoListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSzInfoDto>(
        `/axyzt/syaxzt/szBasicInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetSzCountStatisticsUsingPost1
     * @summary 水闸闸坝工程-信息概览（类别数量统计）
     * @request POST:/axyzt/syaxzt/szCountStatistics
     */
    getSzCountStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSzInfoOverviewResDto>(
        `/axyzt/syaxzt/szCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name SzInfoByIdUsingPost1
     * @summary 通过id查询 水闸闸坝信息
     * @request POST:/axyzt/syaxzt/szInfoById
     */
    szInfoByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSzInfoDto>(`/axyzt/syaxzt/szInfoById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name SzMapPointUsingPost1
     * @summary 水闸闸坝地图点位
     * @request POST:/axyzt/syaxzt/szMapPoint
     */
    szMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/axyzt/syaxzt/szMapPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域岸线专题
     * @name GetYdtsInfoListUsingPost1
     * @summary 引调提水工程-列表
     * @request POST:/axyzt/syaxzt/ydtsInfoList
     */
    getYdtsInfoListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListYdTsBasicDTO>(
        `/axyzt/syaxzt/ydtsInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetQskCountStatisticsUsingPost1
     * @summary 数据统计（取水口）
     * @request POST:/axyzt/szyzt/qskCountStatistics
     */
    getQskCountStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultQskInfoListDTO>(
        `/axyzt/szyzt/qskCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name QskInfoBasicUsingPost1
     * @summary 取水口-列表
     * @request POST:/axyzt/szyzt/qskInfoBasic
     */
    qskInfoBasicUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListQskInfoDto>(
        `/axyzt/szyzt/qskInfoBasic`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetQskPointUsingPost1
     * @summary 取水口 点位接口
     * @request POST:/axyzt/szyzt/qskPoint
     */
    getQskPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListQskInfoDto>(`/axyzt/szyzt/qskPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetSwSiteStandardLineUsingPost1
     * @summary 水文监测-基准线
     * @request POST:/axyzt/szyzt/swSiteStandardLine
     */
    getSwSiteStandardLineUsingPost1: (
      query: SwSiteStandardLineQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSwSiteStandardLineVo>(
        `/axyzt/szyzt/swSiteStandardLine`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetSwslSssjUsingPost1
     * @summary 实时数据
     * @request POST:/axyzt/szyzt/swenzSsjc
     */
    getSwslSssjUsingPost1: (query: LyAndTypeAndMonthQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSwslSsjcDto>(`/axyzt/szyzt/swenzSsjc`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetSwslPointByTypeUsingPost1
     * @summary 水文水利 点位接口(不含取水口)
     * @request POST:/axyzt/szyzt/swslPointByType
     */
    getSwslPointByTypeUsingPost1: (
      query: LyAndSzyTypeQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonPointVo>(
        `/axyzt/szyzt/swslPointByType`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetSwSiteDetailAndGraphUsingPost1
     * @summary 获取点位基础信息(水文、水位、雨量)
     * @request POST:/axyzt/szyzt/swslSiteBaseInfo
     */
    getSwSiteDetailAndGraphUsingPost1: (
      query: SwSiteDetailAndGraphQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSwslSiteInfo>(
        `/axyzt/szyzt/swslSiteBaseInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetSzyCountStatisticsByTypeUsingPost1
     * @summary 数据统计（水文，水位，水利）
     * @request POST:/axyzt/szyzt/szyCountStatisticsByType
     */
    getSzyCountStatisticsByTypeUsingPost1: (
      query: LyAndSzyTypeQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSzySiteCountStatisticsDTO>(
        `/axyzt/szyzt/szyCountStatisticsByType`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源专题
     * @name GetSzyztDataStatisticsUsingGet
     * @summary 数据统计
     * @request GET:/axyzt/szyzt/szyztDataStatistics
     */
    getSzyztDataStatisticsUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSwslZdtjDto>(
        `/axyzt/szyzt/szyztDataStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name WaterOfClassificationByLastDataUsingGet
     * @summary 沿程水质最新数据
     * @request GET:/axyzt/waterOfClassificationByLastData
     */
    waterOfClassificationByLastDataUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultYcszStatistics>(
        `/axyzt/waterOfClassificationByLastData${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 无人机巡河专题
     * @name GetWrjFlyDetailByIdUsingPost1
     * @summary 无人机飞行详情数据
     * @request POST:/axyzt/wrjFlyDetail
     */
    getWrjFlyDetailByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWrjFlightRecordDto>(`/axyzt/wrjFlyDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 无人机巡河专题
     * @name GetWrjFlyRecordUsingPost1
     * @summary 飞行记录
     * @request POST:/axyzt/wrjFlyRecord
     */
    getWrjFlyRecordUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWrjFlyRecordDTO>(
        `/axyzt/wrjFlyRecord`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 无人机巡河专题
     * @name GetWrjFlyStatisticsUsingPost1
     * @summary 数据统计
     * @request POST:/axyzt/wrjFlyStatistics
     */
    getWrjFlyStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWrjFLyStatisticsDTO>(
        `/axyzt/wrjFlyStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 无人机巡河专题
     * @name GetWrjStatisticsUsingGet
     * @summary 数据统计
     * @request GET:/axyzt/wrjStatistics
     */
    getWrjStatisticsUsingGet: (
      query?: { ly?: string; pageNum?: number; pageSize?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWrjStatisticsDto>(
        `/axyzt/wrjStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetWsPkListUsingPost1
     * @summary 沿河排口--列表清单
     * @request POST:/axyzt/wsPkList
     */
    getWsPkListUsingPost1: (query: LyAndPkLxQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListPkListVo>(`/axyzt/wsPkList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetWsclcCountStatisticsUsingPost1
     * @summary 污水处理厂--总数统计
     * @request POST:/axyzt/wsclcCountStatistics
     */
    getWsclcCountStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterPollutionOnlineDto>(
        `/axyzt/wsclcCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name WsclcDetailInfoUsingPost1
     * @summary 污水处理厂--弹窗信息（需先获取排口）
     * @request POST:/axyzt/wsclcDetail
     */
    wsclcDetailInfoUsingPost1: (
      query: WsclcDetailPopQuery,
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultWsclcDetailDto>(`/axyzt/wsclcDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name WsclcDetailInfoUsingGet
     * @summary 污水处理厂详情
     * @request GET:/axyzt/wsclcDetailInfo
     */
    wsclcDetailInfoUsingGet: (
      query?: { outPutCode?: string; psCode?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWsclcDetailDto>(
        `/axyzt/wsclcDetailInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetWsclcGraphListUsingPost3
     * @summary 污水处理厂--监测数据折线图
     * @request POST:/axyzt/wsclcGraphList
     */
    getWsclcGraphListUsingPost3: (query: WsclcGraphQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcGraphDto>(
        `/axyzt/wsclcGraphList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name WsclcOutPutListUsingPost3
     * @summary 污水处理厂--获取排口列表
     * @request POST:/axyzt/wsclcOutPutList
     */
    wsclcOutPutListUsingPost3: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcInfoItemsDto>(
        `/axyzt/wsclcOutPutList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetWsclcPfGmStatisticsUsingPost1
     * @summary 污水处理厂--污水处理厂排放规模统计
     * @request POST:/axyzt/wsclcPfGmStatistics
     */
    getWsclcPfGmStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountUnitDto>(
        `/axyzt/wsclcPfGmStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetWsclcRealTimeDataUsingPost1
     * @summary 污水处理厂--污染源排放实时监测（带表头）
     * @request POST:/axyzt/wsclcRealTimeData
     */
    getWsclcRealTimeDataUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZdgyqyLastDataDto>(
        `/axyzt/wsclcRealTimeData`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name WsclcStatisticsClickPointUsingPost3
     * @summary 污水处理厂--获取点位
     * @request POST:/axyzt/wsclcStatisticsClickPoint
     */
    wsclcStatisticsClickPointUsingPost3: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListJSONObject>(
        `/axyzt/wsclcStatisticsClickPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name XmyzDetailUsingGet
     * @summary 畜牧养殖详情
     * @request GET:/axyzt/xmyzDetail
     */
    xmyzDetailUsingGet: (query?: { id?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXmyzDetailDto>(
        `/axyzt/xmyzDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetXqyzByIdUsingPost1
     * @summary 畜牧养殖点位弹窗
     * @request POST:/axyzt/xqyzById
     */
    getXqyzByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXmyzDetailDto>(`/axyzt/xqyzById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetXqyzListUsingPost1
     * @summary 畜牧养殖列表
     * @request POST:/axyzt/xqyzList
     */
    getXqyzListUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXqyzDto>(`/axyzt/xqyzList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetXqyzMapPointUsingPost1
     * @summary 畜牧养殖地图点位
     * @request POST:/axyzt/xqyzMapPoint
     */
    getXqyzMapPointUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(`/axyzt/xqyzMapPoint`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetXqyzStatisticsCountGroupByZjUsingPost1
     * @summary 畜牧养殖镇街统计
     * @request POST:/axyzt/xqyzPieStatistics
     */
    getXqyzStatisticsCountGroupByZjUsingPost1: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/axyzt/xqyzPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境专题
     * @name GetYthzdzDetailWithMnUsingPost3
     * @summary 一体化自动站弹窗信息
     * @request POST:/axyzt/ythzdzDetail
     */
    getYthzdzDetailWithMnUsingPost3: (
      query: IdStringQuery,
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultSzDetailDto>(`/axyzt/ythzdzDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 水域污染源专题
     * @name GetZdGyqyLastDatasUsingPost1
     * @summary 工业企业--实时监测数据2
     * @request POST:/axyzt/zdGyqyLastDatas
     */
    getZdGyqyLastDatasUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZdgyqyLastDataDto>(
        `/axyzt/zdGyqyLastDatas`,
        'POST',
        query,
        cancelToken
      ),
  }
  common = {
    /**
     * No description
     *
     * @tags 公用接口
     * @name GetAreaTreeUsingGet
     * @summary 获取行政区划
     * @request GET:/common/getAreaTree
     */
    getAreaTreeUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/common/getAreaTree`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 公用接口
     * @name GetMapAreaUsingPost1
     * @summary 地图流域
     * @request POST:/common/mapArea
     */
    getMapAreaUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/common/mapArea`, 'POST', null, cancelToken),
  }
  grid = {
    /**
     * No description
     *
     * @tags 网格接口
     * @name GetGridInfoUsingGet
     * @summary 网格基础信息查询
     * @request GET:/grid/baseInfo
     */
    getGridInfoUsingGet: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGridInfo>(
        `/grid/baseInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 网格接口
     * @name DeleteWgyYxMbUsingPost
     * @summary 对网格员应巡模板进行删除
     * @request POST:/grid/deleteWgyYxMb
     */
    deleteWgyYxMbUsingPost: (ids: number[], cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/grid/deleteWgyYxMb`, 'POST', ids, cancelToken),

    /**
     * No description
     *
     * @tags 网格接口
     * @name SaveWgyYxMbUsingPost
     * @summary 对网格员应巡模板进行编辑
     * @request POST:/grid/saveWgyYxMb
     */
    saveWgyYxMbUsingPost: (dto: WgyYxMbDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/grid/saveWgyYxMb`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 网格接口
     * @name GetWgyWgXhGjUsingGet
     * @summary 网格对应网格员巡河轨迹
     * @request GET:/grid/wgyWgXhGj
     */
    getWgyWgXhGjUsingGet: (
      query: { id: number; period: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListString>(
        `/grid/wgyWgXhGj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 网格接口
     * @name GetWgyXhTrackRecordUsingGet
     * @summary 网格员巡河轨迹记录
     * @request GET:/grid/wgyXhTrackRecord
     */
    getWgyXhTrackRecordUsingGet: (
      query: { period: string; userId: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListSceenWgyXhRecordDto>(
        `/grid/wgyXhTrackRecord${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 网格接口
     * @name WgyYxMbUsingPost
     * @summary 单个网格员应巡模板
     * @request POST:/grid/wgyYxMb
     */
    wgyYxMbUsingPost: (idDto: IdDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWgyYxMbDto>(`/grid/wgyYxMb`, 'POST', idDto, cancelToken),

    /**
     * No description
     *
     * @tags 网格接口
     * @name WgyYxMbListUsingPost
     * @summary 网格员应巡模板查询
     * @request POST:/grid/wgyYxMbList
     */
    wgyYxMbListUsingPost: (reqDto: WgyYxMbReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListWgyYxMbDto>(`/grid/wgyYxMbList`, 'POST', reqDto, cancelToken),
  }
  help = {
    /**
     * No description
     *
     * @tags 帮助
     * @name CalcXhlcUsingPost
     * @summary 重新计算巡河距离
     * @request POST:/help/calcXhlc
     */
    calcXhlcUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/help/calcXhlc`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 帮助
     * @name PushTaskUsingPost
     * @summary 执行任务重发（当天）
     * @request POST:/help/pushTask
     */
    pushTaskUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/help/pushTask`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 帮助
     * @name GetXhgjUsingPost4
     * @summary 导出指定时间巡河轨迹(固定格式)
     * @request POST:/help/xhgj
     */
    getXhgjUsingPost4: (query: XhGjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<any>(`/help/xhgj`, 'POST', query, cancelToken),
  }
  jh = {
    /**
     * No description
     *
     * @tags 计划接口
     * @name DeleteUsingPost1
     * @summary 删除计划
     * @request POST:/jh/delete
     */
    deleteUsingPost1: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(
        `/jh/delete${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetHzUsingGet
     * @summary 获取河长级别列表
     * @request GET:/jh/getHz
     */
    getHzUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(`/jh/getHz`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetJhlbUsingGet
     * @summary 获取计划类别
     * @request GET:/jh/getJhlb
     */
    getJhlbUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/jh/getJhlb`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetJhpcUsingGet
     * @summary 获取频次
     * @request GET:/jh/getJhpc
     */
    getJhpcUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/jh/getJhpc`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetLyUsingGet
     * @summary 获取流域-调用成功接口
     * @request GET:/jh/getLy
     */
    getLyUsingGet: (query?: { name?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/jh/getLy${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetMbHlUsingGet
     * @summary 获取模板河流
     * @request GET:/jh/getMbHl
     */
    getMbHlUsingGet: (
      query?: { ly?: string; mbId?: string; name?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListString>(
        `/jh/getMbHl${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetMbLyUsingGet
     * @summary 获取模板流域
     * @request GET:/jh/getMbLy
     */
    getMbLyUsingGet: (
      query?: { mbId?: string; name?: string; xcfw?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListString>(
        `/jh/getMbLy${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetOperatorUsingGet
     * @summary 获取操作符号
     * @request GET:/jh/getOperator
     */
    getOperatorUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/jh/getOperator`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GethlUsingGet
     * @summary 获取河流-外部接口
     * @request GET:/jh/gethl
     */
    gethlUsingGet: (
      query?: { ly?: string; name?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHlApiDto>(
        `/jh/gethl${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name GetxcfwUsingGet
     * @summary 获取巡查范围
     * @request GET:/jh/getxcfw
     */
    getxcfwUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXcfwDto>(`/jh/getxcfw`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name PageUsingGet
     * @summary 计划分页列表
     * @request GET:/jh/page
     */
    pageUsingGet: (
      query?: {
        jhlx?: number
        jhmc?: string
        jhzt?: number
        page?: number
        size?: number
        testUserId?: number
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPageListJhPageDto>(
        `/jh/page${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name PublishUsingPost
     * @summary 发布计划(新增/编辑)
     * @request POST:/jh/publish
     */
    publishUsingPost: (dto: JhSaveDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/jh/publish`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name PublishListUsingPost
     * @summary 发布计划-位于计划列表
     * @request POST:/jh/publish/list
     */
    publishListUsingPost: (query: { jhId: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(
        `/jh/publish/list${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 计划接口
     * @name InsertUsingPost
     * @summary 保存计划(新增/编辑)
     * @request POST:/jh/save
     */
    insertUsingPost: (dto: JhSaveDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/jh/save`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name StatusChangeUsingPost
     * @summary 启用/停用
     * @request POST:/jh/statusChange
     */
    statusChangeUsingPost: (dto: JhStatusChangeDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/jh/statusChange`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 计划接口
     * @name InfoUsingGet
     * @summary 计划详情
     * @request GET:/jh/{id}
     */
    infoUsingGet: (id: number, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultJhSaveDto>(`/jh/${id}`, 'GET', null, cancelToken),
  }
  mb = {
    /**
     * No description
     *
     * @tags 模板接口
     * @name AreaItemUsingGet
     * @summary 行政区划
     * @request GET:/mb/item/area
     */
    areaItemUsingGet: (query?: { keyword?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTreeDto>(
        `/mb/item/area${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name ExportUsingGet
     * @summary 模板分项导出
     * @request GET:/mb/item/export
     */
    exportUsingGet: (
      query: {
        cjs?: string
        dd?: string
        hzmc?: string
        lyhl?: string
        mbId: string
        qdmc?: string
        wgbh?: string
        xcfw?: string
        zdmc?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<any>(`/mb/item/export${this.addQueryParams(query)}`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name GetHlUsingGet
     * @summary 获取河流-下拉
     * @request GET:/mb/item/hl
     */
    getHlUsingGet: (
      query?: { ly?: string; name?: string; zj?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHlApiDto>(
        `/mb/item/hl${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name ImportExcelUsingPost
     * @summary 导入
     * @request POST:/mb/item/import
     */
    importExcelUsingPost: (
      query: { mbId: string },
      excel: File,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResult>(
        `/mb/item/import${this.addQueryParams(query)}`,
        'POST',
        excel,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name InfoItemUsingGet
     * @summary 模板分项详情
     * @request GET:/mb/item/info/{itemId}
     */
    infoItemUsingGet: (itemId: number, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultMbItemSaveDto>(`/mb/item/info/${itemId}`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name InsertItemUsingPost
     * @summary 新增模板分项
     * @request POST:/mb/item/insert
     */
    insertItemUsingPost: (dto: MbItemSaveDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/mb/item/insert`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name GetLyUsingGet1
     * @summary 获取流域-下拉
     * @request GET:/mb/item/ly
     */
    getLyUsingGet1: (query?: { name?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/mb/item/ly${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name PageUsingGet1
     * @summary 模板分项分页列表
     * @request GET:/mb/item/page
     */
    pageUsingGet1: (
      query: {
        cjs?: string
        dd?: string
        hzmc?: string
        lyhl?: string
        mbId: string
        page?: number
        qdmc?: string
        size?: number
        wgbh?: string
        xcfw?: string
        zdmc?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPageListMbItemPageDto>(
        `/mb/item/page${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name RiverItemUsingGet
     * @summary 流域河段
     * @request GET:/mb/item/river
     */
    riverItemUsingGet: (query?: { keyword?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTreeDto>(
        `/mb/item/river${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name UpdateItemUsingPost
     * @summary 编辑模板分项
     * @request POST:/mb/item/update
     */
    updateItemUsingPost: (dto: MbItemSaveDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/mb/item/update`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name GetZdjgdlbUsingGet
     * @summary 获取重点监管点类别-下拉
     * @request GET:/mb/item/zdjgdlb
     */
    getZdjgdlbUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(`/mb/item/zdjgdlb`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name GetZdjgdmcUsingGet
     * @summary 获取重点监管点名称-下拉
     * @request GET:/mb/item/zdjgdmc
     */
    getZdjgdmcUsingGet: (query?: { zdjgdlb?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/mb/item/zdjgdmc${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name GetZjUsingGet
     * @summary 获取镇街-下拉
     * @request GET:/mb/item/zj
     */
    getZjUsingGet: (
      query?: { ssly?: string; zjmc?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListString>(
        `/mb/item/zj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name DeleteItemUsingPost
     * @summary 模板分项删除
     * @request POST:/mb/mb/deleteItem
     */
    deleteItemUsingPost: (query: { itemId: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(
        `/mb/mb/deleteItem${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 模板接口
     * @name EditLxUsingPost
     * @summary 编辑巡河路线坐标
     * @request POST:/mb/mb/editLx
     */
    editLxUsingPost: (dto: EditLxDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/mb/mb/editLx`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name ListMbUsingGet
     * @summary 获取模板列表
     * @request GET:/mb/mb/list
     */
    listMbUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMbDto>(`/mb/mb/list`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 模板接口
     * @name LxUsingGet
     * @summary 单个路线坐标
     * @request GET:/mb/mb/lx
     */
    lxUsingGet: (query: { itemId: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEditLxDto>(
        `/mb/mb/lx${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
  }
  monitorVideoTerminal = {
    /**
     * No description
     *
     * @tags 视频智能分析终端表
     * @name AddUsingPost1
     * @summary 新增视频智能分析终端
     * @request POST:/monitorVideoTerminal/add
     */
    addUsingPost1: (dto: MonitorVideoTerminalReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultMonitorVideoTerminalDto>(
        `/monitorVideoTerminal/add`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 视频智能分析终端表
     * @name DeleteUsingPost2
     * @summary 删除视频智能分析终端
     * @request POST:/monitorVideoTerminal/delete/{id}
     */
    deleteUsingPost2: (id: number, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/monitorVideoTerminal/delete/${id}`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 视频智能分析终端表
     * @name ListUsingPost
     * @summary 分页查询
     * @request POST:/monitorVideoTerminal/list
     */
    listUsingPost: (dto: MonitorVideoTerminalListDTO, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListMonitorVideoTerminalDto>(
        `/monitorVideoTerminal/list`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 视频智能分析终端表
     * @name UpdateUsingPost1
     * @summary 更新视频智能分析终端
     * @request POST:/monitorVideoTerminal/update
     */
    updateUsingPost1: (dto: MonitorVideoTerminalReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultMonitorVideoTerminalDto>(
        `/monitorVideoTerminal/update`,
        'POST',
        dto,
        cancelToken
      ),
  }
  myDesk = {
    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetAreaHkgkUsingPost1
     * @summary 区域概况--河库概况
     * @request POST:/myDesk/area/hkgk
     */
    getAreaHkgkUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListAreaHkgkDto>(`/myDesk/area/hkgk`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetAreaShjzlUsingPost1
     * @summary 区域概况--水环境质量
     * @request POST:/myDesk/area/shjzl
     */
    getAreaShjzlUsingPost1: (query: ShjzlQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterAssessmentDto>(`/myDesk/area/shjzl`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetAreaSwrUsingPost1
     * @summary 区域概况--水污染
     * @request POST:/myDesk/area/swr
     */
    getAreaSwrUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSwrDto>(`/myDesk/area/swr`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetSyaxUsingPost1
     * @summary 水域岸线
     * @request POST:/myDesk/area/syax
     */
    getSyaxUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSyaxExDto>(`/myDesk/area/syax`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetAreaSzyUsingPost1
     * @summary 区域概况--水资源
     * @request POST:/myDesk/area/szy
     */
    getAreaSzyUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListAreaHkgkDto>(`/myDesk/area/szy`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name AutoMapPointUsingPost1
     * @summary 自动站地图点位
     * @request POST:/myDesk/autoMapPoint
     */
    autoMapPointUsingPost1: (reqDTO: MapPointReqDTO, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/myDesk/autoMapPoint`,
        'POST',
        reqDTO,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetYthzdzDetailWithMnUsingPost2
     * @summary 自动站弹窗基础信息
     * @request POST:/myDesk/autoSiteInfo
     */
    getYthzdzDetailWithMnUsingPost2: (
      reqDTO: AutoSiteInfoReqDTO,
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultSzDetailDto>(`/myDesk/autoSiteInfo`, 'POST', reqDTO, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetYthzdzMonitorDataListUsingPost2
     * @summary 自动站弹窗--监测数据
     * @request POST:/myDesk/autoSiteMonitorData
     */
    getYthzdzMonitorDataListUsingPost2: (
      reqDTO: AutoSiteMonitorDataReqDTO,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListMonitorDataListDto>(
        `/myDesk/autoSiteMonitorData`,
        'POST',
        reqDTO,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name ConfirmNoticeUsingPost1
     * @summary 通知公告已读，打开详情后即可已读
     * @request POST:/myDesk/confirmNotice
     */
    confirmNoticeUsingPost1: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(`/myDesk/confirmNotice`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetRankingsListUsingPost1
     * @summary 镇街考核-获取考核排名列表
     * @request POST:/myDesk/getRankingsList
     */
    getRankingsListUsingPost1: (query: LyAndMonthQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRankingsListDtos>(
        `/myDesk/getRankingsList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetGyqyInfoUsingPost1
     * @summary 工业企业点位详情
     * @request POST:/myDesk/gyqyInfo
     */
    getGyqyInfoUsingPost1: (reqDTO: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyqyInfoPopDto>(`/myDesk/gyqyInfo`, 'POST', reqDTO, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetGyqyMapPointUsingPost1
     * @summary 工业企业地图点位
     * @request POST:/myDesk/gyqyMapPoint
     */
    getGyqyMapPointUsingPost1: (reqDTO: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/myDesk/gyqyMapPoint`,
        'POST',
        reqDTO,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetLyTotalDetailUsingPost1
     * @summary 河长体系
     * @request POST:/myDesk/lyTotalDetail
     */
    getLyTotalDetailUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLyTotalDetailDto>(`/myDesk/lyTotalDetail`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetMyBacklogUsingPost1
     * @summary 我的待办
     * @request POST:/myDesk/my/backlog
     */
    getMyBacklogUsingPost1: (query: MyBacklogReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListEventListDto>(
        `/myDesk/my/backlog`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetMyPatrolUsingPost1
     * @summary 我的巡查
     * @request POST:/myDesk/my/patrol
     */
    getMyPatrolUsingPost1: (dto: MyPatrolReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultMyPatrolDto>(`/myDesk/my/patrol`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name NoticeInfoUsingPost1
     * @summary 通知公告详情
     * @request POST:/myDesk/noticeInfo
     */
    noticeInfoUsingPost1: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultNoticeContentInfoDto>(
        `/myDesk/noticeInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name NoticePageUsingPost1
     * @summary 通知公告列表
     * @request POST:/myDesk/noticePage
     */
    noticePageUsingPost1: (query: PageQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListNoticeContentListDto>(
        `/myDesk/noticePage`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetOneRiverOnePlanStatisticsUsingPost1
     * @summary 一河一策任务完成情况
     * @request POST:/myDesk/oneRiverOnePlanStatistics
     */
    getOneRiverOnePlanStatisticsUsingPost1: (
      query: LyAndYearQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultOneRiverOnePlanStatisticsVo>(
        `/myDesk/oneRiverOnePlanStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetOnlineWgyItemInfoUsingPost1
     * @summary 获取在巡网格员的网格基础信息，以及实时轨迹
     * @request POST:/myDesk/onlineWgyItemInfo
     */
    getOnlineWgyItemInfoUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListOnlineWgyItemInfoDto>(
        `/myDesk/onlineWgyItemInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetPmTimeUsingPost1
     * @summary 镇街考核-获取考核排名最新时间
     * @request POST:/myDesk/pmTime
     */
    getPmTimeUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRankingTimesDto>(`/myDesk/pmTime`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetWsclcGraphListUsingPost2
     * @summary 污水处理厂--监测数据折线图
     * @request POST:/myDesk/wsclcGraphList
     */
    getWsclcGraphListUsingPost2: (query: WsclcGraphQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcGraphDto>(
        `/myDesk/wsclcGraphList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name WsclcInfoUsingPost1
     * @summary 污水处理厂--弹窗信息（需先获取排口）
     * @request POST:/myDesk/wsclcInfo
     */
    wsclcInfoUsingPost1: (query: WsclcDetailPopQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWsclcDetailDto>(`/myDesk/wsclcInfo`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name WsclcStatisticsClickPointUsingPost2
     * @summary 污水处理厂地图点位
     * @request POST:/myDesk/wsclcMapPoint
     */
    wsclcStatisticsClickPointUsingPost2: (reqDTO: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListJSONObject>(`/myDesk/wsclcMapPoint`, 'POST', reqDTO, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name WsclcOutPutListUsingPost2
     * @summary 获取污水处理厂排污口列表
     * @request POST:/myDesk/wsclcOutPutList
     */
    wsclcOutPutListUsingPost2: (reqDTO: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcInfoItemsDto>(
        `/myDesk/wsclcOutPutList`,
        'POST',
        reqDTO,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name WtDetailUsingPost1
     * @summary 问题详情
     * @request POST:/myDesk/wtDetail
     */
    wtDetailUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(`/myDesk/wtDetail`, 'POST', query, cancelToken),

    /**
     * @description 查询时间范围内的所有坐标点
     *
     * @tags 我的工作台
     * @name WtIndexUsingPost1
     * @summary 问题分布上报热力图
     * @request POST:/myDesk/wtIndex
     */
    wtIndexUsingPost1: (dto: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHzddProblemListDto>(`/myDesk/wtIndex`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 我的工作台
     * @name GetXhwtStatisticsUsingPost1
     * @summary 问题处置情况
     * @request POST:/myDesk/xhwtStatistics
     */
    getXhwtStatisticsUsingPost1: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXhProblemStatisticsVo>(
        `/myDesk/xhwtStatistics`,
        'POST',
        query,
        cancelToken
      ),
  }
  openapi = {
    /**
     * No description
     *
     * @tags 开放接口
     * @name ChangeStatusUsingPost1
     * @summary 修改状态
     * @request POST:/openapi/call/changeStatus
     */
    changeStatusUsingPost1: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/openapi/call/changeStatus`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 开放接口
     * @name CloseUsingPost2
     * @summary 挂断
     * @request POST:/openapi/call/close
     */
    closeUsingPost2: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/openapi/call/close`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 开放接口
     * @name CreateUsingPost2
     * @summary 创建用户呼叫状态
     * @request POST:/openapi/call/create
     */
    createUsingPost2: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/openapi/call/create`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 开放接口
     * @name GetChannelInfoUsingGet1
     * @summary 获取用户状态
     * @request GET:/openapi/call/getChannelInfo
     */
    getChannelInfoUsingGet1: (
      query?: { jd?: string; wd?: string; zrrUserId?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultCallInfoDto>(
        `/openapi/call/getChannelInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 开放接口
     * @name GetIndexUsingGet
     * @summary 获取用户实时点位
     * @request GET:/openapi/call/getIndex
     */
    getIndexUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTmpIndexDto>(`/openapi/call/getIndex`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 开放接口
     * @name GetStatusUsingGet2
     * @summary 根据房间号获取房间状态
     * @request GET:/openapi/call/getStatus
     */
    getStatusUsingGet2: (query: { channelNo: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCallInfoDto>(
        `/openapi/call/getStatus${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 定时任务执行接口
     * @name ReplaceUsingPost
     * @summary 巡河任务发布
     * @request POST:/openapi/schedule/task-publishing
     */
    replaceUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<any>(`/openapi/schedule/task-publishing`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 开放接口
     * @name XcjlDetailUsingPost
     * @summary 巡查记录详情
     * @request POST:/openapi/xcjlDetail
     */
    xcjlDetailUsingPost: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXcjlInfoDto>(`/openapi/xcjlDetail`, 'POST', query, cancelToken),

    /**
     * @description 原始记录
     *
     * @tags 开放接口
     * @name XhTaskInfoUsingPost
     * @summary 网格员巡河记录接口
     * @request POST:/openapi/xhRecordInfo
     */
    xhTaskInfoUsingPost: (reqDto: XhRecordInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListXhRecordInfoRespDto>(
        `/openapi/xhRecordInfo`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * @description 原始记录
     *
     * @tags 开放接口
     * @name XhTaskInfoUsingPost1
     * @summary 网格员巡河任务接口
     * @request POST:/openapi/xhTaskInfo
     */
    xhTaskInfoUsingPost1: (reqDto: XhTaskInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListXhTaskInfoRespDto>(
        `/openapi/xhTaskInfo`,
        'POST',
        reqDto,
        cancelToken
      ),
  }
  pc = {
    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name ExportUsingPost2
     * @summary 导出
     * @request POST:/pc/tjfx/export
     */
    exportUsingPost2: (query: XhtjBaseStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<any>(`/pc/tjfx/export`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name HzjbUsingGet
     * @summary 河长级别下拉
     * @request GET:/pc/tjfx/hzjb
     */
    hzjbUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/pc/tjfx/hzjb`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name LyhdUsingGet
     * @summary 流域河段
     * @request GET:/pc/tjfx/lyhd
     */
    lyhdUsingGet: (
      query: { flag: string; keyword?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListLyhdDto>(
        `/pc/tjfx/lyhd${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name LysUsingGet
     * @summary 流域下拉
     * @request GET:/pc/tjfx/lys
     */
    lysUsingGet: (query: { flag: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringObject>(
        `/pc/tjfx/lys${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name GetWgyDataStatisticsAnalyseUsingPost1
     * @summary 智能统计分析报表
     * @request POST:/pc/tjfx/wgyDataStatisticsAnalyse
     */
    getWgyDataStatisticsAnalyseUsingPost1: (
      query: XhtjBaseStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXhtjZjBaseStatisticsVo>(
        `/pc/tjfx/wgyDataStatisticsAnalyse`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name WgyTableUsingPost1
     * @summary 网格员清单
     * @request POST:/pc/tjfx/wgyTable
     */
    wgyTableUsingPost1: (dto: WgyTableReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWgyTableRespDto>(`/pc/tjfx/wgyTable`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name WtsbqkTableUsingPost1
     * @summary 问题上报情况清单
     * @request POST:/pc/tjfx/wtsbqkTable
     */
    wtsbqkTableUsingPost1: (dto: WtsbqkTableReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWtsbqkTableRespDto>(
        `/pc/tjfx/wtsbqkTable`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name XcfwUsingGet1
     * @summary 巡查范围下拉
     * @request GET:/pc/tjfx/xcfw
     */
    xcfwUsingGet1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXcfwDto>(`/pc/tjfx/xcfw`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name GetXhgjUsingPost5
     * @summary 巡河轨迹
     * @request POST:/pc/tjfx/xhgj
     */
    getXhgjUsingPost5: (query: XhgjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXhgjResDto>(`/pc/tjfx/xhgj`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name GetProblemPointUsingPost1
     * @summary 巡河轨迹问题点位
     * @request POST:/pc/tjfx/xhgj/problem
     */
    getProblemPointUsingPost1: (query: XhgjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListProblemPointVO>(
        `/pc/tjfx/xhgj/problem`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name XhjlUsingPost3
     * @summary 巡河轨迹中个人巡查记录
     * @request POST:/pc/tjfx/xhgj/xhjl
     */
    xhjlUsingPost3: (query: XhtjBaseStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListGridXcRecordReportDto>(
        `/pc/tjfx/xhgj/xhjl`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name ZdjgdUsingPost3
     * @summary 巡河轨迹中重点监管点信息
     * @request POST:/pc/tjfx/xhgj/zdjgd
     */
    zdjgdUsingPost3: (query: XhgjReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZdjcdInfoDto>(`/pc/tjfx/xhgj/zdjgd`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name XhtjUsingGet1
     * @summary 巡河统计
     * @request GET:/pc/tjfx/xhtj
     */
    xhtjUsingGet1: (
      query: {
        begin?: string
        end?: string
        flag: string
        hl?: string
        hzjb?: string
        hzmc?: string
        ly?: string
        tag: string
        xcfw?: string
        zjcjs?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPcXhtjDto>(
        `/pc/tjfx/xhtj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name XzqhUsingGet
     * @summary 行政区划
     * @request GET:/pc/tjfx/xzqh
     */
    xzqhUsingGet: (
      query: { flag: string; keyword?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListMapStringObject>(
        `/pc/tjfx/xzqh${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 行政区划全区巡河统计，点击表格中的网格员数量时调用，获取对应网格员信息
     *
     * @tags PC端“统计分析”接口
     * @name GetWgyTableQqUsingGet
     * @summary 点击网格员数量获取网格员表格(行政区划全区)
     * @request GET:/pc/tjfx/xzqh/qq/wgyTable
     */
    getWgyTableQqUsingGet: (
      query: { begin?: string; end?: string; ly: string; zj: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyTableDto>(
        `/pc/tjfx/xzqh/qq/wgyTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 行政区划全区巡河统计，点击上报问题总数获取对应得问题信息
     *
     * @tags PC端“统计分析”接口
     * @name WtTableQqUsingGet
     * @summary 点击上报问题总数获取对应得问题信息(行政区划全区)
     * @request GET:/pc/tjfx/xzqh/qq/wtTable
     */
    wtTableQqUsingGet: (
      query: { begin?: string; column?: string; end?: string; ly: string; zj: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWtTableDto>(
        `/pc/tjfx/xzqh/qq/wtTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 行政区划全区巡河统计，点击未完成巡河人数量获取未完成巡河人名单
     *
     * @tags PC端“统计分析”接口
     * @name GetWwcxhrTableQqUsingGet
     * @summary 点击未完成巡河人数量获取未完成巡河人名单(行政区划全区)
     * @request GET:/pc/tjfx/xzqh/qq/wwcxhrTable
     */
    getWwcxhrTableQqUsingGet: (
      query: { begin?: string; end?: string; ly: string; zj: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWwcxhrTableDto>(
        `/pc/tjfx/xzqh/qq/wwcxhrTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 行政区划指定镇街村居社巡河统计，点击实巡数量获取用户巡河记录
     *
     * @tags PC端“统计分析”接口
     * @name GetSxTableZjcjsUsingGet
     * @summary 点击实巡数量获取用户巡河记录(行政区划指定镇街村居社)
     * @request GET:/pc/tjfx/xzqh/zjcjs/sxTable
     */
    getSxTableZjcjsUsingGet: (
      query: {
        begin?: string
        end?: string
        hzUserId: number
        ly?: string
        xcfw?: string
        zjcjs: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListSxTableDto>(
        `/pc/tjfx/xzqh/zjcjs/sxTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 行政区划指定镇街村居社巡河统计，点击上报问题总数获取对应得问题信息
     *
     * @tags PC端“统计分析”接口
     * @name WtTableZjcjsUsingGet
     * @summary 点击上报问题总数获取对应得问题信息(行政区划指定镇街村居社)
     * @request GET:/pc/tjfx/xzqh/zjcjs/wtTable
     */
    wtTableZjcjsUsingGet: (
      query: {
        begin?: string
        column: string
        end?: string
        hzUserId: number
        ly?: string
        xcfw?: string
        zjcjs: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWtTableDto>(
        `/pc/tjfx/xzqh/zjcjs/wtTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 行政区划指定镇街村居社巡河统计，点击责任河段数量获取责任河段清单
     *
     * @tags PC端“统计分析”接口
     * @name GetZrhdTableZjcjsUsingGet
     * @summary 点击责任河段数量获取责任河段清单(行政区划指定镇街村居社)
     * @request GET:/pc/tjfx/xzqh/zjcjs/zrhdTable
     */
    getZrhdTableZjcjsUsingGet: (
      query: {
        begin?: string
        end?: string
        hzUserId: number
        ly?: string
        xcfw?: string
        zjcjs: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListZrhdTableDto>(
        `/pc/tjfx/xzqh/zjcjs/zrhdTable${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name ZdpkTableUsingPost1
     * @summary 重点排口清单
     * @request POST:/pc/tjfx/zdpkTable
     */
    zdpkTableUsingPost1: (dto: ZdpkTableReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZdpkTableRespDto>(`/pc/tjfx/zdpkTable`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags PC端“统计分析”接口
     * @name ZjsUsingGet
     * @summary 镇街下拉
     * @request GET:/pc/tjfx/zjs
     */
    zjsUsingGet: (query: { flag: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringObject>(
        `/pc/tjfx/zjs${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
  }
  ref = {
    /**
     * No description
     *
     * @tags 下拉接口
     * @name LyUsingPost
     * @summary 流域下拉（所有）
     * @request POST:/ref/ly
     */
    lyUsingPost: (dto: RiverZjDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListKeyValue>(`/ref/ly`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 下拉接口
     * @name RiverUsingPost
     * @summary 河流下拉（所有）
     * @request POST:/ref/river
     */
    riverUsingPost: (dto: RiverZjDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListKeyValue>(`/ref/river`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 下拉接口
     * @name ZjUsingPost
     * @summary 镇街下拉（所有）
     * @request POST:/ref/zj
     */
    zjUsingPost: (dto: RiverZjDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListKeyValue>(`/ref/zj`, 'POST', dto, cancelToken),
  }
  screen = {
    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name CountWgyXhPrintUsingPost
     * @summary 网格员巡河重点监管点统计信息
     * @request POST:/screen/zhihuihezhang/countWgyXhPrint
     */
    countWgyXhPrintUsingPost: (
      query: WgyXhStatisticsInfoQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyDkCountDto>(
        `/screen/zhihuihezhang/countWgyXhPrint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 根据镇街、流域查询
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetDkStatisticsUsingPost2
     * @summary 获取打卡信息(应、实际 打卡次数)
     * @request POST:/screen/zhihuihezhang/dkStatistics
     */
    getDkStatisticsUsingPost2: (query: XhDKStatisticQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultDkStatisticsDTO>(
        `/screen/zhihuihezhang/dkStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetIndexUsingGet3
     * @summary 获取网格员实时点位
     * @request GET:/screen/zhihuihezhang/getIndex
     */
    getIndexUsingGet3: (
      query?: { ly?: string; name?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXhIndexDto>(
        `/screen/zhihuihezhang/getIndex${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetRealGjUsingGet
     * @summary 获取网格员巡查记录的实时轨迹(全信息)
     * @request GET:/screen/zhihuihezhang/getRealGj
     */
    getRealGjUsingGet: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXhGjInfoDto>(
        `/screen/zhihuihezhang/getRealGj${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetRealGj1UsingGet
     * @summary 获取网格员巡查记录的实时轨迹(只有轨迹)
     * @request GET:/screen/zhihuihezhang/getRealGj1
     */
    getRealGj1UsingGet: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultObject>(
        `/screen/zhihuihezhang/getRealGj1${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyWtIndexUsingGet
     * @summary 网格员问题点位分布
     * @request GET:/screen/zhihuihezhang/getWgyWtIndex
     */
    getWgyWtIndexUsingGet: (
      query: { begin: string; end: string; ly?: string; model: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyWtIndexDto>(
        `/screen/zhihuihezhang/getWgyWtIndex${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyXhInfoListUsingGet
     * @summary 网格员巡检统计
     * @request GET:/screen/zhihuihezhang/getWgyXhInfoList
     */
    getWgyXhInfoListUsingGet: (
      query: { begin: string; cached?: boolean; end: string; ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultHzgzXctjDto>(
        `/screen/zhihuihezhang/getWgyXhInfoList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetXhStatisticsRateWithZjUsingPost
     * @summary 获取镇街打卡完成率和问题处置率
     * @request POST:/screen/zhihuihezhang/getXhDoubleWithZj
     */
    getXhStatisticsRateWithZjUsingPost: (
      reqDto: XhStatisticsRateWithZjReqDto,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListXhStatisticsRateWithZjDto>(
        `/screen/zhihuihezhang/getXhDoubleWithZj`,
        'POST',
        reqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetGridXcRecordBaseInfoDtoUsingPost
     * @summary 查询网格员任务网格基础信息
     * @request POST:/screen/zhihuihezhang/gridXcRecordBaseInfoDto
     */
    getGridXcRecordBaseInfoDtoUsingPost: (dto: IdDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGridXcRecordBaseInfoDto>(
        `/screen/zhihuihezhang/gridXcRecordBaseInfoDto`,
        'POST',
        dto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetGridXcRecordDtoUsingPost
     * @summary 查询网格员巡查记录
     * @request POST:/screen/zhihuihezhang/gridXcRecordDto
     */
    getGridXcRecordDtoUsingPost: (
      query: GridWgyRecordQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultGridXcRecordDto>(
        `/screen/zhihuihezhang/gridXcRecordDto`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name InfoUsingGet2
     * @summary 网格员巡查记录详情
     * @request GET:/screen/zhihuihezhang/info
     */
    infoUsingGet2: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXcjlInfoDto>(
        `/screen/zhihuihezhang/info${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 根据镇街、流域查询
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetLcStatisticsUsingPost2
     * @summary 获取应巡，实巡里程数 专职网格员
     * @request POST:/screen/zhihuihezhang/lcStatistics
     */
    getLcStatisticsUsingPost2: (query: XhDKStatisticQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLcStatisticsDTO>(
        `/screen/zhihuihezhang/lcStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetOnlineWgyItemInfoUsingGet
     * @summary 获取在巡网格员的网格基础信息，以及实时轨迹
     * @request GET:/screen/zhihuihezhang/onlineWgyItemInfo
     */
    getOnlineWgyItemInfoUsingGet: (
      query?: { ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListOnlineWgyItemInfoDto>(
        `/screen/zhihuihezhang/onlineWgyItemInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * @description 根据镇街、流域查询
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetProblemReportStatisticsUsingPost4
     * @summary 巡河上报问题统计
     * @request POST:/screen/zhihuihezhang/problemReportStatistics
     */
    getProblemReportStatisticsUsingPost4: (
      query: XhDKStatisticQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemStatisticsDTO>(
        `/screen/zhihuihezhang/problemReportStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyUnXhInfoStatisticsDtoUsingPost
     * @summary 网格员未巡河信息统计
     * @request POST:/screen/zhihuihezhang/wgyUnXhInfoStatisticsDto
     */
    getWgyUnXhInfoStatisticsDtoUsingPost: (
      query: WgyXhStatisticsInfoQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhInfoStatisticsDto>(
        `/screen/zhihuihezhang/wgyUnXhInfoStatisticsDto`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyWtInfoUsingGet
     * @summary 网格员问题详情(含处理流程)
     * @request GET:/screen/zhihuihezhang/wgyWtInfo
     */
    wgyWtInfoUsingGet: (query: { id: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(
        `/screen/zhihuihezhang/wgyWtInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyWtRecordUsingGet
     * @summary 网格员问题上报记录
     * @request GET:/screen/zhihuihezhang/wgyWtRecord
     */
    getWgyWtRecordUsingGet: (
      query: { begin: string; end: string; ly?: string; wtlb?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyWtRecordDto>(
        `/screen/zhihuihezhang/wgyWtRecord${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyWtczUsingGet
     * @summary 网格员问题处置
     * @request GET:/screen/zhihuihezhang/wgyWtcz
     */
    wgyWtczUsingGet: (
      query: { begin: string; end: string; ly?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyWtczDto>(
        `/screen/zhihuihezhang/wgyWtcz${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyWwcxhListUsingGet
     * @summary 网格员未完成巡河列表接口
     * @request GET:/screen/zhihuihezhang/wgyWwcxhList
     */
    wgyWwcxhListUsingGet: (
      query: { ly?: string; month: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyWwcxhListDto>(
        `/screen/zhihuihezhang/wgyWwcxhList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyXhUsingGet
     * @summary 网格员巡河
     * @request GET:/screen/zhihuihezhang/wgyXh
     */
    wgyXhUsingGet: (
      query: { ly?: string; month: string; xcfw?: string; zj?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSceenWgyXhDto>(
        `/screen/zhihuihezhang/wgyXh${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyXhCountByZjUsingPost2
     * @summary 网格员巡河镇街统计信息
     * @request POST:/screen/zhihuihezhang/wgyXhCountByZj
     */
    wgyXhCountByZjUsingPost2: (
      query: WgyXhStatisticsInfoQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhCountDto>(
        `/screen/zhihuihezhang/wgyXhCountByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 根据镇街查询，不支持模糊名称
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyXhGridByZjUsingPost
     * @summary 获取镇街的网格员和巡逻信息
     * @request POST:/screen/zhihuihezhang/wgyXhGridByZj
     */
    getWgyXhGridByZjUsingPost: (query: ZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWgyXhGridByZjDto>(
        `/screen/zhihuihezhang/wgyXhGridByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 根据镇街查询实巡、应巡数以及占比
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyXhGroupByZjUsingPost
     * @summary 网格员镇街巡查情况统计
     * @request POST:/screen/zhihuihezhang/wgyXhGroupByZj
     */
    getWgyXhGroupByZjUsingPost: (
      query: WgyXhStatisticsInfoQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhGroupByZjDto>(
        `/screen/zhihuihezhang/wgyXhGroupByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyXhInfoUsingPost
     * @summary 网格员--巡河未完成清单
     * @request POST:/screen/zhihuihezhang/wgyXhInfo
     */
    wgyXhInfoUsingPost: (query: WgyXhStatisticsInfoQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWgyXhCountInfoDto>(
        `/screen/zhihuihezhang/wgyXhInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 人员所属镇街，应巡实巡打卡情况等
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyXhInfoStatisticsUsingPost2
     * @summary 网格员巡河清单统计
     * @request POST:/screen/zhihuihezhang/wgyXhInfoStatistics
     */
    getWgyXhInfoStatisticsUsingPost2: (
      query: XhDKStatisticQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhCountInfoDto>(
        `/screen/zhihuihezhang/wgyXhInfoStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WgyXhRecordUsingGet
     * @summary 网格员巡河记录
     * @request GET:/screen/zhihuihezhang/wgyXhRecord
     */
    wgyXhRecordUsingGet: (
      query: {
        begin: string
        end: string
        ly?: string
        userId?: number
        xcfw?: string
        zj?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListSceenWgyXhRecordDto>(
        `/screen/zhihuihezhang/wgyXhRecord${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyXhStatisticsInfoUsingPost
     * @summary 网格员巡河统计信息
     * @request POST:/screen/zhihuihezhang/wgyXhStatisticsInfo
     */
    getWgyXhStatisticsInfoUsingPost: (
      query: WgyXhStatisticsInfoQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyXhStatisticsDto>(
        `/screen/zhihuihezhang/wgyXhStatisticsInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 查询时间范围内的所有坐标点
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name GetWgyXhTrackUsingPost
     * @summary 巡河情况热力图
     * @request POST:/screen/zhihuihezhang/wgyXhTrack
     */
    getWgyXhTrackUsingPost: (
      query: WgyXhStatisticsInfoQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListJSONArray>(
        `/screen/zhihuihezhang/wgyXhTrack`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name WtlbUsingGet
     * @summary 问题类别下拉
     * @request GET:/screen/zhihuihezhang/wtlb
     */
    wtlbUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/screen/zhihuihezhang/wtlb`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-网格员巡河
     * @name XcfwUsingGet2
     * @summary 巡查范围下拉
     * @request GET:/screen/zhihuihezhang/xcfw
     */
    xcfwUsingGet2: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/screen/zhihuihezhang/xcfw`, 'GET', null, cancelToken),
  }
  sj = {
    /**
     * @description 事件状态-下拉
     *
     * @tags 上报事件接口
     * @name EventStatusUsingGet
     * @summary 事件状态
     * @request GET:/sj/eventStatus
     */
    eventStatusUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringObject>(`/sj/eventStatus`, 'GET', null, cancelToken),

    /**
     * @description 查询事件类型-下拉
     *
     * @tags 上报事件接口
     * @name EventTypeUsingGet
     * @summary 查询事件类型
     * @request GET:/sj/eventType
     */
    eventTypeUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringObject>(`/sj/eventType`, 'GET', null, cancelToken),

    /**
     * @description 查询事件详情
     *
     * @tags 上报事件接口
     * @name FindByIdUsingGet
     * @summary 事件详情
     * @request GET:/sj/findById
     */
    findByIdUsingGet: (query: { id: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(
        `/sj/findById${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 上报事件接口
     * @name PageUsingGet2
     * @summary 分页查询
     * @request GET:/sj/page
     */
    pageUsingGet2: (
      query: {
        end?: string
        eventName?: string
        level?: number
        page: number
        size: number
        start?: string
        status?: number
        type?: number
        zgcs?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPageListRpcEventInstancePageDto>(
        `/sj/page${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 上报事件接口
     * @name EventReportUsingPost
     * @summary 事件上报
     * @request POST:/sj/report
     */
    eventReportUsingPost: (dto: PcEventReportDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultKeyValue>(`/sj/report`, 'POST', dto, cancelToken),
  }
  upload = {
    /**
     * No description
     *
     * @tags 文件上传接口
     * @name Upload1UsingPost
     * @summary 文件上传接口
     * @request POST:/upload
     */
    upload1UsingPost: (query: { type: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultIndexDto>(
        `/upload${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 文件上传接口
     * @name UploadImageUsingPost
     * @summary 富文本框上传接口
     * @request POST:/upload/image
     */
    uploadImageUsingPost: (query: { type: string }, cancelToken?: CancelToken | undefined) =>
      this.request<Record<string, object>>(
        `/upload/image${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),
  }
  wx = {
    /**
     * No description
     *
     * @tags 微信公众号 巡河
     * @name RealReportUsingPost2
     * @summary 微信公众号坐标实时上报
     * @request POST:/wx/gzh/xh/realReport
     */
    realReportUsingPost2: (post: WxRealReportDTO, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPunchCardVO>(`/wx/gzh/xh/realReport`, 'POST', post, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号 巡河
     * @name XhUploadUsingPost2
     * @summary 微信公众号巡河附件上传
     * @request POST:/wx/gzh/xh/upload
     */
    xhUploadUsingPost2: (post: WxXhAttachmentDTO, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListFileDto>(`/wx/gzh/xh/upload`, 'POST', post, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号 巡河
     * @name PunchCardUsingPost2
     * @summary 微信公众号重点监测点打卡
     * @request POST:/wx/gzh/xh/xh/punchCard
     */
    punchCardUsingPost2: (
      wxPunchCardPost: WxPunchCardPost,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultInt>(`/wx/gzh/xh/xh/punchCard`, 'POST', wxPunchCardPost, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号 巡河
     * @name PostXhProblemReportUsingPost1
     * @summary 巡河问题上报
     * @request POST:/wx/gzh/xh/xhProblemReport
     */
    postXhProblemReportUsingPost1: (
      post: XhProblemReportDTO,
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultString>(`/wx/gzh/xh/xhProblemReport`, 'POST', post, cancelToken),
  }
  wxgzh = {
    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetProblemSubTypeUsingPost1
     * @summary 问题二级分类下拉
     * @request POST:/wxgzh/getProblemSubType
     */
    getProblemSubTypeUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxIntegerDto>(
        `/wxgzh/getProblemSubType`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetGzProblemListByPhoneUsingPost1
     * @summary 公众投诉--问题查询
     * @request POST:/wxgzh/gzProblemListByPhone
     */
    getGzProblemListByPhoneUsingPost1: (query: PhoneQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListGzhProblemDTO>(
        `/wxgzh/gzProblemListByPhone`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetHzListByLevelNameUsingPost3
     * @summary 河长组织-名录（名单）
     * @request POST:/wxgzh/hzListByLevelName
     */
    getHzListByLevelNameUsingPost3: (
      query: HzLevelNameQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHzListVO>(`/wxgzh/hzListByLevelName`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetHzCountStatisticsUsingPost5
     * @summary 河长组织--数据概览
     * @request POST:/wxgzh/hzStatistics
     */
    getHzCountStatisticsUsingPost5: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/wxgzh/hzStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetHzTypeSelectUsingPost3
     * @summary 河长组织-河长类型下拉
     * @request POST:/wxgzh/hzTypeSelect
     */
    getHzTypeSelectUsingPost3: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/wxgzh/hzTypeSelect`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name FindByIdUsingPost1
     * @summary 公众投诉--问题详情
     * @request POST:/wxgzh/problemDetailById
     */
    findByIdUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(
        `/wxgzh/problemDetailById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name PostPublicProblemReportUsingPost1
     * @summary 公众投诉--问题上报
     * @request POST:/wxgzh/publicProblemReport
     */
    postPublicProblemReportUsingPost1: (
      post: PublicProblemReportPOST,
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultString>(`/wxgzh/publicProblemReport`, 'POST', post, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetRiverDetailByIdUsingPost3
     * @summary 河流--河流详情
     * @request POST:/wxgzh/riverDetailById
     */
    getRiverDetailByIdUsingPost3: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRiverDetailDTO>(`/wxgzh/riverDetailById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetRiverLevelUsingPost3
     * @summary 河流--河流等级
     * @request POST:/wxgzh/riverLevel
     */
    getRiverLevelUsingPost3: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/wxgzh/riverLevel`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetRiverListUsingPost3
     * @summary 河流--河流列表
     * @request POST:/wxgzh/riverList
     */
    getRiverListUsingPost3: (query: RiverQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverListDTO>(`/wxgzh/riverList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetSkDetailByIdUsingPost3
     * @summary 湖库--水库详情
     * @request POST:/wxgzh/skDetailById
     */
    getSkDetailByIdUsingPost3: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSkDetailDTO>(`/wxgzh/skDetailById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetSkLevelUsingPost3
     * @summary 湖库--水库等级(规模)
     * @request POST:/wxgzh/skLevel
     */
    getSkLevelUsingPost3: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/wxgzh/skLevel`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetSkListUsingPost3
     * @summary 湖库--水库列表
     * @request POST:/wxgzh/skList
     */
    getSkListUsingPost3: (query: HkListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSkListDTO>(`/wxgzh/skList`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetSmsCodeUsingPost1
     * @summary 公众投诉--短信获取
     * @request POST:/wxgzh/smsCode
     */
    getSmsCodeUsingPost1: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(`/wxgzh/smsCode`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name UploadUsingPost3
     * @summary 微信公众号,文件转存接口
     * @request POST:/wxgzh/upload
     */
    uploadUsingPost3: (mediaList: string[], cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListFileDto>(`/wxgzh/upload`, 'POST', mediaList, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetWgyStatisticsUsingPost3
     * @summary 网格员组织--数据概览
     * @request POST:/wxgzh/wgyStatistics
     */
    getWgyStatisticsUsingPost3: (
      query: WgyStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyCountStatisticsDTO>(
        `/wxgzh/wgyStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetZnzzUsingPost5
     * @summary 网格员组织--职能职责
     * @request POST:/wxgzh/wgyZnzz
     */
    getZnzzUsingPost5: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZnzzVO>(`/wxgzh/wgyZnzz`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetWxAccessTokenUsingPost1
     * @summary 微信公众号accessToken
     * @request POST:/wxgzh/wxGzhAccessToken
     */
    getWxAccessTokenUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(`/wxgzh/wxGzhAccessToken`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetWxGzhTicketUsingPost1
     * @summary 微信公众号ticket
     * @request POST:/wxgzh/wxGzhTicket
     */
    getWxGzhTicketUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(`/wxgzh/wxGzhTicket`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetZjOrLyDetailSelectUsingPost3
     * @summary 镇街/流域 详情下拉框
     * @request POST:/wxgzh/zjOrLyDetailSelect
     */
    getZjOrLyDetailSelectUsingPost3: (
      query: ZjOrLyDetailQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDropBoxDto>(
        `/wxgzh/zjOrLyDetailSelect`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 微信公众号
     * @name GetZjOrLySelectUsingPost3
     * @summary 镇街/流域 统计下拉框
     * @request POST:/wxgzh/zjOrLySelect
     */
    getZjOrLySelectUsingPost3: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/wxgzh/zjOrLySelect`, 'POST', null, cancelToken),
  }
  xcjl = {
    /**
     * No description
     *
     * @tags 巡查记录接口
     * @name ExportUsingGet1
     * @summary 导出巡查记录
     * @request GET:/xcjl/export
     */
    exportUsingGet1: (
      query?: {
        begin?: string
        end?: string
        hzmc?: string
        lyhl?: string
        qdmc?: string
        wgbh?: string
        xcfw?: string
        xzqh?: string
        zdmc?: string
      },
      cancelToken?: CancelToken | undefined
    ) => this.request<any>(`/xcjl/export${this.addQueryParams(query)}`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 巡查记录接口
     * @name HlhdUsingGet
     * @summary 河流河段
     * @request GET:/xcjl/hlhd
     */
    hlhdUsingGet: (query?: { keyword?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTreeDto>(
        `/xcjl/hlhd${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 巡查记录接口
     * @name InfoUsingGet1
     * @summary 巡查记录详情
     * @request GET:/xcjl/info
     */
    infoUsingGet1: (query: { id: number }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXcjlInfoDto>(
        `/xcjl/info${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 巡查记录接口
     * @name PageUsingGet3
     * @summary 巡查记录分页列表
     * @request GET:/xcjl/page
     */
    pageUsingGet3: (
      query?: {
        begin?: string
        end?: string
        hzmc?: string
        lyhl?: string
        page?: number
        qdmc?: string
        size?: number
        testUserId?: number
        wgbh?: string
        xcfw?: string
        xzqh?: string
        zdmc?: string
      },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultPageListXcjlPageDto>(
        `/xcjl/page${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 巡查记录接口
     * @name XzqhUsingGet1
     * @summary 行政区划
     * @request GET:/xcjl/xzqh
     */
    xzqhUsingGet1: (query?: { keyword?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTreeDto>(
        `/xcjl/xzqh${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
  }
  xcx = {
    /**
     * No description
     *
     * @tags 小程序巡查呼叫接口
     * @name ChangeStatusUsingPost3
     * @summary 修改状态
     * @request POST:/xcx/call/changeStatus
     */
    changeStatusUsingPost3: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/xcx/call/changeStatus`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 小程序巡查呼叫接口
     * @name CloseUsingPost4
     * @summary 挂断
     * @request POST:/xcx/call/close
     */
    closeUsingPost4: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/xcx/call/close`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 小程序巡查呼叫接口
     * @name CreateUsingPost4
     * @summary 创建用户呼叫状态
     * @request POST:/xcx/call/create
     */
    createUsingPost4: (dto: CallInfoDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/xcx/call/create`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 小程序巡查呼叫接口
     * @name GetChannelInfoUsingGet3
     * @summary 获取用户状态
     * @request GET:/xcx/call/getChannelInfo
     */
    getChannelInfoUsingGet3: (
      query?: { jd?: string; wd?: string; zrrUserId?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultCallInfoDto>(
        `/xcx/call/getChannelInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 小程序巡查呼叫接口
     * @name GetIndexUsingGet2
     * @summary 获取用户实时点位
     * @request GET:/xcx/call/getIndex
     */
    getIndexUsingGet2: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListTmpIndexDto>(`/xcx/call/getIndex`, 'GET', null, cancelToken),

    /**
     * No description
     *
     * @tags 小程序巡查呼叫接口
     * @name GetStatusUsingGet4
     * @summary 根据房间号获取房间状态
     * @request GET:/xcx/call/getStatus
     */
    getStatusUsingGet4: (query: { channelNo: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCallInfoDto>(
        `/xcx/call/getStatus${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
  }
  xhjlReport = {
    /**
     * No description
     *
     * @tags 巡河记录人工填报
     * @name ReportUsingPost
     * @summary 人工填报巡河记录
     * @request POST:/xhjlReport/report
     */
    reportUsingPost: (reqDto: XhjlReportReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(`/xhjlReport/report`, 'POST', reqDto, cancelToken),

    /**
     * No description
     *
     * @tags 巡河记录人工填报
     * @name XhTaskListUsingGet
     * @summary 根据用户账号获取巡河任务列表接口
     * @request GET:/xhjlReport/xhTaskList
     */
    xhTaskListUsingGet: (query: { loginName: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXhTaskInfoRespDto>(
        `/xhjlReport/xhTaskList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 巡河记录人工填报
     * @name XhTaskPageUsingPost
     * @summary 根据用户账号获取巡河任务分页列表接口
     * @request POST:/xhjlReport/xhTaskPage
     */
    xhTaskPageUsingPost: (reqDto: XhTaskPageReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListXhTaskInfoRespDto>(
        `/xhjlReport/xhTaskPage`,
        'POST',
        reqDto,
        cancelToken
      ),
  }
  yhyc = {
    /**
     * No description
     *
     * @tags 一河一策接口
     * @name AddUsingPost2
     * @summary 任务清单添加，返回ID
     * @request POST:/yhyc/add
     */
    addUsingPost2: (dto: SKeyTaskResolveDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(`/yhyc/add`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name DeleteUsingPost3
     * @summary 任务清单信息删除
     * @request POST:/yhyc/delete
     */
    deleteUsingPost3: (dto: IdDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(`/yhyc/delete`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name GetDepartSelectUsingPost1
     * @summary 任务清单--责任单位下拉
     * @request POST:/yhyc/departSelect
     */
    getDepartSelectUsingPost1: (query: TaskLevelQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/yhyc/departSelect`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name DownloadUsingPost1
     * @summary 下载任务清单信息模板
     * @request POST:/yhyc/download
     */
    downloadUsingPost1: (taskLevelQuery: TaskLevelQuery, cancelToken?: CancelToken | undefined) =>
      this.request<any>(`/yhyc/download`, 'POST', taskLevelQuery, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name ExportUsingPost1
     * @summary 导出任务清单信息
     * @request POST:/yhyc/export
     */
    exportUsingPost1: (dto: TaskListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<any>(`/yhyc/export`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name LyhdUsingPost1
     * @summary 流域河段
     * @request POST:/yhyc/lyhd
     */
    lyhdUsingPost1: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListLyhdDto>(`/yhyc/lyhd`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name GetTaskByIdUsingPost5
     * @summary 单个任务详情
     * @request POST:/yhyc/taskById
     */
    getTaskByIdUsingPost5: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTaskDetailDTO>(`/yhyc/taskById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name GetTaskListUsingPost5
     * @summary 任务清单
     * @request POST:/yhyc/taskList
     */
    getTaskListUsingPost5: (query: TaskListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListSKeyTaskResolveDto>(
        `/yhyc/taskList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name GetTaskProblemSelectUsingPost5
     * @summary 任务清单--类型下拉
     * @request POST:/yhyc/taskTypeSelect
     */
    getTaskProblemSelectUsingPost5: (
      query: TaskLevelQuery,
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultListDropBoxDto>(`/yhyc/taskTypeSelect`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name UpdateUsingPost2
     * @summary 任务清单修改，返回ID
     * @request POST:/yhyc/update
     */
    updateUsingPost2: (dto: SKeyTaskResolveEntity, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(`/yhyc/update`, 'POST', dto, cancelToken),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name UploadUsingPost2
     * @summary 导入任务清单信息
     * @request POST:/yhyc/upload
     */
    uploadUsingPost2: (
      excel: File,
      query?: { taskLevel?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResult>(
        `/yhyc/upload${this.addQueryParams(query)}`,
        'POST',
        excel,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 一河一策接口
     * @name YearSelectUsingPost1
     * @summary 任务清单--任务年份下拉
     * @request POST:/yhyc/yearSelect
     */
    yearSelectUsingPost1: (query: TaskLevelQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(`/yhyc/yearSelect`, 'POST', query, cancelToken),
  }
}
